import React, { useContext, useEffect, useRef, useState } from "react";
import Application from "../../../StateContext/Application.js";
import { apiurl } from "../../../../../path.js";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import "./DemandGenral.css";
import * as exifr from "exifr";
import Select from "react-select";
import { jwtDecode } from "jwt-decode";
import validateFile from "../../../../../utils/fileUploadHelper.js";

const DemandGeneration = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        setData((prev) => ({ ...prev, talulka: decoded.District }));
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  const loginDistrict = userData?.District;

  // department id  ->  head code prefixes that department may use
  // add "1": ["3054"] later if बांधकाम must be restricted too
  const DEPARTMENT_HEADCODE_RULES = { "2": ["2515"] };

  console.log("userData: ", userData);
  const submitLockRef = useRef(false);
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);
  const {
    GetProjectInfo,
    GetBudgetHeadInfo,
    DemandCreation,
    BankMaster,
    getTaxes,
    DeductionOperation,
    GetWorkDetailbyworkID,
    Usermenu,
    GetMyDepartmentAccess,
    GetBillDeductions,
  } = operation;
  const [selectedWorkOrderID, setSelectedWorkOrderID] = useState(null);
  const [selectedWorkDisplayName, setSelectedWorkDisplayName] = useState("");
  const [ulbList, setUlbList] = useState([]);
  const [projectId, setProjectId] = useState([]);
  const [AllData, setALLData] = useState([]);
  const [HeadId, setHeadID] = useState([]);
  const [workID, setWorkID] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filterWorkOrder, setFilterWorkOrder] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [Taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gst, setGst] = useState(0);
  const [tds, setTds] = useState(0);
  const [security, SetSecurity] = useState(0);
  const [totalpaid, SetTotalPaid] = useState(0);
  const [GrossAmount, setGrossAmount] = useState(0);
  const [netPayableAmount, setNetPayableAmount] = useState(0);
  const [TotalEstimateAmount, setTotalEstimateAmount] = useState(0);
  const [RemainingAmount, setRemainingAmount] = useState("0");
  const [TotalReleaseAmountTillDate, setTotalReleaseAmountTillDate] =
    useState(0);
  const [deductionAmount, setDeductionAmount] = useState(0);
  const [deductionList, setDeductionList] = useState([]);
  const [filterdWorkID, setFilteredWorkID] = useState([]);
  const [deductionPercent, setDeductionPercent] = useState("");
  const [selectedDeductionName, setSelectedDeductionName] = useState("");
  const [selectedDeductionID, setSelectedDeductionID] = useState("");
  const [totalDeductionPercent, setTotalDeductionPercent] = useState(0);
  const [totalDeductionAmount, setTotalDeductionAmount] = useState(0);
  const [fetchDeductionData, setFetchDeductionData] = useState([]);
  const [SchemeComponentData, setSchemeComponentData] = useState([]);
  const [editIndexOF, setEditIndexOF] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editAmount, setEditAmount] = useState("");
  const [HeadCode, setHeadCode] = useState([]);
  const [FetchedFData, setFetchedFData] = useState([]);
  const [taluka, setTaluka] = useState([]);
  const [GrnData, setGrnData] = useState([]);
  const [ProposalID, setProposalID] = useState([]);
  const [WorkOrderIDData, setWorkOrderIDData] = useState([]);
  const [WorkOrderAllData, setWorkOrderALLData] = useState([]);
  const [VendorDetail, setVendorDetail] = useState([]);
  const [ShowHead, setShowHead] = useState("Proposal");
  const [TechnicalSanctionUid, setTechnicalSanctionUid] = useState([]);
  const [processedProposalCopy, setProcessedProposalCopy] = useState(null);
  const [fileProcessing, setFileProcessing] = useState(false);
  const [workOrderType, setWorkOrderType] = useState("");
  const total = parseFloat(TotalEstimateAmount || 0);
  const remaining = parseFloat(RemainingAmount || 0);
  const [error, setError] = useState("");
  const [RAbillValue, SetRabillValue] = useState("");
  const [departmentsLoaded, setDepartmentsLoaded] = useState(false);

  // console.log("FetchedFData****: ", FetchedFData);
  const buttonStylePrimary = {
    cursor: "pointer",
    background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
    color: "white",
    border: "none",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    whiteSpace: "nowrap",
  };

  const buttonStyleDanger = {
    cursor: "pointer",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    whiteSpace: "nowrap",
  };

  const [data, setData] = useState({
    DepartmentAccessID: "",
    HeadCode: "",
    ProposalYear: "",
    talulka: "",
    ulb: "",
    GrID: "",
    ProposalId: "",
    WorkUID: "",
    ProjectName: "",
    ProjectID: "",
    BudgetHeadID: "",
    BudgetHeadName: "",
    WorkName: "",
    ContractorName: "",
    ContractorUniqueID: "", // NEW
    BillAmount: "",
    GST: "",
    Royalty: "",
    SQMCharges: "", // ← new
    TotalBillAmount: "",
    RABillAmount: "",
    Remark: "",
    CopyofWorkOrder: "",
    WorkOrderUnique: "",
    type: "true",
    District: "",
    TechnicalSanctionUID: "",
    physicalValue: "",
  });

  const [myDepartments, setMyDepartments] = useState([]);

useEffect(() => {
  (async () => {
    try {
      const r = await GetMyDepartmentAccess();
      const list = r?.data?.departments || [];
      setMyDepartments(list);
      if (list.length === 1) {                       // only one -> automatic
        setData((prev) => ({ ...prev, DepartmentAccessID: list[0].id }));
      }
    } catch (e) {
      console.error("GetMyDepartmentAccess failed", e);
    } finally {
      setDepartmentsLoaded(true);
    }
  })();
}, []);

// head codes visible = login's own head codes  ∩  department rule
const allowedHeadPrefixes = DEPARTMENT_HEADCODE_RULES[String(data.DepartmentAccessID)] || null;
const visibleHeadCodes = !departmentsLoaded
  ? []                                     // wait until the department is known
  : allowedHeadPrefixes
    ? HeadCode.filter((h) =>
        allowedHeadPrefixes.some((p) => String(h.HeadID || "").trim().startsWith(p)),
      )
    : HeadCode;

// ONE effect covers every path: dropdown change, automatic single department, token auto-select
useEffect(() => {
  if (!departmentsLoaded) return;

  // 1) a selected head code that is not allowed any more -> clear it
  if (data.HeadCode && allowedHeadPrefixes &&
      !allowedHeadPrefixes.some((p) => String(data.HeadCode).startsWith(p))) {
    HandleChangeData({ target: { name: "HeadCode", value: "" } });
    return;
  }

  // 2) exactly one head code left -> select it
  if (visibleHeadCodes.length === 1 && data.HeadCode !== visibleHeadCodes[0].HeadID) {
    HandleChangeData({ target: { name: "HeadCode", value: visibleHeadCodes[0].HeadID } });
    FetchDataRelatedtoZilla(visibleHeadCodes[0].HeadID);
  }
}, [departmentsLoaded, data.DepartmentAccessID, HeadCode, data.HeadCode]);

// deductions of the selected department (reloaded whenever the department changes)
useEffect(() => {
  if (!departmentsLoaded) return;

  // several departments and none chosen yet -> nothing to show
  if (myDepartments.length > 1 && !data.DepartmentAccessID) {
    setFetchDeductionData([]);
    setTotalDeductionAmount(0);
    return;
  }

  (async () => {
    try {
      const rows = await GetBillDeductions(data.DepartmentAccessID || null);
      setFetchDeductionData(
        Array.isArray(rows) ? rows.map((r) => ({ ...r, DeductionAmount: 0 })) : [],
      );
      setTotalDeductionAmount(0);
    } catch (e) {
      console.log(e);
      setFetchDeductionData([]);
    }
  })();
}, [departmentsLoaded, data.DepartmentAccessID, myDepartments.length]);

  // ── helper: sums Construction Amount + GST + Royalty (ported from Bill Creation) ──
  const calculateTotal = (bill, gst, royalty, sqmCharges) => {
    const b = parseFloat(bill || 0);
    const g = parseFloat(gst || 0);
    const r = parseFloat(royalty || 0);
    const s = parseFloat(sqmCharges || 0);

    return +(b + g + r + s).toFixed(2);
  };

  const HandleChangeData = (e) => {
    const { name, value } = e.target;

    // Prevent leading space
    if (value.length === 1 && value[0] === " ") return;

    let finalValue = value;
    if (name === "BillAmount") {
      finalValue = value.replace(/[^0-9.]/g, "");
    }

    // 1️⃣ HeadCode changed
    if (name === "HeadCode") {
      setSelectedWorkOrderID(null);
      setSelectedWorkDisplayName("");
      setData((prev) => ({
        ...prev,
        HeadCode: finalValue,
        ProposalYear: "",
        // District: "",
        // talulka: "",
        TechnicalSanctionUID: "",
        GrID: "",
        ProposalId: "",
        WorkUID: "",
        WorkName: "",
        WorkOrderUnique: "",
        physicalValue: "",
        RABillAmount: "",
        Remark: "",
      }));
      setVendorDetail([]);
      setWorkOrderData(null);
      document.getElementById("BillCopy").value = "";
      return;
    }

    // 2️⃣ ProposalYear changed
    if (name === "ProposalYear") {
      setSelectedWorkOrderID(null);
      setSelectedWorkDisplayName("");
      setData((prev) => ({
        ...prev,
        ProposalYear: finalValue,
        // District: "",
        // talulka: "",
        TechnicalSanctionUID: "",
        GrID: "",
        ProposalId: "",
        WorkUID: "",
        WorkName: "",
        WorkOrderUnique: "",
        physicalValue: "",
        RABillAmount: "",
        Remark: "",
      }));
      setVendorDetail([]);
      setWorkOrderData(null);
      document.getElementById("BillCopy").value = "";
      return;
    }

    // 3️⃣ District changed
    if (name === "District") {
      setSelectedWorkOrderID(null);
      setSelectedWorkDisplayName("");
      setData((prev) => ({
        ...prev,
        District: finalValue,
        talulka: "",
        TechnicalSanctionUID: "",
        GrID: "",
        ProposalId: "",
        WorkUID: "",
        WorkOrderUnique: "",
        workName: "",
        physicalValue: "",
        RABillAmount: "",
        Remark: "",
      }));
      setVendorDetail([]);
      setWorkOrderData(null);
      document.getElementById("BillCopy").value = "";
      return;
    }

    // 4️⃣ Taluka changed
    if (name === "talulka") {
      setSelectedWorkOrderID(null);
      setSelectedWorkDisplayName("");
      setData((prev) => ({
        ...prev,
        talulka: finalValue,
        ulb: "",
        TechnicalSanctionUID: "",
        GrID: "",
        ProposalId: "",
        WorkUID: "",
        WorkOrderUnique: "",
        RABillAmount: "",
        Remark: "",
      }));
      setVendorDetail([]);
      setWorkOrderData(null);
      document.getElementById("BillCopy").value = "";
      return;
    }

    // 5️⃣ TechnicalSanctionUID changed
    if (name === "TechnicalSanctionUID") {
      setSelectedWorkOrderID(null);
      setSelectedWorkDisplayName("");
      setData((prev) => ({
        ...prev,
        TechnicalSanctionUID: finalValue,
        GrID: "",
        ProposalId: "",
        WorkUID: "",
        WorkOrderUnique: "",
        RABillAmount: "",
        Remark: "",
      }));
      setVendorDetail([]);
      setWorkOrderData(null);
      document.getElementById("BillCopy").value = "";
      return;
    }

    // 6️⃣ ProposalId changed
    if (name === "ProposalId") {
      setSelectedWorkOrderID(null);
      setSelectedWorkDisplayName("");
      setData((prev) => ({
        ...prev,
        ProposalId: finalValue,
        WorkUID: "",
        WorkOrderUnique: "",
        RABillAmount: "",
        Remark: "",
      }));
      setVendorDetail([]);
      setWorkOrderData(null);
      document.getElementById("BillCopy").value = "";
      return;
    }

    // Default update
    setData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  const getbudget = async () => {
    let data = await BankMaster("get");
    if (data && Array.isArray(data)) {
      setBankData(data);
    } else {
      setBankData([]);
      console.error("Error: Data is not an array or undefined.");
    }
  };

  const GetTaxes = async () => {
    let data = await getTaxes();
    setTaxes(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitLockRef.current) return;
    submitLockRef.current = true;

    if (editIndexOF !== null) {
      alert(
        t(
          "Please save or cancel the current deduction edit before saving the form.",
        ),
      );
      submitLockRef.current = false;
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

  if (!data.BillAmount || Number(data.BillAmount) <= 0) {
  alert("Bill Amount is mandatory and must be greater than 0.");
  document.getElementsByName("BillAmount")[0]?.focus();
  return; // the finally block resets loading and submitLockRef
}

      let TOtalBillamount = parseFloat(GrossAmount || 0);

      if (
        !data.HeadCode ||
        !data.WorkOrderUnique ||
        !data.BillAmount ||
        !data.physicalValue ||
        !data.RABillAmount
      ) {
        alert("You have not entered all required data!");
        submitLockRef.current = false;
        setLoading(false);
        return;
      }

      if (myDepartments.length > 1 && !data.DepartmentAccessID) {
  alert("Please select the Department.");
  submitLockRef.current = false;
  setLoading(false);
  return;
}

      if (parseFloat(data.TotalBillAmount || 0) > remaining) {
        alert(
          "Total Bill Amount must be less than or equal to Remaining Amount.",
        );
        return;
      }

      // if (deductionList.length === 0 || totalDeductionAmount === "") {
      //   alert("Please enter deductions!");
      //   return;
      // }

      // ── deductions taken directly from the fetched deduction table (dynamic, not static) ──
      const finalDeductionList = fetchDeductionData.filter(
        (item) => item.DeductionAmount && item.DeductionAmount > 0,
      );

      const computedDeductionTotal = finalDeductionList.reduce(
        (sum, item) => sum + Number(item.DeductionAmount || 0),
        0,
      );

      const updatedData = {
        ...data,
        BillAmount: TOtalBillamount,
        totalTax: computedDeductionTotal,
        TotalAmountPayToVendor: netPayableAmount,
        ProjectID: data.ProposalId,
        BudgetHeadID: data.HeadCode,
        District: data.talulka,
      };

      const BillCopy = document.getElementById("BillCopy")?.files;
      if (!BillCopy || BillCopy.length === 0) {
        alert("Bill Copy is not uploaded!");
        return;
      }

      const InspectionReport =
        document.getElementById("Inspection_Report")?.files[0];
      const WorkCompletion =
        document.getElementById("Work_completion")?.files[0];
      const MeasurementBook =
        document.getElementById("Measurement_Book")?.files[0];
      const UploadGR = document.getElementById("UploadGR")?.files[0];

      // ── Mandatory documents apply the same way for BOTH Head Codes (3054 & 2515) ──
      if (
        String(data.HeadCode).includes("3054") ||
        String(data.HeadCode).includes("2515")
      ) {
        if (!MeasurementBook) {
          alert("Measurement Book is mandatory.");
          return;
        }

        if (!InspectionReport) {
          alert("Inspection Report is mandatory.");
          return;
        }

        // Work Completion mandatory ONLY for Final RA Bill
        if (data.RABillAmount === "Final" && !WorkCompletion) {
          alert("Work Completion Certificate softcopy is mandatory for Final RA Bill.");
          return;
        }
      }

      if (!UploadGR) {
        alert("Administrative GR Approved copy is mandatory.");
        return;
      }

      const BillCopyFile = document.getElementById("BillCopy")?.files[0];
      const WorkOrderFile =
        document.getElementById("CopyofWorkOrder")?.files[0];

      formData.append("BillCopy", BillCopyFile);
      if (WorkOrderFile) {
        formData.append("CopyofWorkOrder", WorkOrderFile);
      }

      let finalProposalCopy;
      try {
        finalProposalCopy =
          processedProposalCopy || (await processFile(BillCopy[0]));
      } catch {
        alert("Error processing Demand Copy");
        return;
      }

      for (const key in updatedData) {
        formData.append(key, updatedData[key]);
      }

      formData.append("DeductionList", JSON.stringify(finalDeductionList));
      formData.append("SchemeList", JSON.stringify(SchemeComponentData));
      formData.append(
        "remainingLimitAllocationCost",
        parseFloat(TotalEstimateAmount) - TOtalBillamount,
      );
      formData.append(
        "remainingReleaseAmounttillDate",
        parseFloat(TotalReleaseAmountTillDate) + TOtalBillamount,
      );
      formData.append("releasetype", ShowHead);
      formData.append("CopyofWorkOrder", finalProposalCopy);
      formData.append("BillCopy", finalProposalCopy);
      formData.append("WorkOrderID", selectedWorkOrderID || "");

      if (MeasurementBook) formData.append("Measurement_Book", MeasurementBook);
      if (InspectionReport)
        formData.append("Inspection_Report", InspectionReport);
      if (WorkCompletion) formData.append("Work_completion", WorkCompletion);
      if (UploadGR) formData.append("UploadGR", UploadGR);
      if (workOrderType) formData.append("workOrderType", workOrderType);

      const result = await DemandCreation(formData);

      if (result?.message) {
        alert(result.message);
        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else if (result?.error) {
  alert(result.error);
}
    } catch (error) {
      console.error(error);
      alert("Something went wrong while saving.");
    } finally {
      setLoading(false);
      submitLockRef.current = false;
    }
  };

  const FetchData = async () => {
    setLoading(true);
    try {
      let res = await GetProjectInfo("null", "all");
      let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");
  
      setProjectId(res);
  
      // ============================================
      // HEAD CODE FILTERING BASED ON LOGGED USER
      // (decoded directly here — not from `userData` state,
      // to avoid the effect-ordering race condition)
      // ============================================
      let userHeadCodes = [];
      try {
        const token = localStorage.getItem("Token");
        if (token) {
          const decoded = jwtDecode(token);
          let raw = decoded?.HeadCode;
          if (typeof raw === "string") {
            raw = JSON.parse(raw);
          }
          if (Array.isArray(raw)) {
            userHeadCodes = raw
              .filter((c) => c !== null && c !== undefined && String(c).trim() !== "")
              .map((c) => String(c).trim());
          }
        }
      } catch (err) {
        console.error("Error decoding token for HeadCode filter:", err);
        userHeadCodes = [];
      }
  
      console.log("User HeadCodes:", userHeadCodes);
  
      // CASE 1: No restriction -> show all
      if (userHeadCodes.length === 0) {
        console.log("No HeadCode restriction -> Showing ALL HeadCodes");
        setHeadCode(res3 || []);
      } else {
        // CASE 2: Restricted -> show only matching
        const filteredHeadCodes = (res3 || []).filter((h) => {
          const headId = String(h.HeadID || "").trim();
          return userHeadCodes.some((userCode) => headId.startsWith(userCode));
        });
  
        console.log("Filtered HeadCodes:", filteredHeadCodes);
        setHeadCode(filteredHeadCodes);
  
        // Auto-select if only one option available
        if (filteredHeadCodes.length === 1) {
          const selectedHeadCode = filteredHeadCodes[0].HeadID;
          setData((prev) => ({ ...prev, HeadCode: selectedHeadCode }));
          FetchDataRelatedtoZilla(selectedHeadCode);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  //--> old code
  // const FetchData = async () => {
  //   setLoading(true);
  //   try {
  //     let res = await GetProjectInfo("null", "all");
  //     let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");
  //     setProjectId(res);
  //     setHeadCode(res3);
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const PaymentAmountTable = () => {
    const { ProjectID, BudgetHeadID, WorkUID } = data;
    if (!ProjectID || !BudgetHeadID || !WorkUID) {
      alert("You have not selected all three fields! Select them.");
      return;
    }
    let result = AllData?.filter((item) => {
      return (
        item.ProjectID == ProjectID &&
        item.HeadID == BudgetHeadID &&
        item.UniqueID == WorkUID
      );
    });
    let details = result[0];
    setData((prev) => ({
      ...prev,
      ContractorName: details?.ContractorName,
      WorkName: details?.WorKName,
      BudgetHeadName: details?.BudgetHead,
      CopyofWorkOrder: details?.CopyofWorkOrder,
      WorkOrderUnique: details?.WorkOrderID,
    }));
    setTableData(result);
  };

  const FetchInitalData = async () => {
    try {
      let res = await DeductionOperation("null", "fetchalldatafromBank");
      setFetchDeductionData(res);
    } catch (err) {
      console.log(err);
    }
  };

  const FetchTalukaInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "GetTalukas");
      setUlbList(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // FetchInitalData();
    FetchData();
    getbudget();
    GetTaxes();
    FetchTalukaInfo();
  }, []);

  // ✅ NEW — prevent scroll wheel from changing number input values
  useEffect(() => {
    const preventWheel = () => {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };
    window.addEventListener("wheel", preventWheel, { passive: true });
    return () => window.removeEventListener("wheel", preventWheel);
  }, []);

  // ── handle edits to a deduction amount cell, validated against Total Bill Amount (ported from Bill Creation) ──
  const handleDeductionAmountChange = (e, index) => {
    const rawValue = e.target.value;

    if (rawValue === "") {
      const updatedList = [...fetchDeductionData];
      updatedList[index].DeductionAmount = "";
      setFetchDeductionData(updatedList);

      const totalDeduction = updatedList.reduce(
        (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
        0,
      );
      setTotalDeductionAmount(totalDeduction);
      return;
    }

    let value = parseFloat(rawValue);
    const totalBillAmount = parseFloat(data.TotalBillAmount || 0);

    if (value < 0) {
      alert("Deduction Amount should be greater than 0 !");
      return;
    }

    const updatedList = [...fetchDeductionData];
    updatedList[index].DeductionAmount = value;

    const totalDeduction = updatedList.reduce(
      (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
      0,
    );

    if (totalDeduction > totalBillAmount) {
      alert(
        `Total deduction (₹${totalDeduction}) cannot exceed Bill Amount (₹${totalBillAmount})`,
      );
      updatedList[index].DeductionAmount = 0;

      const correctedTotal = updatedList.reduce(
        (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
        0,
      );

      setFetchDeductionData(updatedList);
      setTotalDeductionAmount(correctedTotal);
      return;
    }

    setFetchDeductionData(updatedList);
    setTotalDeductionAmount(totalDeduction);
  };

  // ✅ NEW — revert empty deduction field to 0 on blur
  const handleDeductionAmountBlur = (e, index) => {
    if (e.target.value === "") {
      const updatedList = [...fetchDeductionData];
      updatedList[index].DeductionAmount = 0;
      setFetchDeductionData(updatedList);

      const totalDeduction = updatedList.reduce(
        (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
        0,
      );
      setTotalDeductionAmount(totalDeduction);
    }
  };

  //--> old code
  // const handleDeductionAmountChange = (e, index) => {
  //   let value = parseFloat(e.target.value || 0);
  //   const totalBillAmount = parseFloat(data.TotalBillAmount || 0);

  //   if (value < 0) {
  //     alert("Deduction Amount should be greater than 0 !");
  //     return;
  //   }

  //   const updatedList = [...fetchDeductionData];
  //   updatedList[index].DeductionAmount = value;

  //   const totalDeduction = updatedList.reduce(
  //     (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
  //     0,
  //   );

  //   // ❌ Validation
  //   if (totalDeduction > totalBillAmount) {
  //     alert(
  //       `Total deduction (₹${totalDeduction}) cannot exceed Bill Amount (₹${totalBillAmount})`,
  //     );

  //     // reset current field
  //     updatedList[index].DeductionAmount = 0;

  //     const correctedTotal = updatedList.reduce(
  //       (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
  //       0,
  //     );

  //     setFetchDeductionData(updatedList);
  //     setTotalDeductionAmount(correctedTotal);
  //     return;
  //   }

  //   // ✅ valid case
  //   setFetchDeductionData(updatedList);
  //   setTotalDeductionAmount(totalDeduction);
  // };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      BillAmount: "",
      GST: "",
      Royalty: "",
      SQMCharges: "",      // ← new
      TotalBillAmount: "",
    }));
    setGrossAmount(0);
    setNetPayableAmount(0);
    setTotalDeductionAmount(0);
    setTotalDeductionPercent(0);
    setDeductionList([]);
    setFetchDeductionData((prev) =>
      prev.map((item) => ({ ...item, DeductionAmount: 0 })),
    );
    setProcessedProposalCopy(null);
  }, [
    data.WorkOrderUnique,
    VendorDetail,
    TotalEstimateAmount,
    data.physicalValue,
  ]);

  useEffect(() => {
    if (data.ProjectID && data.BudgetHeadID && data.WorkUID) {
      PaymentAmountTable();
    }
  }, [data.ProjectID, data.BudgetHeadID, data.WorkUID]);

  useEffect(() => {
    if (data.BillAmount) {
      const totalPayment = Number(data.BillAmount);
      const calculatedGst = Math.ceil((totalPayment * 18) / 100);
      const calculatedTds = Math.ceil((totalPayment * 12) / 100);
      const calculatedSecurity = Math.ceil((totalPayment * 2) / 100);
      const totalTax = calculatedGst + calculatedTds + calculatedSecurity;
      const calculatedTotalPaid = totalPayment - totalTax;

      setGst(calculatedGst);
      setTds(calculatedTds);
      SetSecurity(calculatedSecurity);
      SetTotalPaid(calculatedTotalPaid);

      setData((prev) => ({
        ...prev,
        SGST: calculatedGst,
        CGST: calculatedTds,
        SecurityDeposite: calculatedSecurity,
        totalTax: totalTax,
        TotalAmountPayToVendor: netPayableAmount,
      }));
    }
  }, [data.BillAmount]);

  const FetchAllDatafromBackend = async () => {
    try {
      let ProjectID = {
        HeadCode: data.HeadCode,
        ProposalYear: data.ProposalYear,
      };
      let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
      let projectData = res1[0];
      setALLData(res1);
      setData((prev) => ({
        ...prev,
        ProjectName: projectData?.Work_name,
        ProjectID: projectData?.ProposalID,
        District: projectData?.talulka,
      }));
      let AllheadId = res1.map((item) => ({
        HeadID: item.HeadID,
        HeadName: item.HeadName,
      }));
      setHeadID(AllheadId);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.HeadCode) {
      FetchAllDatafromBackend();
    }
  }, [data.HeadCode, data.ProposalYear]);

  // ── Gross / Net Payable now derive from Total Bill Amount (Construction + GST + Royalty) ──
  useEffect(() => {
    const gross = parseFloat(data.TotalBillAmount || 0);
    const totalDeduction = parseFloat(totalDeductionAmount || 0);
    const netPayable = gross - totalDeduction;
    setGrossAmount(parseFloat(gross.toFixed(2)));
    setNetPayableAmount(parseFloat(netPayable.toFixed(2)));
  }, [data.TotalBillAmount, GrossAmount, totalDeductionAmount]);

  // useEffect(() => {
  //   const gross = parseFloat(data.BillAmount || 0);
  //   const totalDeduction = parseFloat(totalDeductionAmount || 0);
  //   const netPayable = gross - totalDeduction;
  //   setGrossAmount(parseFloat(gross.toFixed(2)));
  //   setNetPayableAmount(parseFloat(netPayable.toFixed(2)));
  // }, [data.BillAmount, GrossAmount, totalDeductionAmount]);

  const deductionOperation = (e) => {
    e.preventDefault();

    if (data && data.BillAmount && selectedDeductionID) {
      const netAmount = parseFloat(data.BillAmount);
      let amt = parseFloat(deductionAmount);
      if (amt == "" || amt == null) {
        return alert("Please Enter The Deduction Amount!");
      }
      if (amt < 1) {
        alert("Deduction Amount Should be greater than 0!");
        setDeductionAmount("");
        setDeductionPercent("");
        return;
      }
      const percent = ((amt / netAmount) * 100).toFixed(2);

      let d = {
        ProjectID: data.ProposalId,
        HeadID: data.HeadCode,
        WorkUniqueID: data.WorkOrderUnique,
        DeductionAmount: amt,
        DeductionPercent: percent,
        DeductionName: selectedDeductionName,
        DeductionID: selectedDeductionID,
        isManual: amt > 0,
      };

      const isDuplicate = deductionList.some(
        (item) => item.DeductionID === selectedDeductionID,
      );
      if (isDuplicate) {
        alert("Deduction with this type already exists.");
        return;
      }

      const updatedDeductionList = [...deductionList, d];
      setDeductionList(updatedDeductionList);
      setDeductionPercent("");
      setDeductionAmount("");
      setSelectedDeductionID("");

      const totalDeductionPercent = updatedDeductionList.reduce(
        (total, deduction) => total + parseFloat(deduction.DeductionPercent),
        0,
      );
      const totalDeductionAmount = updatedDeductionList.reduce(
        (total, deduction) => total + parseFloat(deduction.DeductionAmount),
        0,
      );

      setTotalDeductionPercent(totalDeductionPercent);
      setTotalDeductionAmount(totalDeductionAmount);
    } else {
      alert("Please Select Deduction Type !!!");
    }
  };

  const handleDeleteDeduction = (e, id) => {
    e.preventDefault();
    const updatedList = deductionList.filter((d) => d.DeductionID != id);
    setDeductionList(updatedList);

    const totalPercent = updatedList.reduce(
      (sum, d) => sum + parseFloat(d.DeductionPercent),
      0,
    );
    const totalAmount = updatedList.reduce(
      (sum, d) => sum + parseFloat(d.DeductionAmount),
      0,
    );

    setTotalDeductionPercent(totalPercent);
    setTotalDeductionAmount(totalAmount);
    setEditIndex(null);
    setEditIndexOF(null);
  };

  useEffect(() => {
    if (data.BillAmount && deductionList.length > 0) {
      const netAmount = parseFloat(data.BillAmount);
      let totalPercent = 0;
      let totalAmount = 0;

      const updatedList = deductionList.map((d) => {
        if (d.isManual) {
          const updatedPercent = (
            (d.DeductionAmount / netAmount) *
            100
          ).toFixed(2);
          totalPercent += parseFloat(updatedPercent);
          totalAmount += parseFloat(d.DeductionAmount);
          return { ...d, DeductionPercent: updatedPercent };
        } else {
          const updatedAmount = (d.DeductionPercent / 100) * netAmount;
          totalPercent += parseFloat(d.DeductionPercent);
          totalAmount += updatedAmount;
          return { ...d, DeductionAmount: updatedAmount };
        }
      });

      setDeductionList(updatedList);
      setTotalDeductionPercent(totalPercent);
      setTotalDeductionAmount(totalAmount);
    }
  }, [data.BillAmount]);

  useEffect(() => {
    if (editIndex !== null) {
      const netAmount = parseFloat(data.BillAmount || 0);
      const amount = parseFloat(editIndex.DeductionAmount || 0);

      if (amount > netAmount) {
        alert(
          `Deduction amount cannot exceed the Bill Amount (₹${netAmount}).`,
        );
        setEditIndex({
          ...editIndex,
          DeductionAmount: netAmount,
          DeductionPercent: 100,
        });
        return;
      }

      const updatedPercent = ((amount / netAmount) * 100).toFixed(2);

      if (updatedPercent > 100) {
        alert(
          `Deduction percent cannot exceed 100%. It has been reset to 100%.`,
        );
        setEditIndex({
          ...editIndex,
          DeductionPercent: 100,
          DeductionAmount: netAmount,
        });
        return;
      }

      setEditIndex({ ...editIndex, DeductionPercent: updatedPercent });
    }
  }, [editIndex?.DeductionAmount, data.BillAmount]);

  const changeselectedName = (id) => {
    if (id != "") {
      let res = fetchDeductionData.filter((item) => item.DeductionID == id);
      setSelectedDeductionName(res[0].UseFor);
    }
  };

  const handleEdit = (e, index) => {
    e.preventDefault();
    const item = deductionList[index];
    setEditIndex(item);
    setEditIndexOF(index);
  };

  const handelchangeTablre = (e) => {
    e.preventDefault();

    const updatedList = [...deductionList];
    updatedList[editIndexOF] = editIndex;

    const netAmount = parseFloat(data.BillAmount || 0);

    const totalDeductionPercent = updatedList.reduce(
      (total, d) => total + parseFloat(d.DeductionPercent || 0),
      0,
    );
    const totalDeductionAmount = updatedList.reduce(
      (total, d) => total + parseFloat(d.DeductionAmount || 0),
      0,
    );

    if (editIndex.DeductionAmount < 1) {
      alert("Deduction Amount Should be greater than 0!");
      setEditAmount("");
      return;
    }

    if (parseFloat(editIndex.DeductionAmount) > netAmount) {
      alert(`Deduction amount cannot exceed the Bill Amount (₹${netAmount}).`);
      setEditIndex(null);
      setEditIndexOF(null);
      return;
    }

    if (totalDeductionPercent > 100) {
      alert(
        `Total deduction percent (${totalDeductionPercent}%) exceeds 100%. Please adjust.`,
      );
      setEditIndex(null);
      setEditIndexOF(null);
      return;
    }

    if (totalDeductionAmount > netAmount) {
      const excess = (totalDeductionAmount - netAmount).toFixed(2);
      alert(
        `Total deduction amount exceeds Bill Amount by ₹${excess}. Please adjust.`,
      );
      setEditIndex(null);
      setEditIndexOF(null);
      return;
    }

    setDeductionList(updatedList);
    setTotalDeductionPercent(totalDeductionPercent);
    setTotalDeductionAmount(totalDeductionAmount);
    setEditIndex(null);
    setEditIndexOF(null);
    setEditAmount("");
  };

  const [schemeData, setSchemeData] = useState({
    schemeName: "",
    expenseType: "Revenue",
    percent: "",
    amount: "",
  });

  const handleChangeofSchemeData = (e) => {
    const { name, value } = e.target;
    setSchemeData({ ...schemeData, [name]: value });
  };

  const addSchemeINArray = (e) => {
    e.preventDefault();
    let a = { ...schemeData };

    if (
      !schemeData.amount ||
      !schemeData.expenseType ||
      !schemeData.percent ||
      !schemeData.schemeName
    ) {
      return alert("Scheme Data is not inserted !!!!");
    }

    setSchemeComponentData((prev) => {
      const isDuplicate = prev.some(
        (item) =>
          item.schemeName === a.schemeName &&
          item.expenseType === a.expenseType,
      );
      if (!isDuplicate) {
        return [...prev, a];
      } else {
        alert("Duplicate scheme", a.schemeName);
        return prev;
      }
    });

    setSchemeData({
      schemeName: "",
      expenseType: "Revenue",
      percent: "",
      amount: "",
    });
  };

  // ✅ Fetch all Zillas for a HeadCode
  // const FetchDataRelatedtoZilla = async (id) => {
  //   try {
  //     let res = await GetBudgetHeadInfo(
  //       id,
  //       "GetSpecificTalukaDatabasedonHeadcode",
  //     );
  //     const dataArray = Array.isArray(res) ? res : [];
  //     setFetchedFData(dataArray);
  //     const uniqueTalukas = [
  //       ...new Set(dataArray.map((item) => item.ZillaParishad)),
  //     ];
  //     setTaluka(uniqueTalukas);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // New code -> with mhuid for new
  const FetchDataRelatedtoZilla = async (id) => {
    try {
      const userRes = await Usermenu();
      const district = userRes?.Data?.District || "";
      setTaluka(district ? [district] : []);

      // ✅ NEW — auto-fill data.talulka directly, no user click needed
      // setData((prev) => ({ ...prev, talulka: district }));

      const res = await GetBudgetHeadInfo(
        id,
        "GetSpecificTalukaDatabasedonHeadcode",
      );
      const dataArray = Array.isArray(res) ? res : [];
      setFetchedFData(dataArray);
    } catch (err) {
      console.log(err);
    }
  };

  // --> old code
  // const FetchDataRelatedtoZilla = async () => {
  //   try {
  //     const data = await Usermenu();

  //     if (!data || typeof data !== "object") {
  //       console.error("Invalid data:", data);
  //       return;
  //     }

  //     const userData = data?.Data;

  //     const talukaValue = userData?.District;

  //     // If single value
  //     setTaluka(talukaValue ? [talukaValue] : []);
  //     console.log("User Data:", userData);
  //   } catch (error) {
  //     console.error("Error in FetchDataRelatedtoZilla:", error);
  //   }
  // };

  // ✅ Filter Zillas by year — auto-select if only one
  const sortDatabyProposalYear = (year) => {
    if (!data.HeadCode) return;

    let res = FetchedFData.filter(
      (item) => item.ProposalYear == year && item.HeadCode === data.HeadCode,
    );

    const uniqueTalukas = [...new Set(res.map((item) => item.ZillaParishad))];

    if (uniqueTalukas.length > 0) {
      setTaluka(uniqueTalukas);
    }

    // ✅ Auto-select if only one Zilla
    if (uniqueTalukas.length === 1) {
      const autoZilla = uniqueTalukas[0];
      setData((prev) => ({ ...prev, talulka: autoZilla }));

      // if (workOrderType === "New Work Order") {
      //   sortDataByGrnID_withParams(year, data.HeadCode, autoZilla);
      // }
      // if (workOrderType === "Existing Work Order") {
      //   sortDatabyTechnicalID_withParams(data.HeadCode, year, autoZilla);
      // }
    } else if (uniqueTalukas.length > 1) {
      setWorkOrderIDData([]);
      setWorkOrderALLData([]);
      setVendorDetail([]);
      setProposalID([]);
    }
  };

  // ✅ FIXED: autoFetchVendorForExisting — works for BOTH New and Existing Work Orders
  const autoFetchVendorForExisting = async (workItem, allWorkData) => {
    try {
      if (
        workItem.physicalValue === null ||
        workItem.physicalValue === undefined ||
        workItem.physicalValue === "" ||
        Number(workItem.physicalValue) <= 0
      ) {
        alert("No Physical Progress found for this Work.");

        setVendorDetail([]);
        setWorkOrderData(null);

        setData((prev) => ({
          ...prev,
          physicalValue: "",
          ContractorName: "",
          WorkUID: "",
          WorkOrderUnique: "",
        }));

        return;
      }
      const response = await GetWorkDetailbyworkID(workItem.WorkOrderID);

      const billData = response?.message || [];

      const alreadyExists = billData.some(
        (item) =>
          Number(item.physicalValueOfProgress) ===
          Number(workItem.physicalValue),
      );

      if (alreadyExists) {
        alert(
          `Bill already created for Physical Progress ${workItem.physicalValue}%`,
        );

        setSelectedWorkOrderID(null);

        setData((prev) => ({
          ...prev,
          WorkOrderUnique: "",
          physicalValue: "",
          RABillAmount: "",
        }));

        return;
      }

      // ✅ Store WorkOrderID when auto-selected
      setSelectedWorkOrderID(workItem.WorkOrderID || null);

      const ContractorName = workItem.ContractorName;
      const ContractorUniqueID = workItem.ContractorUniqueID; // NEW — this is the exact vendor picked at WO creation
      if (!ContractorUniqueID) {
        console.warn(
          "No ContractorUniqueID on this work order (created before the fix) — vendor bank details may be ambiguous.",
        );
      }

      let res = await GetBudgetHeadInfo(
        ContractorUniqueID,
        "GetSpecificContractorDetail",
      );

      let vendordataiget = res?.[0] || {
        BANK_NAME: "N/A",
        Account_Number: "N/A",
        IFSC_CODE: "N/A",
        BranchName: "N/A",
        UniqueID: "",
      };

            // contractor_registration.DepartmentAccessID is a list like [1,2]
      const contractorInDepartment = (raw, deptId) => {
        if (!deptId || raw === undefined || raw === null || raw === "") return true;
        try {
          const list = Array.isArray(raw) ? raw : JSON.parse(raw);
          return list.map(String).includes(String(deptId));
        } catch (e) {
          return true;                       // unreadable value -> backend still checks
        }
      };

      if (!contractorInDepartment(vendordataiget.DepartmentAccessID, data.DepartmentAccessID)) {
        alert("This contractor is not registered for the selected department.");
        setVendorDetail([]);
        setSelectedWorkOrderID(null);
        setData((prev) => ({
          ...prev,
          ContractorName: "",
          ContractorUniqueID: "",
          WorkUID: "",
          WorkOrderUnique: "",
          physicalValue: "",
          RABillAmount: "",
        }));
        return;
      }

      let objAnswer = {
        ContractorName,
        ApprovedWorkAmount: workItem.ApprovedWorkAmount,
        RemainingAmount: workItem.BillRemainingAmount,
        BANK_NAME: vendordataiget.BANK_NAME,
        Account_Number: vendordataiget.Account_Number,
        IFSC_CODE: vendordataiget.IFSC_CODE,
        BranchName: vendordataiget.BranchName,
        WorkOrderUnique: workItem.WorkName || "",
        physicalValue: workItem.physicalValue,
      };

      setRemainingAmount(workItem.BillRemainingAmount);

      // ✅ Always sync ContractorName, WorkUID, physicalValue onto data
      setData((prev) => ({
        ...prev,
        ContractorName,
        ContractorUniqueID: vendordataiget.UniqueID || ContractorUniqueID || "",
        WorkUID: vendordataiget.UniqueID || "",
        physicalValue: String(workItem.physicalValue || ""),
      }));

      setVendorDetail([objAnswer]);
    } catch (err) {
      console.log("autoFetchVendorForExisting error :: ", err);
    }
  };

  // ✅ Populate MHUID list for New Work Order
  const sortDataByGrnID_withParams = (year, headCode, zilla, taluka = "") => {
    let res = FetchedFData.filter(
      (item) =>
        item.ProposalYear == year &&
        item.ZillaParishad == zilla &&
        item.HeadCode === headCode &&
        (taluka ? item.Taluka === taluka : true),
    );
    const uniqueProposalName = [
      ...new Set(res.map((item) => item.TechnicalSanctionNo)),
    ];
    setProposalID(uniqueProposalName);
  };

  // ✅ Fetch work orders for Existing Work Order — auto-fill if only one
  const sortDatabyTechnicalID_withParams = async (
    headCode,
    proposalYear,
    zilla,
    taluka,
  ) => {
    try {
      setWorkOrderIDData([]);
      setWorkOrderALLData([]);
      setVendorDetail([]);
      setSelectedWorkOrderID(null); // ✅ reset on new fetch
      setData((prev) => ({
        ...prev,
        WorkOrderUnique: "",
        physicalValue: "",
        WorkName: "",
        RABillAmount: "",
      }));

      const payload = {
        HeadCode: headCode,
        ProposalYear: proposalYear,
        Taluka: zilla,
        ULB: taluka,
        WorkOrderType: "Existing Work Order",
        DepartmentAccessID: data.DepartmentAccessID,   // new
      };

      const res = await GetBudgetHeadInfo(
        payload,
        "GetSpecificWorkUIDfromTable",
      );

      if (!res || res.length === 0) return;

      const filtered = taluka
        ? res.filter((item) => item.Taluka === taluka || item.ulb === taluka)
        : res;

      setWorkOrderALLData(filtered);

      // ✅ Store full objects with both WorkOrderID and WorkName — not just names
      // This allows dropdown to use WorkOrderID as value (unique) and WorkName as label
      const uniqueWorkOrders = filtered.reduce((acc, item) => {
        // avoid duplicating same WorkOrderID
        if (!acc.find((x) => x.WorkOrderID === item.WorkOrderID)) {
          acc.push({
            WorkOrderID: item.WorkOrderID, // unique identifier
            WorkName: item.WorkName, // display label
          });
        }
        return acc;
      }, []);

      setWorkOrderIDData(uniqueWorkOrders); // ✅ now array of objects

      // ✅ Auto-select if only one work order
      if (uniqueWorkOrders.length === 1) {
        const autoWork = filtered[0];

        // ✅ Set WorkOrderID immediately — no name-based lookup needed
        setSelectedWorkOrderID(autoWork.WorkOrderID || null);

        setData((prev) => ({
          ...prev,
          WorkOrderUnique: autoWork.WorkName || "",
          WorkName: autoWork.WorkName || "",
          physicalValue: String(autoWork.physicalValue || ""),
        }));

        await autoFetchVendorForExisting(autoWork, filtered);
      }
    } catch (err) {
      console.log("sortDatabyTechnicalID_withParams error :: ", err);
    }
  };

  //--> old code

  //   const sortDatabyTechnicalID_withParams = async (headCode, proposalYear, zilla, taluka ) => {
  //   try {
  //     setWorkOrderIDData([]);
  //     setWorkOrderALLData([]);
  //     setVendorDetail([]);
  //     setData((prev) => ({
  //       ...prev,
  //       WorkOrderUnique: "",
  //       physicalValue: "",
  //       WorkName: "",
  //     }));

  //     const payload = {
  //       HeadCode: headCode,
  //       ProposalYear: proposalYear,
  //       Taluka: zilla,
  //       ULB: taluka,          // ✅ pass taluka to backend if needed
  //       WorkOrderType: "Existing Work Order",
  //     };

  //     const res = await GetBudgetHeadInfo(payload, "GetSpecificWorkUIDfromTable");

  //     if (!res || res.length === 0) return;

  //     // ✅ Filter by taluka on frontend if backend doesn't handle it
  //     const filtered = taluka
  //       ? res.filter(item => item.Taluka === taluka || item.ulb === taluka)
  //       : res;

  //     setWorkOrderALLData(filtered);
  //     const uniqueWorkOrderNo = [...new Set(filtered.map((item) => item.WorkName))];
  //     setWorkOrderIDData(uniqueWorkOrderNo);

  //     if (uniqueWorkOrderNo.length === 1) {
  //       console.log("fg")
  //       const autoWork = filtered[0];
  //       setData((prev) => ({
  //         ...prev,
  //         WorkOrderUnique: autoWork.WorkName || "",
  //         WorkName: autoWork.WorkName || "",
  //         physicalValue: String(autoWork.physicalValue || ""),
  //       }));
  //       if (autoWork.WorkName) {
  //         await autoFetchVendorForExisting(autoWork, filtered);
  //       }
  //     }
  //   } catch (err) {
  //     console.log("sortDatabyTechnicalID_withParams error :: ", err);
  //   }
  // };

  const sortDataByZilla = (zilla) => {
    if (data.HeadCode && data.ProposalYear) {
      let res = FetchedFData.filter(
        (item) =>
          item.ZillaParishad == zilla &&
          item.ProposalYear == data.ProposalYear &&
          item.HeadCode === data.HeadCode,
      );
      const unqiueGRNumber = [...new Set(res.map((item) => item.GRNumber))];
      setGrnData(unqiueGRNumber);
    }
  };

  useEffect(() => {
    if (data.ProposalYear && data.talulka) {
      sortDataByZilla(data.talulka);
    }
  }, [data.ProposalYear, data.talulka]);

  const sortDataByGrnID = (id) => {
    if (data.HeadCode && data.ProposalYear && data.talulka) {
      let res = FetchedFData.filter(
        (item) =>
          item.ProposalYear == data.ProposalYear &&
          item.ZillaParishad == data.talulka &&
          item.HeadCode === data.HeadCode,
      );
      const uniqueProposalName = [
        ...new Set(res.map((item) => item.TechnicalSanctionNo)),
      ];
      setProposalID(uniqueProposalName);
    }
  };

  useEffect(() => {
    if (data.talulka) {
      sortDataByGrnID(data.talulka);
    }
  }, [data.ProposalYear, data.HeadCode, data.talulka]);

  const sortDatabyProposalID = async (Proid) => {
    if (data.HeadCode && data.ProposalYear && data.talulka) {
      try {
        setSelectedWorkOrderID(null); // ✅ reset on new fetch

        let res = await GetBudgetHeadInfo(Proid, "GetSpecificWorkUIDfromTable");

        setWorkOrderALLData(res);

        // ✅ Store objects with WorkOrderID + WorkName — not just names
        const uniqueWorkOrders = res.reduce((acc, item) => {
          if (!acc.find((x) => x.WorkOrderID === item.WorkOrderID)) {
            acc.push({
              WorkOrderID: item.WorkOrderID,
              WorkName: item.WorkName,
            });
          }
          return acc;
        }, []);

        setWorkOrderIDData(uniqueWorkOrders); // ✅ array of objects now

        const uniqueMHUIDNo = [
          ...new Set(res.map((item) => item.TechnicalUID)),
        ];
        setTechnicalSanctionUid(uniqueMHUIDNo);
      } catch (err) {
        console.log(err);
      }
    }
  };

  // --> old code
  // const sortDatabyProposalID = async (Proid) => {
  //   if (data.HeadCode && data.ProposalYear && data.talulka) {
  //     try {
  //       let res = await GetBudgetHeadInfo(Proid, "GetSpecificWorkUIDfromTable");
  //       setWorkOrderALLData(res);
  //       const uniqueWorkOrderNo = [...new Set(res.map((item) => item.WorkName))];
  //       const uniqueMHUIDNo = [...new Set(res.map((item) => item.TechnicalUID))];
  //       setWorkOrderIDData(uniqueWorkOrderNo);
  //       setTechnicalSanctionUid(uniqueMHUIDNo);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  // };

  // ✅ For New Work Order — triggered when MHUID is selected
  const sortDatabyTechnicalID = async (Proid) => {
    try {
      setSelectedWorkOrderID(null); // ✅ reset on new fetch

      setData((prev) => ({
        ...prev,
        physicalValue: "",
        WorkOrderUnique: "",
        WorkName: "",
        RABillAmount: "",
      }));
      setVendorDetail([]);
      setTotalEstimateAmount("");
      setRemainingAmount("");
      setWorkOrderIDData([]);
      setWorkOrderALLData([]);

      const payload = {
        TechnicalUID: Proid,
        WorkOrderType: workOrderType,
        ULB: data.ulb || "",
        DepartmentAccessID: data.DepartmentAccessID,   // new
      };

      let res = await GetBudgetHeadInfo(payload, "GetSpecificWorkUIDfromTable");

      if (!res || res.length === 0) {
        console.warn("No work orders found");
        return;
      }

      setWorkOrderALLData(res);

      // ✅ Store objects with WorkOrderID + WorkName — not just names
      const uniqueWorkOrders = res.reduce((acc, item) => {
        if (!acc.find((x) => x.WorkOrderID === item.WorkOrderID)) {
          acc.push({
            WorkOrderID: item.WorkOrderID,
            WorkName: item.WorkName,
          });
        }
        return acc;
      }, []);

      setWorkOrderIDData(uniqueWorkOrders); // ✅ array of objects now

      // ✅ Auto-fill for New Work Order
      if (workOrderType === "New Work Order" && res.length > 0) {
        const latestWork = res[0];

        // ✅ Store WorkOrderID immediately — unique, not name-based
        setSelectedWorkOrderID(latestWork.WorkOrderID || null);

        setData((prev) => ({
          ...prev,
          WorkName: latestWork.WorkName || "",
          WorkOrderUnique: latestWork.WorkName || "",
          physicalValue: String(latestWork.physicalValue || ""),
          talulka: latestWork.ZillaParishad || prev.talulka,
        }));

        if (latestWork.ZillaParishad) {
          setTaluka((prev) => [
            ...new Set([...prev, latestWork.ZillaParishad]),
          ]);
        }
      }
    } catch (err) {
      console.log("sortDatabyTechnicalID error :: ", err);
    }
  };
  //-->Old code

  // const sortDatabyTechnicalID = async (Proid) => {
  //   try {
  //     const currentHeadCode = data.HeadCode;
  //     const currentProposalYear = data.ProposalYear;
  //     const currentTaluka = data.talulka;

  //     setData((prev) => ({
  //       ...prev,
  //       physicalValue: "",
  //       WorkOrderUnique: "",
  //       WorkName: "",
  //     }));
  //     setVendorDetail([]);
  //     setTotalEstimateAmount("");
  //     setRemainingAmount("");
  //     setWorkOrderIDData([]);
  //     setWorkOrderALLData([]);

  //     const payload = {
  //       TechnicalUID: Proid,
  //       WorkOrderType: workOrderType,
  //     };

  //     let res = await GetBudgetHeadInfo(payload, "GetSpecificWorkUIDfromTable");

  //     if (!res || res.length === 0) {
  //       console.warn("No work orders found");
  //       return;
  //     }

  //     setWorkOrderALLData(res);

  //     const uniqueWorkOrderNo = [...new Set(res.map((item) => item.WorkName))];
  //     setWorkOrderIDData(uniqueWorkOrderNo);

  //     // ✅ Auto-fill for New Work Order
  //     if (workOrderType === "New Work Order" && res.length > 0) {
  //       const latestWork = res[0];

  //       // ✅ Store WorkOrderID when auto-filled
  //       setSelectedWorkOrderID(latestWork.WorkOrderID || null);

  //       setData((prev) => ({
  //         ...prev,
  //         WorkName: latestWork.WorkName || "",
  //         WorkOrderUnique: latestWork.WorkName || "",
  //         physicalValue: String(latestWork.physicalValue || ""),
  //         talulka: latestWork.ZillaParishad || prev.talulka,
  //       }));

  //       if (latestWork.ZillaParishad) {
  //         setTaluka((prev) => [...new Set([...prev, latestWork.ZillaParishad])]);
  //       }
  //     }
  //   } catch (err) {
  //     console.log("sortDatabyTechnicalID error :: ", err);
  //   }
  // };

  // ✅ Trigger Existing Work Order fetch when HeadCode + Year + Zilla are all set
  useEffect(() => {
    if (
      workOrderType === "Existing Work Order" &&
      data.HeadCode &&
      data.ProposalYear &&
      data.talulka &&
      data.ulb
    ) {
      sortDatabyTechnicalID_withParams(
        data.HeadCode,
        data.ProposalYear,
        data.talulka,
      );
    }
  }, [workOrderType, data.HeadCode, data.ProposalYear, data.talulka, data.ulb]);

  // ✅ FIXED: Auto-trigger vendor fetch for BOTH New and Existing Work Orders
  useEffect(() => {
    if (
      selectedWorkOrderID &&
      data.physicalValue &&
      WorkOrderAllData.length > 0 &&
      VendorDetail.length === 0 // only if vendor not already loaded
    ) {
      const matchedWork = WorkOrderAllData.find(
        (item) => String(item.WorkOrderID) === String(selectedWorkOrderID),
      );
      SetRabillValue(matchedWork?.RABillNumber || "");
      console.log("WorkOrderAllData", WorkOrderAllData);
      console.log("RABillNumber", matchedWork);
      if (matchedWork) {
        console.log(
          "Auto-triggering autoFetchVendorForExisting for:",
          selectedWorkOrderID,
        );
        autoFetchVendorForExisting(matchedWork, WorkOrderAllData);
      }
    }
  }, [selectedWorkOrderID, data.physicalValue, WorkOrderAllData]);

  useEffect(() => {
    if (!data.BillAmount) return;

    const billAmount = parseFloat(data.BillAmount);
    const remaining = parseFloat(RemainingAmount || 0);

    if (billAmount > remaining) {
      alert("Enter Net Amount Less than Remaining Amount");
      setData((prev) => ({ ...prev, BillAmount: prev.BillAmount }));
      return;
    }
  }, [data.BillAmount]);

  useEffect(() => {
    if (deductionAmount < 0) {
      alert("Deduction Amount cannot be negative !!");
      setDeductionAmount("");
      setDeductionPercent("");
      return;
    }
  }, [deductionAmount]);

  const CheckTotalEstimationAmt = (TotalEstimateAmount) => {
    if (
      !TotalEstimateAmount ||
      TotalEstimateAmount === 0 ||
      TotalEstimateAmount === null ||
      TotalEstimateAmount === undefined
    ) {
      return "No Limit Allocation Cost Found";
    }
    return parseFloat(TotalEstimateAmount).toFixed(2) || 0;
  };

  const processFile = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
        const pdfTypes = ["application/pdf"];

        if (imageTypes.includes(file.type)) {
          const exifData = await exifr.parse(file, [
            "GPSLatitude",
            "GPSLongitude",
          ]);
          if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
            console.warn(
              `⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`,
            );
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);
              canvas.toBlob((blob) => {
                const cleanedFile = new File([blob], file.name, {
                  type: file.type,
                });
                resolve(cleanedFile);
              }, file.type);
            };
            img.onerror = reject;
            img.src = e.target.result;
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
          return;
        }

        if (pdfTypes.includes(file.type)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const arrayBuffer = e.target.result;
            const uint8Array = new Uint8Array(arrayBuffer);
            const textContent = new TextDecoder("latin1").decode(uint8Array);

            const dangerousPatterns = [
              /\/JavaScript\s*<</,
              /\/JS\s*\(/,
              /\/AA\s*<</,
              /\/OpenAction\s*<</,
              /\/Launch\s*<</,
              /\/RichMedia\s*<</,
            ];

            const isMalicious = dangerousPatterns.some((pattern) =>
              pattern.test(textContent),
            );

            if (isMalicious) {
              alert(
                `⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`,
              );
              return reject(new Error("Malicious PDF detected"));
            }

            resolve(file);
          };
          reader.onerror = reject;
          reader.readAsArrayBuffer(file);
          return;
        }

        resolve(file);
      } catch (error) {
        console.error("Error processing file:", error);
        reject(error);
      }
    });
  };

  const handleBillfile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }

    setFileProcessing(true);
    try {
      const cleaned = await processFile(file);
      setProcessedProposalCopy(cleaned);
    } catch (err) {
      console.error("Error processing ProposalCopy:", err);
      alert("Invalid Proposal Copy file. Please choose a different file.");
      e.target.value = "";
      setProcessedProposalCopy(null);
    } finally {
      setFileProcessing(false);
    }
  };
  const [workOrderData, setWorkOrderData] = useState(null);

  const handleRABillChange = async (e) => {
    const value = e.target.value;

    try {
      let response = await GetWorkDetailbyworkID(selectedWorkOrderID);
      // const billData = response?.message;
      const billData = Array.isArray(response?.message) ? response.message : [];
      console.log(response);
      // ✅ Allow Final directly without condition
      if (value === "Final") {
        setWorkOrderData(billData);

        setData((prev) => ({
          ...prev,
          RABillAmount: value,
        }));

        return;
      }
      if (parseFloat(data.physicalValue) === 100) {
        if (value !== "Final") {
          alert("Physical Progress is 100%, please select Final RA Bill");
          return;
        }

        setWorkOrderData(billData);

        setData((prev) => ({
          ...prev,
          RABillAmount: "Final",
        }));

        return;
      }
      // No previous bill created
      // if (!RAbillValue && value !== "1st") {
      //   alert("Please create 1st RA Bill first");
      //   return;
      // }

      // 1st -> allow only 2nd
      // if (RAbillValue === "1st") {
      //   if (value !== "2nd") {
      //     alert("Please create 2nd RA Bill first");
      //     return;
      //   }

      //   setWorkOrderData(billData);
      // }

      // 2nd -> allow only 3rd
      // if (RAbillValue === "2nd") {
      //   if (value !== "3rd") {
      //     alert("Please create 3rd RA Bill first");
      //     return;
      //   }

      //   setWorkOrderData(billData);
      // }

      // SET SELECT VALUE
      setData((prev) => ({
        ...prev,
        RABillAmount: value,
      }));
    } catch (error) {
      console.log(error);

      alert("Failed to fetch work order details");
    }
  };

  //--> new added
  useEffect(() => {
    if (
      workOrderType === "New Work Order" &&
      data.HeadCode &&
      data.ProposalYear &&
      data.talulka
    ) {
      sortDataByGrnID_withParams(
        data.ProposalYear,
        data.HeadCode,
        data.talulka,
      );
    }
  }, [workOrderType, data.HeadCode, data.ProposalYear, data.talulka]);

  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          overflowY: "scroll",
          height: "90vh",
        }}
      >
        <div className="col-12 m-auto my-5 budgetContainer">
          <div className="m-auto DemandElement">
            {loading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255, 255, 255, 0.7)",
                  backdropFilter: "blur(4px)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    border: "6px solid #f3f3f3",
                    borderTop: "6px solid #007bff",
                    borderRadius: "50%",
                    width: "60px",
                    height: "60px",
                    animation: "spin 1s linear infinite",
                  }}
                />
                <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
              </div>
            )}

            <div className="row px-1 mb-4 mt-3">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/Bill-files64.png"
                  alt="TechnicalSanction"
                  style={{ width: "32px", height: "32px" }}
                  className="my-auto me-2"
                />
                <h3 className="text-left fw-bold mt-2">{t("Bill Maker")}</h3>
              </div>
              <div className="col-12 mt-4">
                <p
                  className="py-2 ps-1 fw-bold text-danger"
                  style={{ backgroundColor: "#FBE7E7" }}
                >
                  {t("Note : Fields marked with * are mandatory")}
                </p>
              </div>
            </div>

            <form action="">
              {/* ── Work Order Type ── */}
              <div className="col-12 elements mb-1 p-0">
                <div className="row g-0 p-0 m-0">
                  <div className="col-3 my-auto">
                    <label>
                      Work Order Type <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      value={workOrderType}
                      className="py-2"
                      onChange={(e) => {
                        setWorkOrderType(e.target.value);
                        setData((prev) => ({
                          ...prev,
                          TechnicalSanctionUID: "",
                          WorkUID: "",
                          WorkOrderUnique: "",
                          ProposalId: "",
                          physicalValue: "",
                        }));
                        setVendorDetail([]);
                        setWorkOrderIDData([]);
                        setWorkOrderALLData([]);
                        setProposalID([]);
                      }}
                    >
                      <option value="" disabled>
                        Select Work Order Type
                      </option>
                      <option value="New Work Order">New Work Order</option>
                      <option value="Existing Work Order">
                        Existing Work Order
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              {myDepartments.length > 1 && (
  <div className="col-12 elements">
    <div className="row">
      <div className="col-3">
        <label>{t("Department")} <span style={{ color: "red" }}>*</span></label>
      </div>
      <div className="col-7">
        <select
          name="DepartmentAccessID"
          value={data.DepartmentAccessID}
          className="py-2"
          onChange={HandleChangeData}
        >
          <option value="" disabled>{t("Select Department")}</option>
          {myDepartments.map((d) => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>
      </div>
    </div>
  </div>
)}

              {/* ── Head Code ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3 my-auto">
                    <label className="my-auto">
                      {t("Head Code")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="HeadCode"
                      value={data.HeadCode}
                      className="py-2"
                      onChange={(e) => {
                        HandleChangeData(e);
                        FetchDataRelatedtoZilla(e.target.value);
                      }}
                      required
                    >
                      <option value="" disabled>
                        {t("Choose Head Code")}
                      </option>
                      {visibleHeadCodes &&
                      visibleHeadCodes.map((val, index) => (
                        <option key={index} value={val.HeadID}>
                          {val.HeadName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* ── Approved Year ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Approved Year")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <select
                      name="ProposalYear"
                      value={data.ProposalYear}
                      className="py-2"
                      onChange={(e) => {
                        HandleChangeData(e);
                        sortDatabyProposalYear(e.target.value);
                      }}
                      style={{
                        fontWeight: "500",
                        padding: "8px",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <option value="" disabled>
                        {t("Choose Approved Year")}
                      </option>
                      {workOrderType === "Existing Work Order" ? (
                        <>
                          <option value="2019-2020" disabled >2019 - 2020</option>
                          <option value="2020-2021" disabled >2020 - 2021</option>
                          <option value="2021-2022">2021 - 2022</option>
                          <option value="2022-2023">2022 - 2023</option>
                          <option value="2023-2024">2023 - 2024</option>
                          <option value="2024-2025">2024 - 2025</option>
                          <option value="2025-2026">2025 - 2026</option>
{(loginDistrict === "सोलापूर" ||
loginDistrict?.startsWith("सोलापूर-")) && (
<option value="2026-2027">2026 - 2027</option>
)}
                        </>
                      ) : workOrderType === "New Work Order" ? (
                        <>
                          <option value="2025-2026">2025 - 2026</option>
                          <option value="2026-2027">2026 - 2027</option>
                        </>
                      ) : null}
                    </select>
                  </div>
                </div>
              </div>

              {/* ── Zilla Parishad ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Zilla Parishad")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      name="talulka"
                      value={data.talulka || ""}
                      placeholder={t("Auto-filled from your login")}
                      readOnly
                      style={{
                        backgroundColor: "#f0f4ff",
                        color: "#3b409e",
                        fontWeight: "600",
                        cursor: "not-allowed",
                        border: "1px solid #b0bfff",
                        borderRadius: "6px",
                        padding: "8px 12px",
                        width: "100%",
                      }}
                    />
                    {/* <select
                      name="talulka"
                      value={data.talulka}
                      className="py-2"
                      onChange={(e) => {
                        HandleChangeData(e);
                        const selectedZilla = e.target.value;

                        if (data.ProposalYear && data.HeadCode) {
                          if (workOrderType === "New Work Order") {
                            sortDataByGrnID_withParams(
                              data.ProposalYear,
                              data.HeadCode,
                              selectedZilla,
                            );
                          }
                          // if (workOrderType === "Existing Work Order") {
                          //   sortDatabyTechnicalID_withParams(
                          //     data.HeadCode,
                          //     data.ProposalYear,
                          //     selectedZilla,
                          //   );
                          // }
                        }
                      }}
                      required
                    >
                      <option value="" disabled>
                        {t("Select Zilla Parishad")}
                      </option>
                      {taluka &&
                        taluka.map((val, index) => (
                          <option value={val} key={index}>
                            {val}
                          </option>
                        ))}
                    </select>  */}
                  </div>
                </div>
              </div>

              {/* ── Taluka (ULB) ── */}
              {(workOrderType === "New Work Order" ||
                workOrderType === "Existing Work Order") &&
                data.talulka && (
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label>
                          {t("Taluka")} <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <select
                          name="taluka"
                          value={data.ulb}
                          className="py-2"
                          onChange={(e) => {
                            const selectedTaluka = e.target.value;

                            setData((prev) => ({
                              ...prev,
                              ulb: selectedTaluka,
                              TechnicalSanctionUID: "",
                              WorkOrderUnique: "",
                              WorkName: "",
                              physicalValue: "",
                              RABillAmount: "",
                            }));
                            setVendorDetail([]);
                            setWorkOrderData(null);
                            setProposalID([]);
                            setWorkOrderIDData([]);
                            setWorkOrderALLData([]);

                            // ✅ Filter MHUIDs by Zilla + Taluka for New Work Order
                            if (
                              workOrderType === "New Work Order" &&
                              data.ProposalYear &&
                              data.HeadCode
                            ) {
                              const filtered = FetchedFData.filter(
                                (item) =>
                                  item.ProposalYear === data.ProposalYear &&
                                  item.ZillaParishad === data.talulka &&
                                  item.HeadCode === data.HeadCode &&
                                  item.Taluka === selectedTaluka, // ✅ filter by ULB Taluka
                              );
                              const uniqueMHUIDs = [
                                ...new Set(
                                  filtered.map(
                                    (item) => item.TechnicalSanctionNo,
                                  ),
                                ),
                              ];
                              setProposalID(uniqueMHUIDs);
                            }

                            // ✅ Filter Work Names by Taluka for Existing Work Order
                            if (
                              workOrderType === "Existing Work Order" &&
                              data.ProposalYear &&
                              data.HeadCode
                            ) {
                              sortDatabyTechnicalID_withParams(
                                data.HeadCode,
                                data.ProposalYear,
                                data.talulka,
                                selectedTaluka,
                              );
                            }
                          }}
                          required
                        >
                          <option value="">{t("Select Taluka")}</option>
                          {ulbList &&
                            [
                              ...new Set(
                                ulbList
                                  .filter(
                                    (item) =>
                                      item.District_Marathi === data.talulka,
                                  ) // ✅ filter by selected Zilla
                                  .map((val) => val.ULBNameMarathi),
                              ),
                            ].map((ULBNameMarathi, index) => (
                              <option key={index} value={ULBNameMarathi}>
                                {ULBNameMarathi}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

              {/* ── MHUID Number (Searchable Dropdown) ── */}
              {workOrderType !== "Existing Work Order" && (
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label>
                        {t("MHUID Number")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>

                    <div className="col-7">
                      <Select
                        options={
                          ProposalID?.map((val) => ({
                            value: val,
                            label: val,
                          })) || []
                        }
                        value={
                          data.TechnicalSanctionUID
                            ? {
                                value: data.TechnicalSanctionUID,
                                label: data.TechnicalSanctionUID,
                              }
                            : null
                        }
                        onChange={(selectedOption) => {
                          const value = selectedOption?.value || "";

                          HandleChangeData({
                            target: {
                              name: "TechnicalSanctionUID",
                              value,
                            },
                          });

                          sortDatabyTechnicalID(value);
                        }}
                        placeholder={t("Search MHUID Number")}
                        isSearchable
                        className="basic-single"
                        classNamePrefix="select"
                        noOptionsMessage={() => "No MHUID Found"}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* ── Work Name ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Work Name")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    {workOrderType === "New Work Order" ? (
                      // ✅ New Work Order: read-only, auto-filled from MHUID
                      <input
                        type="text"
                        name="WorkOrderUnique"
                        value={data.WorkOrderUnique || ""}
                        placeholder={t("Auto-filled on MHUID selection")}
                        readOnly
                        style={{
                          backgroundColor: "#f0f4ff",
                          color: "#3b409e",
                          fontWeight: "600",
                          cursor: "not-allowed",
                          border: "1px solid #b0bfff",
                          borderRadius: "6px",
                          padding: "8px 12px",
                          width: "100%",
                        }}
                      />
                    ) : (
                      // ✅ Existing Work Order: dropdown — auto-fetches physicalValue + vendor on select
                      <select
                        name="WorkOrderUnique"
                        value={selectedWorkOrderID || ""}
                        className="py-2"
                        onChange={async (e) => {
                          const selectedWorkOrderID = e.target.value; // ✅ now this is WorkOrderID (numeric)

                          // Find the exact work by WorkOrderID — no name collision possible
                          const matchedWork = WorkOrderAllData.find(
                            (item) =>
                              String(item.WorkOrderID) ===
                              String(selectedWorkOrderID),
                          );

                          console.log("matchedWork********", matchedWork);

                          if (!matchedWork) return;

                          // ✅ Store WorkOrderID immediately
                          setSelectedWorkOrderID(matchedWork.WorkOrderID);
                          // ✅ Store WorkName for display and backend WorkOrderUnique field
                          setSelectedWorkDisplayName(matchedWork.WorkName);

                          // reset first
                          setData((prev) => ({
                            ...prev,
                            WorkOrderUnique: matchedWork.WorkName, // keep WorkName for display
                            physicalValue: "",
                            RABillAmount: "",
                          }));

                          setVendorDetail([]);
                          setWorkOrderData(null);

                          // ✅ Fetch existing bills using WorkOrderID — not WorkName
                          const response = await GetWorkDetailbyworkID(
                            matchedWork.WorkOrderID,
                          );
                          console.log(
                            "GetWorkDetailbyworkID response:",
                            response,
                          );
                          const billData = response?.message || [];

                          console.log("billData sample:", billData[0]);

                          // Check duplicate physical progress
                          const alreadyExists = billData.some(
                            (item) =>
                              Number(item.physicalValueOfProgress) ===
                              Number(matchedWork.physicalValue),
                          );

                          console.log("alreadyExists:", alreadyExists);
                          console.log(
                            "matchedWork.physicalValue:",
                            matchedWork.physicalValue,
                          );

                          if (alreadyExists) {
                            alert(
                              `Bill already created for Physical Progress ${matchedWork.physicalValue}%`,
                            );
                            setSelectedWorkDisplayName("");
                            setSelectedWorkOrderID(null); // ✅ reset
                            setData((prev) => ({
                              ...prev,
                              WorkOrderUnique: "",
                              physicalValue: "",
                              RABillAmount: "",
                            }));
                            return;
                          }

                          setData((prev) => ({
                            ...prev,
                            WorkOrderUnique: matchedWork.WorkName,
                            physicalValue: String(
                              matchedWork.physicalValue || "",
                            ),
                            RABillAmount: "",
                          }));

                          await autoFetchVendorForExisting(
                            matchedWork,
                            WorkOrderAllData,
                          );
                        }}
                        required
                      >
                        <option value="">{t("Choose Work Name")}</option>
                        {WorkOrderIDData &&
                          WorkOrderIDData.map((item, index) => (
                            // ✅ value = WorkOrderID (unique), label = WorkName (human readable)
                            <option key={index} value={item.WorkOrderID}>
                              {item.WorkName} - {item.WorkOrderID}
                            </option>
                          ))}
                      </select>

                      //-->old code

                      //                       <select
                      //                         name="WorkOrderUnique"
                      //                         value={data.WorkOrderUnique}
                      //                         className="py-2"
                      //                         // onChange={(e) => {
                      //                         //   const selectedWorkName = e.target.value;

                      //                         //   // ✅ Directly update without triggering cascading reset
                      //                         //   setData((prev) => ({
                      //                         //     ...prev,
                      //                         //     WorkOrderUnique: selectedWorkName,
                      //                         //     physicalValue: "",
                      //                         //     RABillAmount: " ", // reset first, auto-filled below
                      //                         //   }));
                      //                         //   setVendorDetail([]);
                      //                         //   setWorkOrderData(null);
                      //                         //   const matchedWork = WorkOrderAllData.find(
                      //                         //     (item) =>
                      //                         //       String(item.WorkName) ===
                      //                         //       String(selectedWorkName),
                      //                         //   );

                      //                         //   if (matchedWork) {
                      //                         //     // ✅ auto-fill physicalValue immediately
                      //                         //     setData((prev) => ({
                      //                         //       ...prev,
                      //                         //       WorkOrderUnique: selectedWorkName,
                      //                         //       physicalValue: String(
                      //                         //         matchedWork.physicalValue || "",
                      //                         //       ),
                      //                         //       RABillAmount: "",
                      //                         //     }));
                      //                         //     // ✅ auto-fetch vendor details
                      //                         //     autoFetchVendorForExisting(
                      //                         //       matchedWork,
                      //                         //       WorkOrderAllData,
                      //                         //     );
                      //                         //   }
                      //                         // }}
                      //                         onChange={async (e) => {
                      //   const selectedWorkName = e.target.value;

                      //   // reset first
                      //   setData((prev) => ({
                      //     ...prev,
                      //     WorkOrderUnique: selectedWorkName,
                      //     physicalValue: "",
                      //     RABillAmount: "",
                      //   }));

                      //   setVendorDetail([]);
                      //   setWorkOrderData(null);

                      //   const matchedWork = WorkOrderAllData.find(
                      //     (item) =>
                      //       String(item.WorkName) === String(selectedWorkName)
                      //   );

                      //   if (matchedWork) {

                      //     // ✅ Fetch existing bills
                      //     const response = await GetWorkDetailbyworkID(
                      //       matchedWork.WorkName
                      //     );

                      //     const billData = response?.message || [];

                      //     // ✅ Check duplicate physical progress
                      //     const alreadyExists = billData.some(
                      //       (item) =>
                      //         Number(item.physicalValueOfProgress) ===
                      //         Number(matchedWork.physicalValue)
                      //     );

                      //     if (alreadyExists) {
                      //       alert(
                      //         `Bill already created for Physical Progress ${matchedWork.physicalValue}%`
                      //       );

                      //       setData((prev) => ({
                      //         ...prev,
                      //         WorkOrderUnique: "",
                      //         physicalValue: "",
                      //         RABillAmount: "",
                      //       }));

                      //       return;
                      //     }

                      //     // ✅ Allow only new physical progress
                      //     setData((prev) => ({
                      //       ...prev,
                      //       WorkOrderUnique: selectedWorkName,
                      //       physicalValue: String(
                      //         matchedWork.physicalValue || ""
                      //       ),
                      //       RABillAmount: "",
                      //     }));

                      //     // ✅ Fetch vendor details
                      //     autoFetchVendorForExisting(
                      //       matchedWork,
                      //       WorkOrderAllData,
                      //     );
                      //   }
                      // }}
                      //                         required
                      //                       >
                      //                         <option value="">{t("Choose Work Name")}</option>
                      //                         {WorkOrderIDData &&
                      //                           WorkOrderIDData.map((val, index) => (
                      //                             <option key={index} value={val}>
                      //                               {val}
                      //                             </option>
                      //                           ))}
                      //                       </select>
                    )}
                  </div>
                </div>
              </div>

              {/* ── Physical Progress — read-only for BOTH types ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Physical Progress In %")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    {/* ✅ Both New and Existing: auto-filled, read-only */}
                    <input
                      type="text"
                      name="physicalValue"
                      value={data.physicalValue ? `${data.physicalValue}%` : ""}
                      placeholder={
                        workOrderType === "New Work Order"
                          ? t("Auto-filled on MHUID selection")
                          : t("Auto-filled on Work Name selection")
                      }
                      readOnly
                      style={{
                        backgroundColor: "#f0f4ff",
                        color: "#3b409e",
                        fontWeight: "600",
                        cursor: "not-allowed",
                        border: "1px solid #b0bfff",
                        borderRadius: "6px",
                        padding: "8px 12px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── Vendor Detail Table ── */}
              {VendorDetail.length > 0 && (
                <div className="col-12 my-3">
                  <div className="row">
                    <div className="col-12">
                      <div className="tableContainer m-auto">
                        <table>
                          <thead>
                            <tr>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                {t("Vendor Name")}
                              </th>
                              <th style={{ width: "20%", textAlign: "start" }}>
                                {t("Work Approve Amount")}
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                {t("Remaining Amount")}
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                {t("Bank Name")}
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                {t("Bank Account Number")}
                              </th>
                              <th style={{ width: "10%", textAlign: "start" }}>
                                {t("Bank IFSC")}
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                {t("Bank Branch Name")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {VendorDetail?.length > 0 ? (
                              VendorDetail?.map((val, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "start" }}>
                                    {val?.ContractorName}
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {val.ApprovedWorkAmount}
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {parseFloat(val.RemainingAmount).toFixed(
                                      2,
                                    ) || 0}
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {val.BANK_NAME}
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {val.Account_Number}
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {val.IFSC_CODE}
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {val.BranchName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7">{t("No Data Found")}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ── Construction Amount ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Bill Amount")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="number"
                      name="BillAmount"
                      placeholder={t("Enter Amount")}
                      value={data.BillAmount}
                      onChange={(e) => {
                        let value = e.target.value;

                        // ✅ allow clearing the field — don't force back to 0
                        if (value === "") {
                          setData((prev) => ({
                            ...prev,
                            BillAmount: "",
                            TotalBillAmount: calculateTotal(
                              "",
                              data.GST,
                              data.Royalty,
                              data.SQMCharges,
                            ),
                          }));
                          return;
                        }

                        if (Number(value) <= 0) {
                          value = 0;
                        }

                        const totalAmt = calculateTotal(
                          value,
                          data.GST,
                          data.Royalty,
                          data.SQMCharges,
                        );

                        if (totalAmt > remaining) {
                          alert(
                            "Total Bill Amount cannot exceed Remaining Amount",
                          );
                          value = 0;
                        }

                        setData((prev) => ({
                          ...prev,
                          BillAmount: value,
                          TotalBillAmount: calculateTotal(
                            value,
                            data.GST,
                            data.Royalty,
                            data.SQMCharges,
                          ),
                        }));
                      }}
                      // onBlur={(e) => {
                      //   let value = parseFloat(e.target.value || 0);
                      //   if (value < 0) {
                      //     alert("Enter Bill Amount greater than 0!");
                      //     value = 0;
                      //   } else if (value > remaining) {
                      //     alert("Enter Bill Amount less than Remaining Amount");
                      //     value = remaining;
                      //   }
                      //   setData((prev) => ({
                      //     ...prev,
                      //     BillAmount: value.toFixed(2),
                      //   }));
                      // }}

   onBlur={(e) => {
  // leave an empty field empty, so the submit check can catch it
  if (e.target.value === "") return;
  let value = parseFloat(e.target.value);
  if (value <= 0) {
    alert("Enter Bill Amount greater than 0!");
    setData((prev) => ({
      ...prev,
      BillAmount: "",
      TotalBillAmount: calculateTotal("", prev.GST, prev.Royalty, prev.SQMCharges),
    }));
    return;
  }
  if (value > remaining) {
    alert("Enter Bill Amount less than Remaining Amount");
    value = remaining;
  }
  setData((prev) => ({
    ...prev,
    BillAmount: value.toFixed(2),
  }));
}}

                      // disabled={totalDeductionAmount > 0}
                      disabled={Number(data.BillAmount) > 0 && totalDeductionAmount > 0}
                      required
                      onKeyDown={(e) => {
                        // Prevent minus, plus, decimal and exponent
                        if (["-", "+", "e", "E"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── GST ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("GST")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      min={0}
                      type="number"
                      placeholder={t("Enter GST")}
                      name="GST"
                      value={data.GST}
                      onChange={(e) => {
                        let value = e.target.value;

                        // ✅ allow clearing
                        if (value === "") {
                          setData((prev) => ({
                            ...prev,
                            GST: "",
                            TotalBillAmount: calculateTotal(
                              data.BillAmount,
                              "",
                              data.Royalty,
                              data.SQMCharges,
                            ),
                          }));
                          return;
                        }

                        if (Number(value) <= 0) {
                          value = 0;
                        }

                        const totalAmt = calculateTotal(
                          data.BillAmount,
                          value,
                          data.Royalty,
                          data.SQMCharges,
                        );

                        if (totalAmt > remaining) {
                          alert(
                            "Total Bill Amount cannot exceed Remaining Amount",
                          );
                          value = 0;
                        }

                        setData((prev) => ({
                          ...prev,
                          GST: value,
                          TotalBillAmount: calculateTotal(
                            data.BillAmount,
                            value,
                            data.Royalty,
                            data.SQMCharges,
                          ),
                        }));
                      }}
                      onBlur={(e) => {
                        // ✅ revert empty field to 0 on outside click
                        if (e.target.value === "") {
                          setData((prev) => ({
                            ...prev,
                            GST: 0,
                            TotalBillAmount: calculateTotal(
                              data.BillAmount,
                              0,
                              data.Royalty,
                              data.SQMCharges,
                            ),
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        // Prevent minus, plus, decimal and exponent
                        if (["-", "+", "e", "E"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── Royalty ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>{t("Royalty")}</label>
                  </div>
                  <div className="col-7">
                    <input
                      min={0}
                      type="number"
                      placeholder={t("Enter Royalty")}
                      name="Royalty"
                      value={data.Royalty}
                      onChange={(e) => {
                        let value = e.target.value;

                        // ✅ allow clearing
                        if (value === "") {
                          setData((prev) => ({
                            ...prev,
                            Royalty: "",
                            TotalBillAmount: calculateTotal(
                              data.BillAmount,
                              data.GST,
                              "",
                              data.SQMCharges,
                            ),
                          }));
                          return;
                        }

                        if (Number(value) <= 0) {
                          value = 0;
                        }

                        const totalAmt = calculateTotal(
                          data.BillAmount,
                          data.GST,
                          value,
                          data.SQMCharges,
                        );

                        if (totalAmt > remaining) {
                          alert(
                            "Total Bill Amount cannot exceed Remaining Amount",
                          );
                          value = 0;
                        }

                        setData((prev) => ({
                          ...prev,
                          Royalty: value,
                          TotalBillAmount: calculateTotal(
                            data.BillAmount,
                            data.GST,
                            value,
                            data.SQMCharges,
                          ),
                        }));
                      }}
                      onBlur={(e) => {
                        // ✅ revert empty field to 0 on outside click
                        if (e.target.value === "") {
                          setData((prev) => ({
                            ...prev,
                            Royalty: 0,
                            TotalBillAmount: calculateTotal(
                              data.BillAmount,
                              data.GST,
                              0,
                              data.SQMCharges,
                            ),
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        // Prevent minus, plus, decimal and exponent
                        if (["-", "+", "e", "E"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── SQM Charges ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>{t("Testing/SQM Charges")}</label>
                  </div>
                  <div className="col-7">
                    <input
                      min={0}
                      type="number"
                      placeholder={t("Enter SQM Charges")}
                      name="SQMCharges"
                      value={data.SQMCharges}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (!/^\d*\.?\d{0,2}$/.test(value)) {
                          return;
                        }
                        if (value === "") {
                          setData((prev) => ({
                            ...prev,
                            SQMCharges: "",
                            TotalBillAmount: calculateTotal(
                              data.BillAmount,
                              data.GST,
                              data.Royalty,
                              ""
                            ),
                          }));
                          return;
                        }

                        if (Number(value) <= 0) {
                          value = 0;
                        }

                        const totalAmt = calculateTotal(
                          data.BillAmount,
                          data.GST,
                          data.Royalty,
                          value
                        );

                        if (totalAmt > remaining) {
                          alert(
                            "Total Bill Amount cannot exceed Remaining Amount",
                          );
                          value = 0;
                        }

                        setData((prev) => ({
                          ...prev,
                          SQMCharges: value,
                          TotalBillAmount: calculateTotal(
                            data.BillAmount,
                            data.GST,
                            data.Royalty,
                            value
                          ),
                        }));
                      }}
                      onKeyDown={(e) => {
                        if (["-", "+", "e", "E"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onBlur={(e) => {
                        if (e.target.value === "") {
                          setData((prev) => ({
                            ...prev,
                            SQMCharges: 0,
                            TotalBillAmount: calculateTotal(
                              data.BillAmount,
                              data.GST,
                              data.Royalty,
                              0
                            ),
                          }));
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── Total Bill Amount (auto-calculated, read-only) ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Total Bill Amount")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder={t("Total Bill Amount")}
                      name="TotalBillAmount"
                      value={data.TotalBillAmount}
                     required
                      style={{
                        backgroundColor: "#f0f4ff",
                        color: "#3b409e",
                        fontWeight: "600",
                        cursor: "not-allowed",
                        border: "1px solid #b0bfff",
                        borderRadius: "6px",
                        padding: "8px 12px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── RA Bill Number ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("RA Bill Number")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>

                  <div className="col-7">
                    <select
                      name="RABillAmount"
                      value={data.RABillAmount}
                      className="py-2"
                      onChange={handleRABillChange}
                    >
                      <option value="" disabled>
                        {t("Select RA Bill Number")}
                      </option>

                      <option
                        value="1st"
                        disabled={
                          RAbillValue === "1st" ||
                          RAbillValue === "2nd" ||
                          RAbillValue === "3rd" ||
                          RAbillValue === "Final"
                        }
                      >
                        1st
                      </option>

                      <option
                        value="2nd"
                        disabled={
                          RAbillValue === "2nd" ||
                          RAbillValue === "3rd" ||
                          RAbillValue === "Final"
                        }
                      >
                        2nd
                      </option>

                      <option
                        value="3rd"
                        disabled={
                          RAbillValue === "3rd" || RAbillValue === "Final"
                        }
                      >
                        3rd
                      </option>

                      <option value="Final" disabled={RAbillValue === "Final"}>
                        Final
                      </option>

                      {/* <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                      <option value="Final">Final</option> */}
                    </select>
                  </div>
                  {workOrderData && workOrderData.length > 0 && (
                    <div className="tableContainer m-auto border-none">
                      <table>
                        <thead>
                          <tr>
                            <th style={{ padding: "10px" }}>Sr No</th>
                            <th style={{ padding: "10px" }}>RA Bill</th>
                            <th style={{ padding: "10px" }}>Project Name</th>
                            <th style={{ padding: "10px" }}>Bill Amount</th>
                            <th style={{ padding: "10px" }}>Net Payable</th>
                            <th style={{ padding: "10px" }}>Deduction</th>
                            <th style={{ padding: "10px" }}>Progress</th>
                          </tr>
                        </thead>

                        <tbody>
                          {workOrderData.map((item, index) => (
                            <tr key={index} style={{}}>
                              <td style={{ padding: "10px" }}>{index + 1}</td>

                              <td style={{ padding: "10px" }}>
                                {item.RABillNumber}
                              </td>

                              <td style={{ padding: "10px" }}>
                                {item.ProjectName}
                              </td>

                              <td style={{ padding: "10px" }}>
                                ₹ {item.BillAmount}
                              </td>

                              <td style={{ padding: "10px" }}>
                                ₹ {item.NetPayableAmount}
                              </td>

                              <td style={{ padding: "10px" }}>
                                ₹ {item.DeductionAmount}
                              </td>

                              <td style={{ padding: "10px" }}>
                                {item.physicalValueOfProgress}%
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

              {/* ── Remark ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>{t("Remark")}</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder={t("Enter Remark")}
                      name="Remark"
                      value={data.Remark}
                      onChange={(e) => {
                        let value = e.target.value
                          .replace(
                            /[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g,
                            "",
                          )
                          .replace(/^\s+/, "");
                        HandleChangeData({
                          target: { name: e.target.name, value },
                        });
                      }}
                      onBlur={(e) => {
                        const value = e.target.value.trim();
                        const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(
                          value,
                        );
                        if (value && !hasValidChar) {
                          setError("Enter at least one valid character");
                          alert("Enter at least one valid character");
                          setTimeout(() => e.target.focus(), 0);
                        } else {
                          setError("");
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── Upload Bill Copy ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Upload Bill Copy")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="form-control py-2"
                      id="BillCopy"
                      onChange={handleBillfile}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                  </div>
                </div>
              </div>

              {/* ── Measurement Book ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Measurement Book")}
                      <span style={{ color: "red" }}> *</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="form-control py-2"
                      id="Measurement_Book"
                      onChange={handleBillfile}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                  </div>
                </div>
              </div>

              {/* ── Inspection Report ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("SQM Inspection Report")}{" "}
                      <span style={{ color: "red" }}> *</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="form-control py-2"
                      id="Inspection_Report"
                      onChange={handleBillfile}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                  </div>
                </div>
              </div>

              {/* ── Work Completion ── */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Work Completion Certificate")}{" "}
                      {data.RABillAmount === "Final" && (
                        <span style={{ color: "red" }}> *</span>
                      )}
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="form-control py-2"
                      id="Work_completion"
                      onChange={handleBillfile}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                  </div>
                </div>
              </div>

              {/* ── GR File (Existing Work Order only) ── */}
              {/* {workOrderType === "Existing Work Order" && ( */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label>
                      {t("Administrative Approved GR (AAGR)")}{" "}
                      <span style={{ color: "red" }}> *</span>
                    </label>
                  </div>
                  <div className="col-7">
                    <input
                      type="file"
                      className="form-control py-2"
                      id="UploadGR"
                      onChange={handleBillfile}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                  </div>
                </div>
              </div>
              {/* )} */}

              {/* ── Amount Summary ── */}
              {/* <div className="col-12 elements">
                <div className="col-12 my-5">
                  <div className="row">
                    <div className="col-4 part1 py-2">
                      <div className="row">
                        <div className="col-7 my-auto">
                          <p className="my-auto">{t("Net Bill Amount")} : </p>
                        </div>
                        <div className="col-5 my-auto">
                          <p className="my-auto">
                            <b>{data.BillAmount || 0}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 part1 py-2">
                      <div className="row">
                        <div className="col-7 my-auto">
                          <p className="my-auto">
                            {t("Net Payable Amount")} :{" "}
                          </p>
                        </div>
                        <div className="col-5 my-auto">
                          <p className="my-auto">
                            <b>{netPayableAmount || 0}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 part1 py-2">
                      <div className="row">
                        <div className="col-8 my-auto">
                          <p className="my-auto">
                            {t("Total Deduction Amount")} :{" "}
                          </p>
                        </div>
                        <div className="col-4 my-auto">
                          <p className="my-auto">
                            <b>{totalDeductionAmount.toFixed(2)}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* ── Deduction Input Row ── */}
              {/* <div className="row border p-4 rounded my-3 bg-light justify-content-center">
                <div className="col-md-3">
                  <label className="fw-bold">{t("Deduction Type")}</label>
                  <select
                    className="form-control my-2"
                    value={selectedDeductionID}
                    onChange={(e) => {
                      setSelectedDeductionID(e.target.value);
                      changeselectedName(e.target.value);
                    }}
                  >
                    <option value="">{t("Choose Deduction")}</option>
                    {fetchDeductionData.map((val, idx) => (
                      <option key={idx} value={val.DeductionID}>
                        {val.UseFor}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="fw-bold">{t("Percentage")}</label>
                  <input
                    type="text"
                    value={deductionPercent}
                    disabled
                    className="form-control text-center my-2"
                  />
                </div>

                <div className="col-md-3">
                  <label className="fw-bold">{t("Amount")}</label>
                  <input
                    type="number"
                    className="form-control text-center my-2"
                    value={deductionAmount || ""}
                    onChange={(e) => {
                      const amt = parseFloat(e.target.value || 0);
                      const currentNetAmount = netPayableAmount;
                      if (amt > currentNetAmount) {
                        alert(
                          `Deduction amount cannot exceed the Bill Amount (₹${currentNetAmount.toFixed(2)}).`,
                        );
                        setDeductionAmount(currentNetAmount);
                        setDeductionPercent(100);
                        return;
                      }
                      setDeductionAmount(amt);
                      if (data.BillAmount > 0) {
                        setDeductionPercent(
                          ((amt / data.BillAmount) * 100).toFixed(2),
                        );
                      }
                    }}
                  />
                </div>

                <div className="col-md-2 d-flex align-items-end justify-content-center">
                  <button
                    className="btn btn-success rounded-pill px-4 fw-bold"
                    style={{
                      cursor: "pointer",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      whiteSpace: "nowrap",
                      marginBottom: "8px",
                    }}
                    onClick={(e) => deductionOperation(e)}
                  >
                    <img
                      src="/Add-32.png"
                      alt="add"
                      style={{
                        width: "13px",
                        height: "13px",
                        marginRight: "2px",
                      }}
                    />
                    {t("ADD")}
                  </button>
                </div>
              </div> */}

              {/* ── Deduction List Table ── */}
              {/* {deductionList.length > 0 && (
                <div className="col-12 my-3">
                  <div className="row">
                    <div className="col-12">
                      <div className="tableContainer m-auto">
                        <table>
                          <thead>
                            <tr style={{ textAlign: "center" }}>
                              <th style={{ width: "5%", textAlign: "center" }}>
                                {t("Sr.No")}
                              </th>
                              <th style={{ width: "5%", textAlign: "center" }}>
                                {t("Deduction Name")}
                              </th>
                              <th style={{ width: "15%", textAlign: "center" }}>
                                {t("Deduction Percentage")}
                              </th>
                              <th style={{ width: "15%", textAlign: "center" }}>
                                {t("Deduction Amount")}
                              </th>
                              <th style={{ width: "10%", textAlign: "center" }}>
                                {t("Action")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {deductionList.length > 0 ? (
                              deductionList.map((val, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{val.DeductionName}</td>
                                  <td>
                                    {editIndexOF === index ? (
                                      <input
                                        type="number"
                                        value={editIndex?.DeductionPercent || 0}
                                        disabled
                                        className="form-control"
                                      />
                                    ) : (
                                      <>
                                        {parseFloat(
                                          val.DeductionPercent,
                                        ).toFixed(2)}{" "}
                                        %
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {editIndexOF === index ? (
                                      <input
                                        type="number"
                                        value={editIndex?.DeductionAmount || ""}
                                        onChange={(e) => {
                                          setEditIndex({
                                            ...editIndex,
                                            DeductionAmount: e.target.value,
                                          });
                                          if (e.target.value < 0) {
                                            alert(
                                              "Deduction Amount Should be greater than 0!",
                                            );
                                            setEditIndex({
                                              ...editIndex,
                                              DeductionAmount: "",
                                            });
                                          }
                                        }}
                                        className="form-control"
                                      />
                                    ) : (
                                      parseFloat(val.DeductionAmount).toFixed(2)
                                    )}
                                  </td>
                                  <td>
                                    {editIndexOF === index ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "8px",
                                          flexWrap: "nowrap",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          disabled={fileProcessing || loading}
                                          className="btn btn-sm"
                                          style={buttonStylePrimary}
                                          onClick={(e) => handelchangeTablre(e)}
                                        >
                                          <img
                                            src="/Submit-32.png"
                                            alt="save"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          {t("Save")}
                                        </button>
                                        <button
                                          className="btn btn-sm"
                                          type="button"
                                          style={buttonStyleDanger}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setEditIndex(null);
                                            setEditIndexOF(null);
                                          }}
                                        >
                                          <img
                                            src="/Close-32.png"
                                            alt="cancel"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          {t("Cancel")}
                                        </button>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "8px",
                                          flexWrap: "nowrap",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          className="btn btn-sm"
                                          style={buttonStylePrimary}
                                          onClick={(e) => handleEdit(e, index)}
                                        >
                                          <img
                                            src="/Edit-32.png"
                                            alt="edit"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          {t("Edit")}
                                        </button>
                                        <button
                                          className="btn btn-sm"
                                          style={buttonStyleDanger}
                                          onClick={(e) =>
                                            handleDeleteDeduction(
                                              e,
                                              val.DeductionID,
                                            )
                                          }
                                        >
                                          <img
                                            src="/Delete-32.png"
                                            alt="delete"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          {t("Delete")}
                                        </button>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  {t("No data found")}
                                </td>
                              </tr>
                            )}

                            {deductionList.length > 0 && (
                              <tr>
                                <td colSpan="2" className="text-center">
                                  <b>{t("Total")}</b>
                                </td>
                                <td>
                                  <b>
                                    {parseFloat(totalDeductionPercent).toFixed(
                                      2,
                                    )}{" "}
                                    %
                                  </b>
                                </td>
                                <td>
                                  <b>
                                    {parseFloat(totalDeductionAmount).toFixed(
                                      2,
                                    )}
                                  </b>
                                </td>
                                <td></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

              {/* ── Amount Summary ── */}
              <div className="col-12 elements">
                <div className="col-12 my-5">
                  <div className="row">
                    <div className="col-4 part1 py-2">
                      <div className="row">
                        <div className="col-7 my-auto">
                          <p className="my-auto">{t("Total Bill Amount")} : </p>
                        </div>
                        <div className="col-5 my-auto">
                          <p className="my-auto">
                            <b>{Number(data.TotalBillAmount || 0)}</b>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-4 part1 py-2">
                      <div className="row">
                        <div className="col-8 my-auto">
                          <p className="my-auto">
                            {t("Total Deduction Amount")} :{" "}
                          </p>
                        </div>
                        <div className="col-4 my-auto">
                          <p className="my-auto">
                            <b>{totalDeductionAmount.toFixed(2)}</b>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-4 part1 py-2">
                      <div className="row">
                        <div className="col-7 my-auto">
                          <p className="my-auto">
                            {t("Net Payable Amount")} :{" "}
                          </p>
                        </div>
                        <div className="col-5 my-auto">
                          <p className="my-auto">
                            <b>
                              {(
                                parseFloat(data.TotalBillAmount || 0) -
                                Number(totalDeductionAmount || 0)
                              ).toFixed(2)}
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Deductions — driven directly by fetched deduction data, not a static list ── */}
              <div className="tableContainer m-auto">
                <table>
                  <thead>
                    <tr style={{ textAlign: "center" }}>
                      <th style={{ width: "5%" }}>{t("Sr.No")}</th>
                      <th style={{ width: "20%" }}>{t("Deduction Name")}</th>
                      <th style={{ width: "20%" }}>{t("Deduction Amount")}</th>
                      <th style={{ width: "20%" }}>{t("Bank Name")}</th>
                      <th style={{ width: "20%" }}>{t("Account Number")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {fetchDeductionData.length > 0 ? (
                      fetchDeductionData.map((val, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{val.UseFor}</td>
                          <td>
                            <input
                              type="number"
                              value={val.DeductionAmount}
                              placeholder="0"
                              min={0}
                              onChange={(e) =>
                                handleDeductionAmountChange(e, index)
                              }
                              onBlur={(e) =>
                                handleDeductionAmountBlur(e, index)
                              }
                              onKeyDown={(e) => {
                                // Prevent minus, plus, decimal and exponent
                                if (["-", "+", "e", "E"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onFocus={(e) => {
                                if (e.target.value === "0") {
                                  e.target.select();
                                }
                              }}
                            />
                          </td>
                          <td>{val.Bank_Name}</td>
                          <td>{val.Account_Number}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          {t("No data found")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ── Save / Cancel Buttons ── */}
              <div className="col-12 ms-auto my-5">
                <div className="row">
                  <div className="col-7 m-auto">
                    <div className="col-12 text-center">
                      <button
                        className="px-4 py-2 btn btn-primary fw-bold"
                        onClick={handleSubmit}
                        disabled={loading || submitLockRef.current}
                        style={{
                          cursor: loading ? "not-allowed" : "pointer",
                          background: loading
                            ? "#9ca3af"
                            : "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          opacity: loading ? 0.7 : 1,
                        }}
                      >
                        {loading ? (
                          <>
                            <span
                              style={{
                                width: "14px",
                                height: "14px",
                                border: "2px solid white",
                                borderTop: "2px solid transparent",
                                borderRadius: "50%",
                                animation: "spin 0.8s linear infinite",
                              }}
                            />
                            {t("Saving...")}
                          </>
                        ) : (
                          <>
                            <img
                              src="/Submit-32.png"
                              alt="submit"
                              style={{ width: "13px" }}
                            />
                            {t("Save")}
                          </>
                        )}
                      </button>

                      <button
                        className="px-4 py-2 btn btn-danger fw-bold mx-4"
                        style={{
                          cursor: "pointer",
                          color: "white",
                          border: "none",
                          padding: "6px 10px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          display: "inline-flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "4px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <img
                          src="/Close-32.png"
                          alt="cancel"
                          style={{ width: "13px", height: "13px" }}
                        />
                        {t("Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default DemandGeneration;


//--> old code
// import React, { useContext, useEffect, useRef, useState } from "react";
// import Application from "../../../StateContext/Application.js";
// import { apiurl } from "../../../../../path.js";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
// import "./DemandGenral.css";
// import * as exifr from "exifr";
// import Select from "react-select";
// import { jwtDecode } from "jwt-decode";
// import validateFile from "../../../../../utils/fileUploadHelper.js";
// import { getBillDeadlineForProposalYear } from "../../../../../utils/DateFormat.js";

// const DemandGeneration = () => {
//   const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("Token");
//     if (token) {
//       try {
//         // Decode the JWT token to get user details
//         const decoded = jwtDecode(token);
//         setUserData(decoded);
//         setData((prev) => ({ ...prev, talulka: decoded.District }));
//         console.log("Logged User Info:", decoded);
//       } catch (error) {
//         console.error("Invalid token:", error);
//       }
//     }
//   }, []);

//   // Added New state variable to store the login district
//   const loginDistrict = userData?.District;

//   console.log("loginDistrict: ", loginDistrict);
//   console.log("userData: ", userData);
//   const submitLockRef = useRef(false);
//   const { language, toggleLanguage, t } = useLanguage();
//   const operation = useContext(Application);
//   const {
//     GetProjectInfo,
//     GetBudgetHeadInfo,
//     DemandCreation,
//     BankMaster,
//     getTaxes,
//     DeductionOperation,
//     GetWorkDetailbyworkID,
//     Usermenu,
//   } = operation;
//   const [selectedWorkOrderID, setSelectedWorkOrderID] = useState(null);
//   const [selectedWorkDisplayName, setSelectedWorkDisplayName] = useState("");
//   const [ulbList, setUlbList] = useState([]);
//   const [projectId, setProjectId] = useState([]);
//   const [AllData, setALLData] = useState([]);
//   const [HeadId, setHeadID] = useState([]);
//   const [workID, setWorkID] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [filterWorkOrder, setFilterWorkOrder] = useState([]);
//   const [bankData, setBankData] = useState([]);
//   const [Taxes, setTaxes] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [gst, setGst] = useState(0);
//   const [tds, setTds] = useState(0);
//   const [security, SetSecurity] = useState(0);
//   const [totalpaid, SetTotalPaid] = useState(0);
//   const [GrossAmount, setGrossAmount] = useState(0);
//   const [netPayableAmount, setNetPayableAmount] = useState(0);
//   const [TotalEstimateAmount, setTotalEstimateAmount] = useState(0);
//   const [RemainingAmount, setRemainingAmount] = useState("0");
//   const [TotalReleaseAmountTillDate, setTotalReleaseAmountTillDate] =
//     useState(0);
//   const [deductionAmount, setDeductionAmount] = useState(0);
//   const [deductionList, setDeductionList] = useState([]);
//   const [filterdWorkID, setFilteredWorkID] = useState([]);
//   const [deductionPercent, setDeductionPercent] = useState("");
//   const [selectedDeductionName, setSelectedDeductionName] = useState("");
//   const [selectedDeductionID, setSelectedDeductionID] = useState("");
//   const [totalDeductionPercent, setTotalDeductionPercent] = useState(0);
//   const [totalDeductionAmount, setTotalDeductionAmount] = useState(0);
//   const [fetchDeductionData, setFetchDeductionData] = useState([]);
//   const [SchemeComponentData, setSchemeComponentData] = useState([]);
//   const [editIndexOF, setEditIndexOF] = useState(null);
//   const [editIndex, setEditIndex] = useState(null);
//   const [editAmount, setEditAmount] = useState("");
//   const [HeadCode, setHeadCode] = useState([]);
//   const [FetchedFData, setFetchedFData] = useState([]);
//   const [taluka, setTaluka] = useState([]);
//   const [GrnData, setGrnData] = useState([]);
//   const [ProposalID, setProposalID] = useState([]);
//   const [WorkOrderIDData, setWorkOrderIDData] = useState([]);
//   const [WorkOrderAllData, setWorkOrderALLData] = useState([]);
//   const [VendorDetail, setVendorDetail] = useState([]);
//   const [ShowHead, setShowHead] = useState("Proposal");
//   const [TechnicalSanctionUid, setTechnicalSanctionUid] = useState([]);
//   const [processedProposalCopy, setProcessedProposalCopy] = useState(null);
//   const [fileProcessing, setFileProcessing] = useState(false);
//   const [workOrderType, setWorkOrderType] = useState("");
//   const total = parseFloat(TotalEstimateAmount || 0);
//   const remaining = parseFloat(RemainingAmount || 0);
//   const [error, setError] = useState("");
//   const [RAbillValue, SetRabillValue] = useState("");

//   const [isWorkOrderExpired, setIsWorkOrderExpired] = useState(false);
//   const [hasExistingExtension, setHasExistingExtension] = useState(false);
//   const [workOrderEndDateValue, setWorkOrderEndDateValue] = useState(null);
//   // const [extensionOrderProcessed, setExtensionOrderProcessed] = useState(null);

//   const resetExtensionState = () => {
//     setIsWorkOrderExpired(false);
//     setHasExistingExtension(false);
//     setWorkOrderEndDateValue(null);
//     // setExtensionOrderProcessed(null);
//   };

//   // console.log("FetchedFData****: ", FetchedFData);
//   const buttonStylePrimary = {
//     cursor: "pointer",
//     background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//     color: "white",
//     border: "none",
//     padding: "6px 14px",
//     borderRadius: "20px",
//     fontSize: "14px",
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "6px",
//     whiteSpace: "nowrap",
//   };

//   const buttonStyleDanger = {
//     cursor: "pointer",
//     backgroundColor: "#dc3545",
//     color: "white",
//     border: "none",
//     padding: "6px 14px",
//     borderRadius: "20px",
//     fontSize: "14px",
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "6px",
//     whiteSpace: "nowrap",
//   };

//   const [data, setData] = useState({
//     HeadCode: "",
//     ProposalYear: "",
//     talulka: "",
//     ulb: "",
//     GrID: "",
//     ProposalId: "",
//     WorkUID: "",
//     ProjectName: "",
//     ProjectID: "",
//     BudgetHeadID: "",
//     BudgetHeadName: "",
//     WorkName: "",
//     ContractorName: "",
//     ContractorUniqueID: "", // NEW
//     BillAmount: "",
//     GST: "",
//     Royalty: "",
//     SQMCharges: "", // ← new
//     TotalBillAmount: "",
//     RABillAmount: "",
//     Remark: "",
//     CopyofWorkOrder: "",
//     WorkOrderUnique: "",
//     type: "true",
//     District: "",
//     TechnicalSanctionUID: "",
//     physicalValue: "",
//   });

//   // ── helper: sums Construction Amount + GST + Royalty (ported from Bill Creation) ──
//   const calculateTotal = (bill, gst, royalty, sqmCharges) => {
//     const b = parseFloat(bill || 0);
//     const g = parseFloat(gst || 0);
//     const r = parseFloat(royalty || 0);
//     const s = parseFloat(sqmCharges || 0);

//     return +(b + g + r + s).toFixed(2);
//   };

//   const HandleChangeData = (e) => {
//     const { name, value } = e.target;

//     // Prevent leading space
//     if (value.length === 1 && value[0] === " ") return;

//     let finalValue = value;
//     if (name === "BillAmount") {
//       finalValue = value.replace(/[^0-9.]/g, "");
//     }

//     // 1️⃣ HeadCode changed
//     if (name === "HeadCode") {
//       setSelectedWorkOrderID(null);
//       setSelectedWorkDisplayName("");
//       setData((prev) => ({
//         ...prev,
//         HeadCode: finalValue,
//         ProposalYear: "",
//         // District: "",
//         // talulka: "",
//         TechnicalSanctionUID: "",
//         GrID: "",
//         ProposalId: "",
//         WorkUID: "",
//         WorkName: "",
//         WorkOrderUnique: "",
//         physicalValue: "",
//         RABillAmount: "",
//         Remark: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setWorkOrderData(null);
//       document.getElementById("BillCopy").value = "";
//       return;
//     }

//     // 2️⃣ ProposalYear changed
//     if (name === "ProposalYear") {
//       setSelectedWorkOrderID(null);
//       setSelectedWorkDisplayName("");
//       setData((prev) => ({
//         ...prev,
//         ProposalYear: finalValue,
//         // District: "",
//         // talulka: "",
//         TechnicalSanctionUID: "",
//         GrID: "",
//         ProposalId: "",
//         WorkUID: "",
//         WorkName: "",
//         WorkOrderUnique: "",
//         physicalValue: "",
//         RABillAmount: "",
//         Remark: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setWorkOrderData(null);
//       document.getElementById("BillCopy").value = "";
//       return;
//     }

//     // 3️⃣ District changed
//     if (name === "District") {
//       setSelectedWorkOrderID(null);
//       setSelectedWorkDisplayName("");
//       setData((prev) => ({
//         ...prev,
//         District: finalValue,
//         talulka: "",
//         TechnicalSanctionUID: "",
//         GrID: "",
//         ProposalId: "",
//         WorkUID: "",
//         WorkOrderUnique: "",
//         workName: "",
//         physicalValue: "",
//         RABillAmount: "",
//         Remark: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setWorkOrderData(null);
//       document.getElementById("BillCopy").value = "";
//       return;
//     }

//     // 4️⃣ Taluka changed
//     if (name === "talulka") {
//       setSelectedWorkOrderID(null);
//       setSelectedWorkDisplayName("");
//       setData((prev) => ({
//         ...prev,
//         talulka: finalValue,
//         ulb: "",
//         TechnicalSanctionUID: "",
//         GrID: "",
//         ProposalId: "",
//         WorkUID: "",
//         WorkOrderUnique: "",
//         RABillAmount: "",
//         Remark: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setWorkOrderData(null);
//       document.getElementById("BillCopy").value = "";
//       return;
//     }

//     // 5️⃣ TechnicalSanctionUID changed
//     if (name === "TechnicalSanctionUID") {
//       setSelectedWorkOrderID(null);
//       setSelectedWorkDisplayName("");
//       setData((prev) => ({
//         ...prev,
//         TechnicalSanctionUID: finalValue,
//         GrID: "",
//         ProposalId: "",
//         WorkUID: "",
//         WorkOrderUnique: "",
//         RABillAmount: "",
//         Remark: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setWorkOrderData(null);
//       document.getElementById("BillCopy").value = "";
//       return;
//     }

//     // 6️⃣ ProposalId changed
//     if (name === "ProposalId") {
//       setSelectedWorkOrderID(null);
//       setSelectedWorkDisplayName("");
//       setData((prev) => ({
//         ...prev,
//         ProposalId: finalValue,
//         WorkUID: "",
//         WorkOrderUnique: "",
//         RABillAmount: "",
//         Remark: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setWorkOrderData(null);
//       document.getElementById("BillCopy").value = "";
//       return;
//     }

//     // Default update
//     setData((prev) => ({
//       ...prev,
//       [name]: finalValue,
//     }));
//   };

//   const getbudget = async () => {
//     let data = await BankMaster("get");
//     if (data && Array.isArray(data)) {
//       setBankData(data);
//     } else {
//       setBankData([]);
//       console.error("Error: Data is not an array or undefined.");
//     }
//   };

//   const GetTaxes = async () => {
//     let data = await getTaxes();
//     setTaxes(data);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (submitLockRef.current) return;
//     submitLockRef.current = true;

//     if (editIndexOF !== null) {
//       alert(
//         t(
//           "Please save or cancel the current deduction edit before saving the form.",
//         ),
//       );
//       submitLockRef.current = false;
//       return;
//     }

//     setLoading(true);

//     try {
//       const formData = new FormData();
//       let TOtalBillamount = parseFloat(GrossAmount || 0);

//       if (
//         !data.HeadCode ||
//         !data.WorkOrderUnique ||
//         !data.BillAmount ||
//         !data.physicalValue ||
//         !data.RABillAmount
//       ) {
//         alert("You have not entered all required data!");
//         submitLockRef.current = false;
//         setLoading(false);
//         return;
//       }

//       if (parseFloat(data.TotalBillAmount || 0) > remaining) {
//         alert(
//           "Total Bill Amount must be less than or equal to Remaining Amount.",
//         );
//         return;
//       }

//       // if (deductionList.length === 0 || totalDeductionAmount === "") {
//       //   alert("Please enter deductions!");
//       //   return;
//       // }

//       // ── deductions taken directly from the fetched deduction table (dynamic, not static) ──
//       const finalDeductionList = fetchDeductionData.filter(
//         (item) => item.DeductionAmount && item.DeductionAmount > 0,
//       );

//       const computedDeductionTotal = finalDeductionList.reduce(
//         (sum, item) => sum + Number(item.DeductionAmount || 0),
//         0,
//       );

//       const updatedData = {
//         ...data,
//         BillAmount: TOtalBillamount,
//         totalTax: computedDeductionTotal,
//         TotalAmountPayToVendor: netPayableAmount,
//         ProjectID: data.ProposalId,
//         BudgetHeadID: data.HeadCode,
//         District: data.talulka,
//       };

//       const BillCopy = document.getElementById("BillCopy")?.files;
//       if (!BillCopy || BillCopy.length === 0) {
//         alert("Bill Copy is not uploaded!");
//         return;
//       }

//       const InspectionReport =
//         document.getElementById("Inspection_Report")?.files[0];
//       const WorkCompletion =
//         document.getElementById("Work_completion")?.files[0];
//       const MeasurementBook =
//         document.getElementById("Measurement_Book")?.files[0];
//       const UploadGR = document.getElementById("UploadGR")?.files[0];

//       // ── Mandatory documents apply the same way for BOTH Head Codes (3054 & 2515) ──
//       if (
//         String(data.HeadCode).includes("3054") ||
//         String(data.HeadCode).includes("2515")
//       ) {
//         if (!MeasurementBook) {
//           alert("Measurement Book is mandatory.");
//           return;
//         }

//         if (!InspectionReport) {
//           alert("Inspection Report is mandatory.");
//           return;
//         }

//         // Work Completion mandatory ONLY for Final RA Bill
//         if (data.RABillAmount === "Final" && !WorkCompletion) {
//           alert(
//             "Work Completion Certificate softcopy is mandatory for Final RA Bill.",
//           );
//           return;
//         }
//       }

//       if (!UploadGR) {
//         alert("Administrative GR Approved copy is mandatory.");
//         return;
//       }

//       // ── Extension Order required if bill submission deadline has passed ──
//       if (isWorkOrderExpired && !hasExistingExtension) {
//         alert(
//           "The bill submission deadline for this Work Order's Approval Year has passed. Please upload the ZP-approved Extension Order from the Work Order Outwards screen to proceed with bill generation.",
//         );
//         setLoading(false);
//         submitLockRef.current = false;
//         return;
//       }

//       const BillCopyFile = document.getElementById("BillCopy")?.files[0];
//       const WorkOrderFile =
//         document.getElementById("CopyofWorkOrder")?.files[0];

//       formData.append("BillCopy", BillCopyFile);
//       if (WorkOrderFile) {
//         formData.append("CopyofWorkOrder", WorkOrderFile);
//       }

//       let finalProposalCopy;
//       try {
//         finalProposalCopy =
//           processedProposalCopy || (await processFile(BillCopy[0]));
//       } catch {
//         alert("Error processing Demand Copy");
//         return;
//       }

//       for (const key in updatedData) {
//         formData.append(key, updatedData[key]);
//       }

//       formData.append("DeductionList", JSON.stringify(finalDeductionList));
//       formData.append("SchemeList", JSON.stringify(SchemeComponentData));
//       formData.append(
//         "remainingLimitAllocationCost",
//         parseFloat(TotalEstimateAmount) - TOtalBillamount,
//       );
//       formData.append(
//         "remainingReleaseAmounttillDate",
//         parseFloat(TotalReleaseAmountTillDate) + TOtalBillamount,
//       );
//       formData.append("releasetype", ShowHead);
//       formData.append("CopyofWorkOrder", finalProposalCopy);
//       formData.append("BillCopy", finalProposalCopy);
//       formData.append("WorkOrderID", selectedWorkOrderID || "");

//       if (MeasurementBook) formData.append("Measurement_Book", MeasurementBook);
//       if (InspectionReport)
//         formData.append("Inspection_Report", InspectionReport);
//       if (WorkCompletion) formData.append("Work_completion", WorkCompletion);
//       if (UploadGR) formData.append("UploadGR", UploadGR);
//       if (workOrderType) formData.append("workOrderType", workOrderType);

//       const result = await DemandCreation(formData);

//       if (result?.message) {
//         alert(result.message);
//         setTimeout(() => {
//           window.location.reload();
//         }, 300);
//       } else if (result?.error) {
//         alert(result.error); // 👈 add this
//       } else {
//         alert("Something went wrong while saving.");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong while saving.");
//     } finally {
//       setLoading(false);
//       submitLockRef.current = false;
//     }
//   };

//   const FetchData = async () => {
//     setLoading(true);
//     try {
//       let res = await GetProjectInfo("null", "all");
//       let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");

//       setProjectId(res);

//       // ============================================
//       // HEAD CODE FILTERING BASED ON LOGGED USER
//       // (decoded directly here — not from `userData` state,
//       // to avoid the effect-ordering race condition)
//       // ============================================
//       let userHeadCodes = [];
//       try {
//         const token = localStorage.getItem("Token");
//         if (token) {
//           const decoded = jwtDecode(token);
//           let raw = decoded?.HeadCode;
//           if (typeof raw === "string") {
//             raw = JSON.parse(raw);
//           }
//           if (Array.isArray(raw)) {
//             userHeadCodes = raw
//               .filter(
//                 (c) => c !== null && c !== undefined && String(c).trim() !== "",
//               )
//               .map((c) => String(c).trim());
//           }
//         }
//       } catch (err) {
//         console.error("Error decoding token for HeadCode filter:", err);
//         userHeadCodes = [];
//       }

//       console.log("User HeadCodes:", userHeadCodes);

//       // CASE 1: No restriction -> show all
//       if (userHeadCodes.length === 0) {
//         console.log("No HeadCode restriction -> Showing ALL HeadCodes");
//         setHeadCode(res3 || []);
//       } else {
//         // CASE 2: Restricted -> show only matching
//         const filteredHeadCodes = (res3 || []).filter((h) => {
//           const headId = String(h.HeadID || "").trim();
//           return userHeadCodes.some((userCode) => headId.startsWith(userCode));
//         });

//         console.log("Filtered HeadCodes:", filteredHeadCodes);
//         setHeadCode(filteredHeadCodes);

//         // Auto-select if only one option available
//         if (filteredHeadCodes.length === 1) {
//           const selectedHeadCode = filteredHeadCodes[0].HeadID;
//           setData((prev) => ({ ...prev, HeadCode: selectedHeadCode }));
//           FetchDataRelatedtoZilla(selectedHeadCode);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   //--> old code
//   // const FetchData = async () => {
//   //   setLoading(true);
//   //   try {
//   //     let res = await GetProjectInfo("null", "all");
//   //     let res3 = await GetBudgetHeadInfo("null", "AllHeadCode");
//   //     setProjectId(res);
//   //     setHeadCode(res3);
//   //   } catch (err) {
//   //     console.log(err);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const PaymentAmountTable = () => {
//     const { ProjectID, BudgetHeadID, WorkUID } = data;
//     if (!ProjectID || !BudgetHeadID || !WorkUID) {
//       alert("You have not selected all three fields! Select them.");
//       return;
//     }
//     let result = AllData?.filter((item) => {
//       return (
//         item.ProjectID == ProjectID &&
//         item.HeadID == BudgetHeadID &&
//         item.UniqueID == WorkUID
//       );
//     });
//     let details = result[0];
//     setData((prev) => ({
//       ...prev,
//       ContractorName: details?.ContractorName,
//       WorkName: details?.WorKName,
//       BudgetHeadName: details?.BudgetHead,
//       CopyofWorkOrder: details?.CopyofWorkOrder,
//       WorkOrderUnique: details?.WorkOrderID,
//     }));
//     setTableData(result);
//   };

//   const FetchInitalData = async () => {
//     try {
//       let res = await DeductionOperation("null", "fetchalldatafromBank");
//       setFetchDeductionData(res);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const FetchTalukaInfo = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "GetTalukas");
//       setUlbList(res);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     FetchInitalData();
//     FetchData();
//     getbudget();
//     GetTaxes();
//     FetchTalukaInfo();
//   }, []);

//   // ✅ NEW — prevent scroll wheel from changing number input values
//   useEffect(() => {
//     const preventWheel = () => {
//       if (document.activeElement.type === "number") {
//         document.activeElement.blur();
//       }
//     };
//     window.addEventListener("wheel", preventWheel, { passive: true });
//     return () => window.removeEventListener("wheel", preventWheel);
//   }, []);

//   // ── handle edits to a deduction amount cell, validated against Total Bill Amount (ported from Bill Creation) ──
//   const handleDeductionAmountChange = (e, index) => {
//     const rawValue = e.target.value;

//     if (rawValue === "") {
//       const updatedList = [...fetchDeductionData];
//       updatedList[index].DeductionAmount = "";
//       setFetchDeductionData(updatedList);

//       const totalDeduction = updatedList.reduce(
//         (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
//         0,
//       );
//       setTotalDeductionAmount(totalDeduction);
//       return;
//     }

//     let value = parseFloat(rawValue);
//     const totalBillAmount = parseFloat(data.TotalBillAmount || 0);

//     if (value < 0) {
//       alert("Deduction Amount should be greater than 0 !");
//       return;
//     }

//     const updatedList = [...fetchDeductionData];
//     updatedList[index].DeductionAmount = value;

//     const totalDeduction = updatedList.reduce(
//       (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
//       0,
//     );

//     if (totalDeduction > totalBillAmount) {
//       alert(
//         `Total deduction (₹${totalDeduction}) cannot exceed Bill Amount (₹${totalBillAmount})`,
//       );
//       updatedList[index].DeductionAmount = 0;

//       const correctedTotal = updatedList.reduce(
//         (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
//         0,
//       );

//       setFetchDeductionData(updatedList);
//       setTotalDeductionAmount(correctedTotal);
//       return;
//     }

//     setFetchDeductionData(updatedList);
//     setTotalDeductionAmount(totalDeduction);
//   };

//   // ✅ NEW — revert empty deduction field to 0 on blur
//   const handleDeductionAmountBlur = (e, index) => {
//     if (e.target.value === "") {
//       const updatedList = [...fetchDeductionData];
//       updatedList[index].DeductionAmount = 0;
//       setFetchDeductionData(updatedList);

//       const totalDeduction = updatedList.reduce(
//         (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
//         0,
//       );
//       setTotalDeductionAmount(totalDeduction);
//     }
//   };

//   //--> old code
//   // const handleDeductionAmountChange = (e, index) => {
//   //   let value = parseFloat(e.target.value || 0);
//   //   const totalBillAmount = parseFloat(data.TotalBillAmount || 0);

//   //   if (value < 0) {
//   //     alert("Deduction Amount should be greater than 0 !");
//   //     return;
//   //   }

//   //   const updatedList = [...fetchDeductionData];
//   //   updatedList[index].DeductionAmount = value;

//   //   const totalDeduction = updatedList.reduce(
//   //     (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
//   //     0,
//   //   );

//   //   // ❌ Validation
//   //   if (totalDeduction > totalBillAmount) {
//   //     alert(
//   //       `Total deduction (₹${totalDeduction}) cannot exceed Bill Amount (₹${totalBillAmount})`,
//   //     );

//   //     // reset current field
//   //     updatedList[index].DeductionAmount = 0;

//   //     const correctedTotal = updatedList.reduce(
//   //       (sum, item) => sum + parseFloat(item.DeductionAmount || 0),
//   //       0,
//   //     );

//   //     setFetchDeductionData(updatedList);
//   //     setTotalDeductionAmount(correctedTotal);
//   //     return;
//   //   }

//   //   // ✅ valid case
//   //   setFetchDeductionData(updatedList);
//   //   setTotalDeductionAmount(totalDeduction);
//   // };

//   useEffect(() => {
//     setData((prev) => ({
//       ...prev,
//       BillAmount: "",
//       GST: "",
//       Royalty: "",
//       SQMCharges: "", // ← new
//       TotalBillAmount: "",
//     }));
//     setGrossAmount(0);
//     setNetPayableAmount(0);
//     setTotalDeductionAmount(0);
//     setTotalDeductionPercent(0);
//     setDeductionList([]);
//     setFetchDeductionData((prev) =>
//       prev.map((item) => ({ ...item, DeductionAmount: 0 })),
//     );
//     setProcessedProposalCopy(null);
//   }, [
//     data.WorkOrderUnique,
//     VendorDetail,
//     TotalEstimateAmount,
//     data.physicalValue,
//   ]);

//   useEffect(() => {
//     if (data.ProjectID && data.BudgetHeadID && data.WorkUID) {
//       PaymentAmountTable();
//     }
//   }, [data.ProjectID, data.BudgetHeadID, data.WorkUID]);

//   useEffect(() => {
//     if (data.BillAmount) {
//       const totalPayment = Number(data.BillAmount);
//       const calculatedGst = Math.ceil((totalPayment * 18) / 100);
//       const calculatedTds = Math.ceil((totalPayment * 12) / 100);
//       const calculatedSecurity = Math.ceil((totalPayment * 2) / 100);
//       const totalTax = calculatedGst + calculatedTds + calculatedSecurity;
//       const calculatedTotalPaid = totalPayment - totalTax;

//       setGst(calculatedGst);
//       setTds(calculatedTds);
//       SetSecurity(calculatedSecurity);
//       SetTotalPaid(calculatedTotalPaid);

//       setData((prev) => ({
//         ...prev,
//         SGST: calculatedGst,
//         CGST: calculatedTds,
//         SecurityDeposite: calculatedSecurity,
//         totalTax: totalTax,
//         TotalAmountPayToVendor: netPayableAmount,
//       }));
//     }
//   }, [data.BillAmount]);

//   const FetchAllDatafromBackend = async () => {
//     try {
//       let ProjectID = {
//         HeadCode: data.HeadCode,
//         ProposalYear: data.ProposalYear,
//       };
//       let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
//       let projectData = res1[0];
//       setALLData(res1);
//       setData((prev) => ({
//         ...prev,
//         ProjectName: projectData?.Work_name,
//         ProjectID: projectData?.ProposalID,
//         District: projectData?.talulka,
//       }));
//       let AllheadId = res1.map((item) => ({
//         HeadID: item.HeadID,
//         HeadName: item.HeadName,
//       }));
//       setHeadID(AllheadId);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     if (data.HeadCode) {
//       FetchAllDatafromBackend();
//     }
//   }, [data.HeadCode, data.ProposalYear]);

//   // ── Gross / Net Payable now derive from Total Bill Amount (Construction + GST + Royalty) ──
//   useEffect(() => {
//     const gross = parseFloat(data.TotalBillAmount || 0);
//     const totalDeduction = parseFloat(totalDeductionAmount || 0);
//     const netPayable = gross - totalDeduction;
//     setGrossAmount(parseFloat(gross.toFixed(2)));
//     setNetPayableAmount(parseFloat(netPayable.toFixed(2)));
//   }, [data.TotalBillAmount, GrossAmount, totalDeductionAmount]);

//   // useEffect(() => {
//   //   const gross = parseFloat(data.BillAmount || 0);
//   //   const totalDeduction = parseFloat(totalDeductionAmount || 0);
//   //   const netPayable = gross - totalDeduction;
//   //   setGrossAmount(parseFloat(gross.toFixed(2)));
//   //   setNetPayableAmount(parseFloat(netPayable.toFixed(2)));
//   // }, [data.BillAmount, GrossAmount, totalDeductionAmount]);

//   const deductionOperation = (e) => {
//     e.preventDefault();

//     if (data && data.BillAmount && selectedDeductionID) {
//       const netAmount = parseFloat(data.BillAmount);
//       let amt = parseFloat(deductionAmount);
//       if (amt == "" || amt == null) {
//         return alert("Please Enter The Deduction Amount!");
//       }
//       if (amt < 1) {
//         alert("Deduction Amount Should be greater than 0!");
//         setDeductionAmount("");
//         setDeductionPercent("");
//         return;
//       }
//       const percent = ((amt / netAmount) * 100).toFixed(2);

//       let d = {
//         ProjectID: data.ProposalId,
//         HeadID: data.HeadCode,
//         WorkUniqueID: data.WorkOrderUnique,
//         DeductionAmount: amt,
//         DeductionPercent: percent,
//         DeductionName: selectedDeductionName,
//         DeductionID: selectedDeductionID,
//         isManual: amt > 0,
//       };

//       const isDuplicate = deductionList.some(
//         (item) => item.DeductionID === selectedDeductionID,
//       );
//       if (isDuplicate) {
//         alert("Deduction with this type already exists.");
//         return;
//       }

//       const updatedDeductionList = [...deductionList, d];
//       setDeductionList(updatedDeductionList);
//       setDeductionPercent("");
//       setDeductionAmount("");
//       setSelectedDeductionID("");

//       const totalDeductionPercent = updatedDeductionList.reduce(
//         (total, deduction) => total + parseFloat(deduction.DeductionPercent),
//         0,
//       );
//       const totalDeductionAmount = updatedDeductionList.reduce(
//         (total, deduction) => total + parseFloat(deduction.DeductionAmount),
//         0,
//       );

//       setTotalDeductionPercent(totalDeductionPercent);
//       setTotalDeductionAmount(totalDeductionAmount);
//     } else {
//       alert("Please Select Deduction Type !!!");
//     }
//   };

//   const handleDeleteDeduction = (e, id) => {
//     e.preventDefault();
//     const updatedList = deductionList.filter((d) => d.DeductionID != id);
//     setDeductionList(updatedList);

//     const totalPercent = updatedList.reduce(
//       (sum, d) => sum + parseFloat(d.DeductionPercent),
//       0,
//     );
//     const totalAmount = updatedList.reduce(
//       (sum, d) => sum + parseFloat(d.DeductionAmount),
//       0,
//     );

//     setTotalDeductionPercent(totalPercent);
//     setTotalDeductionAmount(totalAmount);
//     setEditIndex(null);
//     setEditIndexOF(null);
//   };

//   useEffect(() => {
//     if (data.BillAmount && deductionList.length > 0) {
//       const netAmount = parseFloat(data.BillAmount);
//       let totalPercent = 0;
//       let totalAmount = 0;

//       const updatedList = deductionList.map((d) => {
//         if (d.isManual) {
//           const updatedPercent = (
//             (d.DeductionAmount / netAmount) *
//             100
//           ).toFixed(2);
//           totalPercent += parseFloat(updatedPercent);
//           totalAmount += parseFloat(d.DeductionAmount);
//           return { ...d, DeductionPercent: updatedPercent };
//         } else {
//           const updatedAmount = (d.DeductionPercent / 100) * netAmount;
//           totalPercent += parseFloat(d.DeductionPercent);
//           totalAmount += updatedAmount;
//           return { ...d, DeductionAmount: updatedAmount };
//         }
//       });

//       setDeductionList(updatedList);
//       setTotalDeductionPercent(totalPercent);
//       setTotalDeductionAmount(totalAmount);
//     }
//   }, [data.BillAmount]);

//   useEffect(() => {
//     if (editIndex !== null) {
//       const netAmount = parseFloat(data.BillAmount || 0);
//       const amount = parseFloat(editIndex.DeductionAmount || 0);

//       if (amount > netAmount) {
//         alert(
//           `Deduction amount cannot exceed the Bill Amount (₹${netAmount}).`,
//         );
//         setEditIndex({
//           ...editIndex,
//           DeductionAmount: netAmount,
//           DeductionPercent: 100,
//         });
//         return;
//       }

//       const updatedPercent = ((amount / netAmount) * 100).toFixed(2);

//       if (updatedPercent > 100) {
//         alert(
//           `Deduction percent cannot exceed 100%. It has been reset to 100%.`,
//         );
//         setEditIndex({
//           ...editIndex,
//           DeductionPercent: 100,
//           DeductionAmount: netAmount,
//         });
//         return;
//       }

//       setEditIndex({ ...editIndex, DeductionPercent: updatedPercent });
//     }
//   }, [editIndex?.DeductionAmount, data.BillAmount]);

//   const changeselectedName = (id) => {
//     if (id != "") {
//       let res = fetchDeductionData.filter((item) => item.DeductionID == id);
//       setSelectedDeductionName(res[0].UseFor);
//     }
//   };

//   const handleEdit = (e, index) => {
//     e.preventDefault();
//     const item = deductionList[index];
//     setEditIndex(item);
//     setEditIndexOF(index);
//   };

//   const handelchangeTablre = (e) => {
//     e.preventDefault();

//     const updatedList = [...deductionList];
//     updatedList[editIndexOF] = editIndex;

//     const netAmount = parseFloat(data.BillAmount || 0);

//     const totalDeductionPercent = updatedList.reduce(
//       (total, d) => total + parseFloat(d.DeductionPercent || 0),
//       0,
//     );
//     const totalDeductionAmount = updatedList.reduce(
//       (total, d) => total + parseFloat(d.DeductionAmount || 0),
//       0,
//     );

//     if (editIndex.DeductionAmount < 1) {
//       alert("Deduction Amount Should be greater than 0!");
//       setEditAmount("");
//       return;
//     }

//     if (parseFloat(editIndex.DeductionAmount) > netAmount) {
//       alert(`Deduction amount cannot exceed the Bill Amount (₹${netAmount}).`);
//       setEditIndex(null);
//       setEditIndexOF(null);
//       return;
//     }

//     if (totalDeductionPercent > 100) {
//       alert(
//         `Total deduction percent (${totalDeductionPercent}%) exceeds 100%. Please adjust.`,
//       );
//       setEditIndex(null);
//       setEditIndexOF(null);
//       return;
//     }

//     if (totalDeductionAmount > netAmount) {
//       const excess = (totalDeductionAmount - netAmount).toFixed(2);
//       alert(
//         `Total deduction amount exceeds Bill Amount by ₹${excess}. Please adjust.`,
//       );
//       setEditIndex(null);
//       setEditIndexOF(null);
//       return;
//     }

//     setDeductionList(updatedList);
//     setTotalDeductionPercent(totalDeductionPercent);
//     setTotalDeductionAmount(totalDeductionAmount);
//     setEditIndex(null);
//     setEditIndexOF(null);
//     setEditAmount("");
//   };

//   const [schemeData, setSchemeData] = useState({
//     schemeName: "",
//     expenseType: "Revenue",
//     percent: "",
//     amount: "",
//   });

//   const handleChangeofSchemeData = (e) => {
//     const { name, value } = e.target;
//     setSchemeData({ ...schemeData, [name]: value });
//   };

//   const addSchemeINArray = (e) => {
//     e.preventDefault();
//     let a = { ...schemeData };

//     if (
//       !schemeData.amount ||
//       !schemeData.expenseType ||
//       !schemeData.percent ||
//       !schemeData.schemeName
//     ) {
//       return alert("Scheme Data is not inserted !!!!");
//     }

//     setSchemeComponentData((prev) => {
//       const isDuplicate = prev.some(
//         (item) =>
//           item.schemeName === a.schemeName &&
//           item.expenseType === a.expenseType,
//       );
//       if (!isDuplicate) {
//         return [...prev, a];
//       } else {
//         alert("Duplicate scheme", a.schemeName);
//         return prev;
//       }
//     });

//     setSchemeData({
//       schemeName: "",
//       expenseType: "Revenue",
//       percent: "",
//       amount: "",
//     });
//   };

//   // ✅ Fetch all Zillas for a HeadCode
//   // const FetchDataRelatedtoZilla = async (id) => {
//   //   try {
//   //     let res = await GetBudgetHeadInfo(
//   //       id,
//   //       "GetSpecificTalukaDatabasedonHeadcode",
//   //     );
//   //     const dataArray = Array.isArray(res) ? res : [];
//   //     setFetchedFData(dataArray);
//   //     const uniqueTalukas = [
//   //       ...new Set(dataArray.map((item) => item.ZillaParishad)),
//   //     ];
//   //     setTaluka(uniqueTalukas);
//   //   } catch (err) {
//   //     console.log(err);
//   //   }
//   // };

//   // New code -> with mhuid for new
//   const FetchDataRelatedtoZilla = async (id) => {
//     try {
//       const userRes = await Usermenu();
//       const district = userRes?.Data?.District || "";
//       setTaluka(district ? [district] : []);

//       // ✅ NEW — auto-fill data.talulka directly, no user click needed
//       // setData((prev) => ({ ...prev, talulka: district }));

//       const res = await GetBudgetHeadInfo(
//         id,
//         "GetSpecificTalukaDatabasedonHeadcode",
//       );
//       const dataArray = Array.isArray(res) ? res : [];
//       setFetchedFData(dataArray);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // --> old code
//   // const FetchDataRelatedtoZilla = async () => {
//   //   try {
//   //     const data = await Usermenu();

//   //     if (!data || typeof data !== "object") {
//   //       console.error("Invalid data:", data);
//   //       return;
//   //     }

//   //     const userData = data?.Data;

//   //     const talukaValue = userData?.District;

//   //     // If single value
//   //     setTaluka(talukaValue ? [talukaValue] : []);
//   //     console.log("User Data:", userData);
//   //   } catch (error) {
//   //     console.error("Error in FetchDataRelatedtoZilla:", error);
//   //   }
//   // };

//   // ✅ Filter Zillas by year — auto-select if only one
//   const sortDatabyProposalYear = (year) => {
//     if (!data.HeadCode) return;

//     let res = FetchedFData.filter(
//       (item) => item.ProposalYear == year && item.HeadCode === data.HeadCode,
//     );

//     const uniqueTalukas = [...new Set(res.map((item) => item.ZillaParishad))];

//     if (uniqueTalukas.length > 0) {
//       setTaluka(uniqueTalukas);
//     }

//     // ✅ Auto-select if only one Zilla
//     if (uniqueTalukas.length === 1) {
//       const autoZilla = uniqueTalukas[0];
//       setData((prev) => ({ ...prev, talulka: autoZilla }));

//       // if (workOrderType === "New Work Order") {
//       //   sortDataByGrnID_withParams(year, data.HeadCode, autoZilla);
//       // }
//       // if (workOrderType === "Existing Work Order") {
//       //   sortDatabyTechnicalID_withParams(data.HeadCode, year, autoZilla);
//       // }
//     } else if (uniqueTalukas.length > 1) {
//       setWorkOrderIDData([]);
//       setWorkOrderALLData([]);
//       setVendorDetail([]);
//       resetExtensionState();
//       setProposalID([]);
//     }
//   };

//   // ✅ FIXED: autoFetchVendorForExisting — works for BOTH New and Existing Work Orders
//   const autoFetchVendorForExisting = async (workItem, allWorkData) => {
//     try {
//       // ── Check if Bill Submission Deadline (based on Approval Year) has passed ──
//       const headCodeForCheck = workItem.HeadCode || data.HeadCode;
//       const deadlineStr = getBillDeadlineForProposalYear(
//         headCodeForCheck,
//         workItem.ProposalYear,
//       );

//       if (deadlineStr) {
//         const deadline = new Date(deadlineStr);
//         deadline.setHours(23, 59, 59, 999);
//         const today = new Date();

//         if (today > deadline) {
//           setIsWorkOrderExpired(true);
//           setWorkOrderEndDateValue(deadline);

//           if (workItem.ExtensionOrder) {
//             setHasExistingExtension(true);
//           } else {
//             setHasExistingExtension(false);
//             alert(
//               `⚠️ The bill submission deadline for Approval Year ${workItem.ProposalYear} (${deadline.toLocaleDateString("en-GB")}) has passed.\n\n` +
//                 `As per the Government Resolution (GR), approval from the Ministry is mandatory. Since this is an offline process, ` +
//         `kindly upload the State-approved Extension Order under the 'Work Order Outwards' module before proceeding with bill creation.`
//             );
//           }
//         } else {
//           setIsWorkOrderExpired(false);
//           setHasExistingExtension(false);
//           setWorkOrderEndDateValue(null);
//         }
//       } else {
//         setIsWorkOrderExpired(false);
//         setHasExistingExtension(false);
//         setWorkOrderEndDateValue(null);
//       }

//       ///////////////////////////

//       // ── No physical progress branch (unchanged apart from removing the duplicate expiry block) ──
//       if (
//         workItem.physicalValue === null ||
//         workItem.physicalValue === undefined ||
//         workItem.physicalValue === "" ||
//         Number(workItem.physicalValue) <= 0
//       ) {
//         alert("No Physical Progress found for this Work.");

//         setVendorDetail([]);
//         setWorkOrderData(null);

//         setData((prev) => ({
//           ...prev,
//           physicalValue: "",
//           ContractorName: "",
//           WorkUID: "",
//           WorkOrderUnique: "",
//         }));

//         return;
//       }
//       const response = await GetWorkDetailbyworkID(workItem.WorkOrderID);

//       const billData = response?.message || [];

//       const alreadyExists = billData.some(
//         (item) =>
//           Number(item.physicalValueOfProgress) ===
//           Number(workItem.physicalValue),
//       );

//       if (alreadyExists) {
//         alert(
//           `Bill already created for Physical Progress ${workItem.physicalValue}%`,
//         );

//         setSelectedWorkOrderID(null);

//         setData((prev) => ({
//           ...prev,
//           WorkOrderUnique: "",
//           physicalValue: "",
//           RABillAmount: "",
//         }));

//         return;
//       }

//       // ✅ Store WorkOrderID when auto-selected
//       setSelectedWorkOrderID(workItem.WorkOrderID || null);

//       const ContractorName = workItem.ContractorName;
//       const ContractorUniqueID = workItem.ContractorUniqueID; // NEW — this is the exact vendor picked at WO creation
//       if (!ContractorUniqueID) {
//         console.warn(
//           "No ContractorUniqueID on this work order (created before the fix) — vendor bank details may be ambiguous.",
//         );
//       }

//       let res = await GetBudgetHeadInfo(
//         ContractorUniqueID,
//         "GetSpecificContractorDetail",
//       );

//       let vendordataiget = res?.[0] || {
//         BANK_NAME: "N/A",
//         Account_Number: "N/A",
//         IFSC_CODE: "N/A",
//         BranchName: "N/A",
//         UniqueID: "",
//       };

//       let objAnswer = {
//         ContractorName,
//         ApprovedWorkAmount: workItem.ApprovedWorkAmount,
//         RemainingAmount: workItem.BillRemainingAmount,
//         BANK_NAME: vendordataiget.BANK_NAME,
//         Account_Number: vendordataiget.Account_Number,
//         IFSC_CODE: vendordataiget.IFSC_CODE,
//         BranchName: vendordataiget.BranchName,
//         WorkOrderUnique: workItem.WorkName || "",
//         physicalValue: workItem.physicalValue,
//       };

//       setRemainingAmount(workItem.BillRemainingAmount);

//       // ✅ Always sync ContractorName, WorkUID, physicalValue onto data
//       setData((prev) => ({
//         ...prev,
//         ContractorName,
//         ContractorUniqueID: vendordataiget.UniqueID || ContractorUniqueID || "",
//         WorkUID: vendordataiget.UniqueID || "",
//         physicalValue: String(workItem.physicalValue || ""),
//       }));

//       setVendorDetail([objAnswer]);
//     } catch (err) {
//       console.log("autoFetchVendorForExisting error :: ", err);
//     }
//   };

//   // ✅ Populate MHUID list for New Work Order
//   const sortDataByGrnID_withParams = (year, headCode, zilla, taluka = "") => {
//     let res = FetchedFData.filter(
//       (item) =>
//         item.ProposalYear == year &&
//         item.ZillaParishad == zilla &&
//         item.HeadCode === headCode &&
//         (taluka ? item.Taluka === taluka : true),
//     );
//     const uniqueProposalName = [
//       ...new Set(res.map((item) => item.TechnicalSanctionNo)),
//     ];
//     setProposalID(uniqueProposalName);
//   };

//   // ✅ Fetch work orders for Existing Work Order — auto-fill if only one
//   const sortDatabyTechnicalID_withParams = async (
//     headCode,
//     proposalYear,
//     zilla,
//     taluka,
//   ) => {
//     try {
//       setWorkOrderIDData([]);
//       setWorkOrderALLData([]);
//       setVendorDetail([]);
//       resetExtensionState();
//       setSelectedWorkOrderID(null); // ✅ reset on new fetch
//       setData((prev) => ({
//         ...prev,
//         WorkOrderUnique: "",
//         physicalValue: "",
//         WorkName: "",
//         RABillAmount: "",
//       }));

//       const payload = {
//         HeadCode: headCode,
//         ProposalYear: proposalYear,
//         Taluka: zilla,
//         ULB: taluka,
//         WorkOrderType: "Existing Work Order",
//       };

//       const res = await GetBudgetHeadInfo(
//         payload,
//         "GetSpecificWorkUIDfromTable",
//       );

//       if (!res || res.length === 0) return;

//       const filtered = taluka
//         ? res.filter((item) => item.Taluka === taluka || item.ulb === taluka)
//         : res;

//       setWorkOrderALLData(filtered);

//       // ✅ Store full objects with both WorkOrderID and WorkName — not just names
//       // This allows dropdown to use WorkOrderID as value (unique) and WorkName as label
//       const uniqueWorkOrders = filtered.reduce((acc, item) => {
//         // avoid duplicating same WorkOrderID
//         if (!acc.find((x) => x.WorkOrderID === item.WorkOrderID)) {
//           acc.push({
//             WorkOrderID: item.WorkOrderID, // unique identifier
//             WorkName: item.WorkName, // display label
//           });
//         }
//         return acc;
//       }, []);

//       setWorkOrderIDData(uniqueWorkOrders); // ✅ now array of objects

//       // ✅ Auto-select if only one work order
//       if (uniqueWorkOrders.length === 1) {
//         const autoWork = filtered[0];

//         // ✅ Set WorkOrderID immediately — no name-based lookup needed
//         setSelectedWorkOrderID(autoWork.WorkOrderID || null);

//         setData((prev) => ({
//           ...prev,
//           WorkOrderUnique: autoWork.WorkName || "",
//           WorkName: autoWork.WorkName || "",
//           physicalValue: String(autoWork.physicalValue || ""),
//         }));

//         await autoFetchVendorForExisting(autoWork, filtered);
//       }
//     } catch (err) {
//       console.log("sortDatabyTechnicalID_withParams error :: ", err);
//     }
//   };

//   //--> old code

//   //   const sortDatabyTechnicalID_withParams = async (headCode, proposalYear, zilla, taluka ) => {
//   //   try {
//   //     setWorkOrderIDData([]);
//   //     setWorkOrderALLData([]);
//   //     setVendorDetail([]);
//   //     setData((prev) => ({
//   //       ...prev,
//   //       WorkOrderUnique: "",
//   //       physicalValue: "",
//   //       WorkName: "",
//   //     }));

//   //     const payload = {
//   //       HeadCode: headCode,
//   //       ProposalYear: proposalYear,
//   //       Taluka: zilla,
//   //       ULB: taluka,          // ✅ pass taluka to backend if needed
//   //       WorkOrderType: "Existing Work Order",
//   //     };

//   //     const res = await GetBudgetHeadInfo(payload, "GetSpecificWorkUIDfromTable");

//   //     if (!res || res.length === 0) return;

//   //     // ✅ Filter by taluka on frontend if backend doesn't handle it
//   //     const filtered = taluka
//   //       ? res.filter(item => item.Taluka === taluka || item.ulb === taluka)
//   //       : res;

//   //     setWorkOrderALLData(filtered);
//   //     const uniqueWorkOrderNo = [...new Set(filtered.map((item) => item.WorkName))];
//   //     setWorkOrderIDData(uniqueWorkOrderNo);

//   //     if (uniqueWorkOrderNo.length === 1) {
//   //       console.log("fg")
//   //       const autoWork = filtered[0];
//   //       setData((prev) => ({
//   //         ...prev,
//   //         WorkOrderUnique: autoWork.WorkName || "",
//   //         WorkName: autoWork.WorkName || "",
//   //         physicalValue: String(autoWork.physicalValue || ""),
//   //       }));
//   //       if (autoWork.WorkName) {
//   //         await autoFetchVendorForExisting(autoWork, filtered);
//   //       }
//   //     }
//   //   } catch (err) {
//   //     console.log("sortDatabyTechnicalID_withParams error :: ", err);
//   //   }
//   // };

//   const sortDataByZilla = (zilla) => {
//     if (data.HeadCode && data.ProposalYear) {
//       let res = FetchedFData.filter(
//         (item) =>
//           item.ZillaParishad == zilla &&
//           item.ProposalYear == data.ProposalYear &&
//           item.HeadCode === data.HeadCode,
//       );
//       const unqiueGRNumber = [...new Set(res.map((item) => item.GRNumber))];
//       setGrnData(unqiueGRNumber);
//     }
//   };

//   useEffect(() => {
//     if (data.ProposalYear && data.talulka) {
//       sortDataByZilla(data.talulka);
//     }
//   }, [data.ProposalYear, data.talulka]);

//   const sortDataByGrnID = (id) => {
//     if (data.HeadCode && data.ProposalYear && data.talulka) {
//       let res = FetchedFData.filter(
//         (item) =>
//           item.ProposalYear == data.ProposalYear &&
//           item.ZillaParishad == data.talulka &&
//           item.HeadCode === data.HeadCode,
//       );
//       const uniqueProposalName = [
//         ...new Set(res.map((item) => item.TechnicalSanctionNo)),
//       ];
//       setProposalID(uniqueProposalName);
//     }
//   };

//   useEffect(() => {
//     if (data.talulka) {
//       sortDataByGrnID(data.talulka);
//     }
//   }, [data.ProposalYear, data.HeadCode, data.talulka]);

//   const sortDatabyProposalID = async (Proid) => {
//     if (data.HeadCode && data.ProposalYear && data.talulka) {
//       try {
//         setSelectedWorkOrderID(null); // ✅ reset on new fetch

//         let res = await GetBudgetHeadInfo(Proid, "GetSpecificWorkUIDfromTable");

//         setWorkOrderALLData(res);

//         // ✅ Store objects with WorkOrderID + WorkName — not just names
//         const uniqueWorkOrders = res.reduce((acc, item) => {
//           if (!acc.find((x) => x.WorkOrderID === item.WorkOrderID)) {
//             acc.push({
//               WorkOrderID: item.WorkOrderID,
//               WorkName: item.WorkName,
//             });
//           }
//           return acc;
//         }, []);

//         setWorkOrderIDData(uniqueWorkOrders); // ✅ array of objects now

//         const uniqueMHUIDNo = [
//           ...new Set(res.map((item) => item.TechnicalUID)),
//         ];
//         setTechnicalSanctionUid(uniqueMHUIDNo);
//       } catch (err) {
//         console.log(err);
//       }
//     }
//   };

//   // --> old code
//   // const sortDatabyProposalID = async (Proid) => {
//   //   if (data.HeadCode && data.ProposalYear && data.talulka) {
//   //     try {
//   //       let res = await GetBudgetHeadInfo(Proid, "GetSpecificWorkUIDfromTable");
//   //       setWorkOrderALLData(res);
//   //       const uniqueWorkOrderNo = [...new Set(res.map((item) => item.WorkName))];
//   //       const uniqueMHUIDNo = [...new Set(res.map((item) => item.TechnicalUID))];
//   //       setWorkOrderIDData(uniqueWorkOrderNo);
//   //       setTechnicalSanctionUid(uniqueMHUIDNo);
//   //     } catch (err) {
//   //       console.log(err);
//   //     }
//   //   }
//   // };

//   // ✅ For New Work Order — triggered when MHUID is selected
//   const sortDatabyTechnicalID = async (Proid) => {
//     try {
//       setSelectedWorkOrderID(null); // ✅ reset on new fetch

//       setData((prev) => ({
//         ...prev,
//         physicalValue: "",
//         WorkOrderUnique: "",
//         WorkName: "",
//         RABillAmount: "",
//       }));
//       setVendorDetail([]);
//       resetExtensionState();
//       setTotalEstimateAmount("");
//       setRemainingAmount("");
//       setWorkOrderIDData([]);
//       setWorkOrderALLData([]);

//       const payload = {
//         TechnicalUID: Proid,
//         WorkOrderType: workOrderType,
//         ULB: data.ulb || "",
//       };

//       let res = await GetBudgetHeadInfo(payload, "GetSpecificWorkUIDfromTable");

//       if (!res || res.length === 0) {
//         console.warn("No work orders found");
//         return;
//       }

//       setWorkOrderALLData(res);

//       // ✅ Store objects with WorkOrderID + WorkName — not just names
//       const uniqueWorkOrders = res.reduce((acc, item) => {
//         if (!acc.find((x) => x.WorkOrderID === item.WorkOrderID)) {
//           acc.push({
//             WorkOrderID: item.WorkOrderID,
//             WorkName: item.WorkName,
//           });
//         }
//         return acc;
//       }, []);

//       setWorkOrderIDData(uniqueWorkOrders); // ✅ array of objects now

//       // ✅ Auto-fill for New Work Order
//       if (workOrderType === "New Work Order" && res.length > 0) {
//         const latestWork = res[0];

//         // ✅ Store WorkOrderID immediately — unique, not name-based
//         setSelectedWorkOrderID(latestWork.WorkOrderID || null);

//         setData((prev) => ({
//           ...prev,
//           WorkName: latestWork.WorkName || "",
//           WorkOrderUnique: latestWork.WorkName || "",
//           physicalValue: String(latestWork.physicalValue || ""),
//           talulka: latestWork.ZillaParishad || prev.talulka,
//         }));

//         if (latestWork.ZillaParishad) {
//           setTaluka((prev) => [
//             ...new Set([...prev, latestWork.ZillaParishad]),
//           ]);
//         }
//       }
//     } catch (err) {
//       console.log("sortDatabyTechnicalID error :: ", err);
//     }
//   };
//   //-->Old code

//   // const sortDatabyTechnicalID = async (Proid) => {
//   //   try {
//   //     const currentHeadCode = data.HeadCode;
//   //     const currentProposalYear = data.ProposalYear;
//   //     const currentTaluka = data.talulka;

//   //     setData((prev) => ({
//   //       ...prev,
//   //       physicalValue: "",
//   //       WorkOrderUnique: "",
//   //       WorkName: "",
//   //     }));
//   //     setVendorDetail([]);
//   //     setTotalEstimateAmount("");
//   //     setRemainingAmount("");
//   //     setWorkOrderIDData([]);
//   //     setWorkOrderALLData([]);

//   //     const payload = {
//   //       TechnicalUID: Proid,
//   //       WorkOrderType: workOrderType,
//   //     };

//   //     let res = await GetBudgetHeadInfo(payload, "GetSpecificWorkUIDfromTable");

//   //     if (!res || res.length === 0) {
//   //       console.warn("No work orders found");
//   //       return;
//   //     }

//   //     setWorkOrderALLData(res);

//   //     const uniqueWorkOrderNo = [...new Set(res.map((item) => item.WorkName))];
//   //     setWorkOrderIDData(uniqueWorkOrderNo);

//   //     // ✅ Auto-fill for New Work Order
//   //     if (workOrderType === "New Work Order" && res.length > 0) {
//   //       const latestWork = res[0];

//   //       // ✅ Store WorkOrderID when auto-filled
//   //       setSelectedWorkOrderID(latestWork.WorkOrderID || null);

//   //       setData((prev) => ({
//   //         ...prev,
//   //         WorkName: latestWork.WorkName || "",
//   //         WorkOrderUnique: latestWork.WorkName || "",
//   //         physicalValue: String(latestWork.physicalValue || ""),
//   //         talulka: latestWork.ZillaParishad || prev.talulka,
//   //       }));

//   //       if (latestWork.ZillaParishad) {
//   //         setTaluka((prev) => [...new Set([...prev, latestWork.ZillaParishad])]);
//   //       }
//   //     }
//   //   } catch (err) {
//   //     console.log("sortDatabyTechnicalID error :: ", err);
//   //   }
//   // };

//   // ✅ Trigger Existing Work Order fetch when HeadCode + Year + Zilla are all set
//   useEffect(() => {
//     if (
//       workOrderType === "Existing Work Order" &&
//       data.HeadCode &&
//       data.ProposalYear &&
//       data.talulka &&
//       data.ulb
//     ) {
//       sortDatabyTechnicalID_withParams(
//         data.HeadCode,
//         data.ProposalYear,
//         data.talulka,
//       );
//     }
//   }, [workOrderType, data.HeadCode, data.ProposalYear, data.talulka, data.ulb]);

//   // ✅ FIXED: Auto-trigger vendor fetch for BOTH New and Existing Work Orders
//   useEffect(() => {
//     if (
//       selectedWorkOrderID &&
//       data.physicalValue &&
//       WorkOrderAllData.length > 0 &&
//       VendorDetail.length === 0 // only if vendor not already loaded
//     ) {
//       const matchedWork = WorkOrderAllData.find(
//         (item) => String(item.WorkOrderID) === String(selectedWorkOrderID),
//       );
//       SetRabillValue(matchedWork?.RABillNumber || "");
//       console.log("WorkOrderAllData", WorkOrderAllData);
//       console.log("RABillNumber", matchedWork);
//       if (matchedWork) {
//         console.log(
//           "Auto-triggering autoFetchVendorForExisting for:",
//           selectedWorkOrderID,
//         );
//         autoFetchVendorForExisting(matchedWork, WorkOrderAllData);
//       }
//     }
//   }, [selectedWorkOrderID, data.physicalValue, WorkOrderAllData]);

//   useEffect(() => {
//     if (!data.BillAmount) return;

//     const billAmount = parseFloat(data.BillAmount);
//     const remaining = parseFloat(RemainingAmount || 0);

//     if (billAmount > remaining) {
//       alert("Enter Net Amount Less than Remaining Amount");
//       setData((prev) => ({ ...prev, BillAmount: prev.BillAmount }));
//       return;
//     }
//   }, [data.BillAmount]);

//   useEffect(() => {
//     if (deductionAmount < 0) {
//       alert("Deduction Amount cannot be negative !!");
//       setDeductionAmount("");
//       setDeductionPercent("");
//       return;
//     }
//   }, [deductionAmount]);

//   const CheckTotalEstimationAmt = (TotalEstimateAmount) => {
//     if (
//       !TotalEstimateAmount ||
//       TotalEstimateAmount === 0 ||
//       TotalEstimateAmount === null ||
//       TotalEstimateAmount === undefined
//     ) {
//       return "No Limit Allocation Cost Found";
//     }
//     return parseFloat(TotalEstimateAmount).toFixed(2) || 0;
//   };

//   const processFile = (file) => {
//     return new Promise(async (resolve, reject) => {
//       try {
//         const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
//         const pdfTypes = ["application/pdf"];

//         if (imageTypes.includes(file.type)) {
//           const exifData = await exifr.parse(file, [
//             "GPSLatitude",
//             "GPSLongitude",
//           ]);
//           if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
//             console.warn(
//               `⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`,
//             );
//           }

//           const reader = new FileReader();
//           reader.onload = (e) => {
//             const img = new Image();
//             img.onload = () => {
//               const canvas = document.createElement("canvas");
//               canvas.width = img.width;
//               canvas.height = img.height;
//               const ctx = canvas.getContext("2d");
//               ctx.drawImage(img, 0, 0);
//               canvas.toBlob((blob) => {
//                 const cleanedFile = new File([blob], file.name, {
//                   type: file.type,
//                 });
//                 resolve(cleanedFile);
//               }, file.type);
//             };
//             img.onerror = reject;
//             img.src = e.target.result;
//           };
//           reader.onerror = reject;
//           reader.readAsDataURL(file);
//           return;
//         }

//         if (pdfTypes.includes(file.type)) {
//           const reader = new FileReader();
//           reader.onload = (e) => {
//             const arrayBuffer = e.target.result;
//             const uint8Array = new Uint8Array(arrayBuffer);
//             const textContent = new TextDecoder("latin1").decode(uint8Array);

//             const dangerousPatterns = [
//               /\/JavaScript\s*<</,
//               /\/JS\s*\(/,
//               /\/AA\s*<</,
//               /\/OpenAction\s*<</,
//               /\/Launch\s*<</,
//               /\/RichMedia\s*<</,
//             ];

//             const isMalicious = dangerousPatterns.some((pattern) =>
//               pattern.test(textContent),
//             );

//             if (isMalicious) {
//               alert(
//                 `⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`,
//               );
//               return reject(new Error("Malicious PDF detected"));
//             }

//             resolve(file);
//           };
//           reader.onerror = reject;
//           reader.readAsArrayBuffer(file);
//           return;
//         }

//         resolve(file);
//       } catch (error) {
//         console.error("Error processing file:", error);
//         reject(error);
//       }
//     });
//   };

//   const handleBillfile = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const validation = validateFile(file, 2);

//     if (!validation.valid) {
//       alert(validation.message);
//       e.target.value = "";
//       return;
//     }

//     setFileProcessing(true);
//     try {
//       const cleaned = await processFile(file);
//       setProcessedProposalCopy(cleaned);
//     } catch (err) {
//       console.error("Error processing ProposalCopy:", err);
//       alert("Invalid Proposal Copy file. Please choose a different file.");
//       e.target.value = "";
//       setProcessedProposalCopy(null);
//     } finally {
//       setFileProcessing(false);
//     }
//   };
//   const [workOrderData, setWorkOrderData] = useState(null);

//   const handleRABillChange = async (e) => {
//     const value = e.target.value;

//     try {
//       let response = await GetWorkDetailbyworkID(selectedWorkOrderID);
//       // const billData = response?.message;
//       const billData = Array.isArray(response?.message) ? response.message : [];
//       console.log(response);
//       // ✅ Allow Final directly without condition
//       if (value === "Final") {
//         setWorkOrderData(billData);

//         setData((prev) => ({
//           ...prev,
//           RABillAmount: value,
//         }));

//         return;
//       }
//       if (parseFloat(data.physicalValue) === 100) {
//         if (value !== "Final") {
//           alert("Physical Progress is 100%, please select Final RA Bill");
//           return;
//         }

//         setWorkOrderData(billData);

//         setData((prev) => ({
//           ...prev,
//           RABillAmount: "Final",
//         }));

//         return;
//       }
//       // No previous bill created
//       // if (!RAbillValue && value !== "1st") {
//       //   alert("Please create 1st RA Bill first");
//       //   return;
//       // }

//       // 1st -> allow only 2nd
//       // if (RAbillValue === "1st") {
//       //   if (value !== "2nd") {
//       //     alert("Please create 2nd RA Bill first");
//       //     return;
//       //   }

//       //   setWorkOrderData(billData);
//       // }

//       // 2nd -> allow only 3rd
//       // if (RAbillValue === "2nd") {
//       //   if (value !== "3rd") {
//       //     alert("Please create 3rd RA Bill first");
//       //     return;
//       //   }

//       //   setWorkOrderData(billData);
//       // }

//       // SET SELECT VALUE
//       setData((prev) => ({
//         ...prev,
//         RABillAmount: value,
//       }));
//     } catch (error) {
//       console.log(error);

//       alert("Failed to fetch work order details");
//     }
//   };

//   //--> new added
//   useEffect(() => {
//     if (
//       workOrderType === "New Work Order" &&
//       data.HeadCode &&
//       data.ProposalYear &&
//       data.talulka
//     ) {
//       sortDataByGrnID_withParams(
//         data.ProposalYear,
//         data.HeadCode,
//         data.talulka,
//       );
//     }
//   }, [workOrderType, data.HeadCode, data.ProposalYear, data.talulka]);
//   return (
//     <>
//       <div
//         className="col-12"
//         style={{
//           backgroundColor: "#EFF3F8",
//           overflowY: "scroll",
//           height: "90vh",
//         }}
//       >
//         <div className="col-12 m-auto my-5 budgetContainer">
//           <div className="m-auto DemandElement">
//             {loading && (
//               <div
//                 style={{
//                   position: "fixed",
//                   top: 0,
//                   left: 0,
//                   width: "100%",
//                   height: "100%",
//                   background: "rgba(255, 255, 255, 0.7)",
//                   backdropFilter: "blur(4px)",
//                   zIndex: 9999,
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     border: "6px solid #f3f3f3",
//                     borderTop: "6px solid #007bff",
//                     borderRadius: "50%",
//                     width: "60px",
//                     height: "60px",
//                     animation: "spin 1s linear infinite",
//                   }}
//                 />
//                 <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
//               </div>
//             )}

//             <div className="row px-1 mb-4 mt-3">
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <img
//                   src="/Bill-files64.png"
//                   alt="TechnicalSanction"
//                   style={{ width: "32px", height: "32px" }}
//                   className="my-auto me-2"
//                 />
//                 <h3 className="text-left fw-bold mt-2">{t("Bill Maker")}</h3>
//               </div>
//               <div className="col-12 mt-4">
//                 <p
//                   className="py-2 ps-1 fw-bold text-danger"
//                   style={{ backgroundColor: "#FBE7E7" }}
//                 >
//                   {t("Note : Fields marked with * are mandatory")}
//                 </p>
//               </div>
//             </div>

//             <form action="">
//               {/* ── Work Order Type ── */}
//               <div className="col-12 elements mb-1 p-0">
//                 <div className="row g-0 p-0 m-0">
//                   <div className="col-3 my-auto">
//                     <label>
//                       Work Order Type <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <select
//                       value={workOrderType}
//                       className="py-2"
//                       onChange={(e) => {
//                         setWorkOrderType(e.target.value);
//                         setData((prev) => ({
//                           ...prev,
//                           TechnicalSanctionUID: "",
//                           WorkUID: "",
//                           WorkOrderUnique: "",
//                           ProposalId: "",
//                           physicalValue: "",
//                         }));
//                         setVendorDetail([]);
//                         resetExtensionState();
//                         setWorkOrderIDData([]);
//                         setWorkOrderALLData([]);
//                         setProposalID([]);
//                       }}
//                     >
//                       <option value="" disabled>
//                         Select Work Order Type
//                       </option>
//                       <option value="New Work Order">New Work Order</option>
//                       <option value="Existing Work Order">
//                         Existing Work Order
//                       </option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* ── Head Code ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3 my-auto">
//                     <label className="my-auto">
//                       {t("Head Code")}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <select
//                       name="HeadCode"
//                       value={data.HeadCode}
//                       className="py-2"
//                       onChange={(e) => {
//                         HandleChangeData(e);
//                         FetchDataRelatedtoZilla(e.target.value);
//                       }}
//                       required
//                     >
//                       <option value="" disabled>
//                         {t("Choose Head Code")}
//                       </option>
//                       {HeadCode &&
//                         HeadCode.map((val, index) => (
//                           <option key={index} value={val.HeadID}>
//                             {val.HeadName}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* ── Approved Year ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Approved Year")}{" "}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <select
//                       name="ProposalYear"
//                       value={data.ProposalYear}
//                       className="py-2"
//                       onChange={(e) => {
//                         HandleChangeData(e);
//                         sortDatabyProposalYear(e.target.value);
//                       }}
//                       style={{
//                         fontWeight: "500",
//                         padding: "8px",
//                         borderRadius: "4px",
//                         backgroundColor: "#fff",
//                       }}
//                     >
//                       <option value="" disabled>
//                         {t("Choose Approved Year")}
//                       </option>
//                       {workOrderType === "Existing Work Order" ? (
//                         <>
//                           <option value="2019-2020" disabled>2019 - 2020</option>
//                           <option value="2020-2021">2020 - 2021</option>
//                           <option value="2021-2022">2021 - 2022</option>
//                           <option value="2022-2023">2022 - 2023</option>
//                           <option value="2023-2024">2023 - 2024</option>
//                           <option value="2024-2025">2024 - 2025</option>
//                           <option value="2025-2026">2025 - 2026</option>
//                           {/* <option value="2026-2027">2026 - 2027</option> */}
//                            {(loginDistrict === "सोलापूर" ||
//                             loginDistrict?.startsWith("सोलापूर-")) && (
//                             <option value="2026-2027">2026 - 2027</option>
//                           )}
//                         </>
//                       ) : workOrderType === "New Work Order" ? (
//                         <>
//                           <option value="2025-2026">2025 - 2026</option>
//                           <option value="2026-2027">2026 - 2027</option>
//                           {/* {(loginDistrict === "सोलापूर" ||
//                             loginDistrict?.startsWith("सोलापूर-")) && (
//                             <option value="2026-2027">2026 - 2027</option>
//                           )} */}
//                         </>
//                       ) : null}
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* ── Zilla Parishad ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Zilla Parishad")}{" "}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       name="talulka"
//                       value={data.talulka || ""}
//                       placeholder={t("Auto-filled from your login")}
//                       readOnly
//                       style={{
//                         backgroundColor: "#f0f4ff",
//                         color: "#3b409e",
//                         fontWeight: "600",
//                         cursor: "not-allowed",
//                         border: "1px solid #b0bfff",
//                         borderRadius: "6px",
//                         padding: "8px 12px",
//                         width: "100%",
//                       }}
//                     />
//                     {/* <select
//                       name="talulka"
//                       value={data.talulka}
//                       className="py-2"
//                       onChange={(e) => {
//                         HandleChangeData(e);
//                         const selectedZilla = e.target.value;

//                         if (data.ProposalYear && data.HeadCode) {
//                           if (workOrderType === "New Work Order") {
//                             sortDataByGrnID_withParams(
//                               data.ProposalYear,
//                               data.HeadCode,
//                               selectedZilla,
//                             );
//                           }
//                           // if (workOrderType === "Existing Work Order") {
//                           //   sortDatabyTechnicalID_withParams(
//                           //     data.HeadCode,
//                           //     data.ProposalYear,
//                           //     selectedZilla,
//                           //   );
//                           // }
//                         }
//                       }}
//                       required
//                     >
//                       <option value="" disabled>
//                         {t("Select Zilla Parishad")}
//                       </option>
//                       {taluka &&
//                         taluka.map((val, index) => (
//                           <option value={val} key={index}>
//                             {val}
//                           </option>
//                         ))}
//                     </select>  */}
//                   </div>
//                 </div>
//               </div>

//               {/* ── Taluka (ULB) ── */}
//               {(workOrderType === "New Work Order" ||
//                 workOrderType === "Existing Work Order") &&
//                 data.talulka && (
//                   <div className="col-12 elements">
//                     <div className="row">
//                       <div className="col-3">
//                         <label>
//                           {t("Taluka")} <span style={{ color: "red" }}>*</span>
//                         </label>
//                       </div>
//                       <div className="col-7">
//                         <select
//                           name="taluka"
//                           value={data.ulb}
//                           className="py-2"
//                           onChange={(e) => {
//                             const selectedTaluka = e.target.value;

//                             setData((prev) => ({
//                               ...prev,
//                               ulb: selectedTaluka,
//                               TechnicalSanctionUID: "",
//                               WorkOrderUnique: "",
//                               WorkName: "",
//                               physicalValue: "",
//                               RABillAmount: "",
//                             }));
//                             setVendorDetail([]);
//                             resetExtensionState();
//                             setWorkOrderData(null);
//                             setProposalID([]);
//                             setWorkOrderIDData([]);
//                             setWorkOrderALLData([]);

//                             // ✅ Filter MHUIDs by Zilla + Taluka for New Work Order
//                             if (
//                               workOrderType === "New Work Order" &&
//                               data.ProposalYear &&
//                               data.HeadCode
//                             ) {
//                               const filtered = FetchedFData.filter(
//                                 (item) =>
//                                   item.ProposalYear === data.ProposalYear &&
//                                   item.ZillaParishad === data.talulka &&
//                                   item.HeadCode === data.HeadCode &&
//                                   item.Taluka === selectedTaluka, // ✅ filter by ULB Taluka
//                               );
//                               const uniqueMHUIDs = [
//                                 ...new Set(
//                                   filtered.map(
//                                     (item) => item.TechnicalSanctionNo,
//                                   ),
//                                 ),
//                               ];
//                               setProposalID(uniqueMHUIDs);
//                             }

//                             // ✅ Filter Work Names by Taluka for Existing Work Order
//                             if (
//                               workOrderType === "Existing Work Order" &&
//                               data.ProposalYear &&
//                               data.HeadCode
//                             ) {
//                               sortDatabyTechnicalID_withParams(
//                                 data.HeadCode,
//                                 data.ProposalYear,
//                                 data.talulka,
//                                 selectedTaluka,
//                               );
//                             }
//                           }}
//                           required
//                         >
//                           <option value="">{t("Select Taluka")}</option>
//                           {ulbList &&
//                             [
//                               ...new Set(
//                                 ulbList
//                                   .filter(
//                                     (item) =>
//                                       item.District_Marathi === data.talulka,
//                                   ) // ✅ filter by selected Zilla
//                                   .map((val) => val.ULBNameMarathi),
//                               ),
//                             ].map((ULBNameMarathi, index) => (
//                               <option key={index} value={ULBNameMarathi}>
//                                 {ULBNameMarathi}
//                               </option>
//                             ))}
//                         </select>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//               {/* ── MHUID Number (Searchable Dropdown) ── */}
//               {workOrderType !== "Existing Work Order" && (
//                 <div className="col-12 elements">
//                   <div className="row">
//                     <div className="col-3">
//                       <label>
//                         {t("MHUID Number")}{" "}
//                         <span style={{ color: "red" }}>*</span>
//                       </label>
//                     </div>

//                     <div className="col-7">
//                       <Select
//                         options={
//                           ProposalID?.map((val) => ({
//                             value: val,
//                             label: val,
//                           })) || []
//                         }
//                         value={
//                           data.TechnicalSanctionUID
//                             ? {
//                                 value: data.TechnicalSanctionUID,
//                                 label: data.TechnicalSanctionUID,
//                               }
//                             : null
//                         }
//                         onChange={(selectedOption) => {
//                           const value = selectedOption?.value || "";

//                           HandleChangeData({
//                             target: {
//                               name: "TechnicalSanctionUID",
//                               value,
//                             },
//                           });

//                           sortDatabyTechnicalID(value);
//                         }}
//                         placeholder={t("Search MHUID Number")}
//                         isSearchable
//                         className="basic-single"
//                         classNamePrefix="select"
//                         noOptionsMessage={() => "No MHUID Found"}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* ── Work Name ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Work Name")} <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     {workOrderType === "New Work Order" ? (
//                       // ✅ New Work Order: read-only, auto-filled from MHUID
//                       <input
//                         type="text"
//                         name="WorkOrderUnique"
//                         value={data.WorkOrderUnique || ""}
//                         placeholder={t("Auto-filled on MHUID selection")}
//                         readOnly
//                         style={{
//                           backgroundColor: "#f0f4ff",
//                           color: "#3b409e",
//                           fontWeight: "600",
//                           cursor: "not-allowed",
//                           border: "1px solid #b0bfff",
//                           borderRadius: "6px",
//                           padding: "8px 12px",
//                           width: "100%",
//                         }}
//                       />
//                     ) : (
//                       // ✅ Existing Work Order: dropdown — auto-fetches physicalValue + vendor on select
//                       <select
//                         name="WorkOrderUnique"
//                         value={selectedWorkOrderID || ""}
//                         className="py-2"
//                         onChange={async (e) => {
//                           const selectedWorkOrderID = e.target.value; // ✅ now this is WorkOrderID (numeric)

//                           // Find the exact work by WorkOrderID — no name collision possible
//                           const matchedWork = WorkOrderAllData.find(
//                             (item) =>
//                               String(item.WorkOrderID) ===
//                               String(selectedWorkOrderID),
//                           );

//                           console.log("matchedWork********", matchedWork);

//                           if (!matchedWork) return;

//                           // ✅ Store WorkOrderID immediately
//                           setSelectedWorkOrderID(matchedWork.WorkOrderID);
//                           // ✅ Store WorkName for display and backend WorkOrderUnique field
//                           setSelectedWorkDisplayName(matchedWork.WorkName);

//                           // reset first
//                           setData((prev) => ({
//                             ...prev,
//                             WorkOrderUnique: matchedWork.WorkName, // keep WorkName for display
//                             physicalValue: "",
//                             RABillAmount: "",
//                           }));

//                           setVendorDetail([]);
//                           resetExtensionState();
//                           setWorkOrderData(null);

//                           // ✅ Fetch existing bills using WorkOrderID — not WorkName
//                           const response = await GetWorkDetailbyworkID(
//                             matchedWork.WorkOrderID,
//                           );
//                           console.log(
//                             "GetWorkDetailbyworkID response:",
//                             response,
//                           );
//                           const billData = response?.message || [];

//                           console.log("billData sample:", billData[0]);

//                           // Check duplicate physical progress
//                           const alreadyExists = billData.some(
//                             (item) =>
//                               Number(item.physicalValueOfProgress) ===
//                               Number(matchedWork.physicalValue),
//                           );

//                           console.log("alreadyExists:", alreadyExists);
//                           console.log(
//                             "matchedWork.physicalValue:",
//                             matchedWork.physicalValue,
//                           );

//                           if (alreadyExists) {
//                             alert(
//                               `Bill already created for Physical Progress ${matchedWork.physicalValue}%`,
//                             );
//                             setSelectedWorkDisplayName("");
//                             setSelectedWorkOrderID(null); // ✅ reset
//                             setData((prev) => ({
//                               ...prev,
//                               WorkOrderUnique: "",
//                               physicalValue: "",
//                               RABillAmount: "",
//                             }));
//                             return;
//                           }

//                           setData((prev) => ({
//                             ...prev,
//                             WorkOrderUnique: matchedWork.WorkName,
//                             physicalValue: String(
//                               matchedWork.physicalValue || "",
//                             ),
//                             RABillAmount: "",
//                           }));

//                           await autoFetchVendorForExisting(
//                             matchedWork,
//                             WorkOrderAllData,
//                           );
//                         }}
//                         required
//                       >
//                         <option value="">{t("Choose Work Name")}</option>
//                         {WorkOrderIDData &&
//                           WorkOrderIDData.map((item, index) => (
//                             // ✅ value = WorkOrderID (unique), label = WorkName (human readable)
//                             <option key={index} value={item.WorkOrderID}>
//                               {item.WorkName} - {item.WorkOrderID}
//                             </option>
//                           ))}
//                       </select>

//                       //-->old code

//                       //                       <select
//                       //                         name="WorkOrderUnique"
//                       //                         value={data.WorkOrderUnique}
//                       //                         className="py-2"
//                       //                         // onChange={(e) => {
//                       //                         //   const selectedWorkName = e.target.value;

//                       //                         //   // ✅ Directly update without triggering cascading reset
//                       //                         //   setData((prev) => ({
//                       //                         //     ...prev,
//                       //                         //     WorkOrderUnique: selectedWorkName,
//                       //                         //     physicalValue: "",
//                       //                         //     RABillAmount: " ", // reset first, auto-filled below
//                       //                         //   }));
//                       //                         //   setVendorDetail([]);
//                       //                         //   setWorkOrderData(null);
//                       //                         //   const matchedWork = WorkOrderAllData.find(
//                       //                         //     (item) =>
//                       //                         //       String(item.WorkName) ===
//                       //                         //       String(selectedWorkName),
//                       //                         //   );

//                       //                         //   if (matchedWork) {
//                       //                         //     // ✅ auto-fill physicalValue immediately
//                       //                         //     setData((prev) => ({
//                       //                         //       ...prev,
//                       //                         //       WorkOrderUnique: selectedWorkName,
//                       //                         //       physicalValue: String(
//                       //                         //         matchedWork.physicalValue || "",
//                       //                         //       ),
//                       //                         //       RABillAmount: "",
//                       //                         //     }));
//                       //                         //     // ✅ auto-fetch vendor details
//                       //                         //     autoFetchVendorForExisting(
//                       //                         //       matchedWork,
//                       //                         //       WorkOrderAllData,
//                       //                         //     );
//                       //                         //   }
//                       //                         // }}
//                       //                         onChange={async (e) => {
//                       //   const selectedWorkName = e.target.value;

//                       //   // reset first
//                       //   setData((prev) => ({
//                       //     ...prev,
//                       //     WorkOrderUnique: selectedWorkName,
//                       //     physicalValue: "",
//                       //     RABillAmount: "",
//                       //   }));

//                       //   setVendorDetail([]);
//                       //   setWorkOrderData(null);

//                       //   const matchedWork = WorkOrderAllData.find(
//                       //     (item) =>
//                       //       String(item.WorkName) === String(selectedWorkName)
//                       //   );

//                       //   if (matchedWork) {

//                       //     // ✅ Fetch existing bills
//                       //     const response = await GetWorkDetailbyworkID(
//                       //       matchedWork.WorkName
//                       //     );

//                       //     const billData = response?.message || [];

//                       //     // ✅ Check duplicate physical progress
//                       //     const alreadyExists = billData.some(
//                       //       (item) =>
//                       //         Number(item.physicalValueOfProgress) ===
//                       //         Number(matchedWork.physicalValue)
//                       //     );

//                       //     if (alreadyExists) {
//                       //       alert(
//                       //         `Bill already created for Physical Progress ${matchedWork.physicalValue}%`
//                       //       );

//                       //       setData((prev) => ({
//                       //         ...prev,
//                       //         WorkOrderUnique: "",
//                       //         physicalValue: "",
//                       //         RABillAmount: "",
//                       //       }));

//                       //       return;
//                       //     }

//                       //     // ✅ Allow only new physical progress
//                       //     setData((prev) => ({
//                       //       ...prev,
//                       //       WorkOrderUnique: selectedWorkName,
//                       //       physicalValue: String(
//                       //         matchedWork.physicalValue || ""
//                       //       ),
//                       //       RABillAmount: "",
//                       //     }));

//                       //     // ✅ Fetch vendor details
//                       //     autoFetchVendorForExisting(
//                       //       matchedWork,
//                       //       WorkOrderAllData,
//                       //     );
//                       //   }
//                       // }}
//                       //                         required
//                       //                       >
//                       //                         <option value="">{t("Choose Work Name")}</option>
//                       //                         {WorkOrderIDData &&
//                       //                           WorkOrderIDData.map((val, index) => (
//                       //                             <option key={index} value={val}>
//                       //                               {val}
//                       //                             </option>
//                       //                           ))}
//                       //                       </select>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* ── Physical Progress — read-only for BOTH types ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Physical Progress In %")}{" "}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     {/* ✅ Both New and Existing: auto-filled, read-only */}
//                     <input
//                       type="text"
//                       name="physicalValue"
//                       value={data.physicalValue ? `${data.physicalValue}%` : ""}
//                       placeholder={
//                         workOrderType === "New Work Order"
//                           ? t("Auto-filled on MHUID selection")
//                           : t("Auto-filled on Work Name selection")
//                       }
//                       readOnly
//                       style={{
//                         backgroundColor: "#f0f4ff",
//                         color: "#3b409e",
//                         fontWeight: "600",
//                         cursor: "not-allowed",
//                         border: "1px solid #b0bfff",
//                         borderRadius: "6px",
//                         padding: "8px 12px",
//                         width: "100%",
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {isWorkOrderExpired && (
//                 <div className="col-12 elements">
//                   <div className="row">
//                     <div className="col-12">
//                       <div
//                         className="p-3 mb-3"
//                         style={{
//                           backgroundColor: "#FBE7E7",
//                           border: "1px solid #dc3545",
//                           borderRadius: "6px",
//                         }}
//                       >
//                         <p className="fw-bold text-danger mb-1">
//                           ⚠️{" "}
//                           {t(
//                             "Bill Submission Deadline has passed for this Approval Year",
//                           )}
//                           {workOrderEndDateValue
//                             ? ` (${new Date(workOrderEndDateValue).toLocaleDateString("en-GB")})`
//                             : ""}
//                         </p>
//                         <p
//                           className="mb-0"
//                           style={{ fontSize: "13px", color: "#333" }}
//                         >
//                           {t(
//                             "This requires offline approval from the State. Please upload the State-approved Extension Order copy from the 'Work Order Outwards' module to continue with the bill creation process.",
//                           )}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   {hasExistingExtension && (
//                     <div className="row">
//                       <div className="col-12">
//                         <p
//                           style={{ fontSize: "13px", color: "#28a745" }}
//                           className="fw-bold"
//                         >
//                           ✅{" "}
//                           {t(
//                             "Extension Order already approved for this Work Order.",
//                           )}
//                         </p>
//                          <p className="mb-0" style={{ fontSize: "13px", color: "#333" }}>
//             {t(
//               "Note: Therefore, we hereby confirm that you have successfully completed the offline extension process and have uploaded the requisite Extension Order copy through the Work Order Outwards module." 
//             )}
//           </p>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* ── Vendor Detail Table ── */}
//               {VendorDetail.length > 0 && (
//                 <div className="col-12 my-3">
//                   <div className="row">
//                     <div className="col-12">
//                       <div className="tableContainer m-auto">
//                         <table>
//                           <thead>
//                             <tr>
//                               <th style={{ width: "15%", textAlign: "start" }}>
//                                 {t("Vendor Name")}
//                               </th>
//                               <th style={{ width: "20%", textAlign: "start" }}>
//                                 {t("Work Approve Amount")}
//                               </th>
//                               <th style={{ width: "15%", textAlign: "start" }}>
//                                 {t("Remaining Amount")}
//                               </th>
//                               <th style={{ width: "15%", textAlign: "start" }}>
//                                 {t("Bank Name")}
//                               </th>
//                               <th style={{ width: "15%", textAlign: "start" }}>
//                                 {t("Bank Account Number")}
//                               </th>
//                               <th style={{ width: "10%", textAlign: "start" }}>
//                                 {t("Bank IFSC")}
//                               </th>
//                               <th style={{ width: "15%", textAlign: "start" }}>
//                                 {t("Bank Branch Name")}
//                               </th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {VendorDetail?.length > 0 ? (
//                               VendorDetail?.map((val, index) => (
//                                 <tr key={index}>
//                                   <td style={{ textAlign: "start" }}>
//                                     {val?.ContractorName}
//                                   </td>
//                                   <td style={{ textAlign: "start" }}>
//                                     {val.ApprovedWorkAmount}
//                                   </td>
//                                   <td style={{ textAlign: "start" }}>
//                                     {parseFloat(val.RemainingAmount).toFixed(
//                                       2,
//                                     ) || 0}
//                                   </td>
//                                   <td style={{ textAlign: "start" }}>
//                                     {val.BANK_NAME}
//                                   </td>
//                                   <td style={{ textAlign: "start" }}>
//                                     {val.Account_Number}
//                                   </td>
//                                   <td style={{ textAlign: "start" }}>
//                                     {val.IFSC_CODE}
//                                   </td>
//                                   <td style={{ textAlign: "start" }}>
//                                     {val.BranchName}
//                                   </td>
//                                 </tr>
//                               ))
//                             ) : (
//                               <tr>
//                                 <td colSpan="7">{t("No Data Found")}</td>
//                               </tr>
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* ── Construction Amount ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Bill Amount")} <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="number"
//                       name="BillAmount"
//                       placeholder={t("Enter Amount")}
//                       value={data.BillAmount}
//                       onChange={(e) => {
//                         let value = e.target.value;

//                         // ✅ allow clearing the field — don't force back to 0
//                         if (value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             BillAmount: "",
//                             TotalBillAmount: calculateTotal(
//                               "",
//                               data.GST,
//                               data.Royalty,
//                               data.SQMCharges,
//                             ),
//                           }));
//                           return;
//                         }

//                         if (Number(value) <= 0) {
//                           value = 0;
//                         }

//                         const totalAmt = calculateTotal(
//                           value,
//                           data.GST,
//                           data.Royalty,
//                           data.SQMCharges,
//                         );

//                         if (totalAmt > remaining) {
//                           alert(
//                             "Total Bill Amount cannot exceed Remaining Amount",
//                           );
//                           value = 0;
//                         }

//                         setData((prev) => ({
//                           ...prev,
//                           BillAmount: value,
//                           TotalBillAmount: calculateTotal(
//                             value,
//                             data.GST,
//                             data.Royalty,
//                             data.SQMCharges,
//                           ),
//                         }));
//                       }}
//                       onBlur={(e) => {
//                         let value = parseFloat(e.target.value || 0);
//                         if (value < 0) {
//                           alert("Enter Bill Amount greater than 0!");
//                           value = 0;
//                         } else if (value > remaining) {
//                           alert("Enter Bill Amount less than Remaining Amount");
//                           value = remaining;
//                         }
//                         setData((prev) => ({
//                           ...prev,
//                           BillAmount: value.toFixed(2),
//                         }));
//                       }}
//                       disabled={totalDeductionAmount > 0}
//                       required
//                       onKeyDown={(e) => {
//                         // Prevent minus, plus, decimal and exponent
//                         if (["-", "+", "e", "E"].includes(e.key)) {
//                           e.preventDefault();
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── GST ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("GST")} <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       min={0}
//                       type="number"
//                       placeholder={t("Enter GST")}
//                       name="GST"
//                       value={data.GST}
//                       onChange={(e) => {
//                         let value = e.target.value;

//                         // ✅ allow clearing
//                         if (value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             GST: "",
//                             TotalBillAmount: calculateTotal(
//                               data.BillAmount,
//                               "",
//                               data.Royalty,
//                               data.SQMCharges,
//                             ),
//                           }));
//                           return;
//                         }

//                         if (Number(value) <= 0) {
//                           value = 0;
//                         }

//                         const totalAmt = calculateTotal(
//                           data.BillAmount,
//                           value,
//                           data.Royalty,
//                           data.SQMCharges,
//                         );

//                         if (totalAmt > remaining) {
//                           alert(
//                             "Total Bill Amount cannot exceed Remaining Amount",
//                           );
//                           value = 0;
//                         }

//                         setData((prev) => ({
//                           ...prev,
//                           GST: value,
//                           TotalBillAmount: calculateTotal(
//                             data.BillAmount,
//                             value,
//                             data.Royalty,
//                             data.SQMCharges,
//                           ),
//                         }));
//                       }}
//                       onBlur={(e) => {
//                         // ✅ revert empty field to 0 on outside click
//                         if (e.target.value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             GST: 0,
//                             TotalBillAmount: calculateTotal(
//                               data.BillAmount,
//                               0,
//                               data.Royalty,
//                               data.SQMCharges,
//                             ),
//                           }));
//                         }
//                       }}
//                       onKeyDown={(e) => {
//                         // Prevent minus, plus, decimal and exponent
//                         if (["-", "+", "e", "E"].includes(e.key)) {
//                           e.preventDefault();
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Royalty ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>{t("Royalty")}</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       min={0}
//                       type="number"
//                       placeholder={t("Enter Royalty")}
//                       name="Royalty"
//                       value={data.Royalty}
//                       onChange={(e) => {
//                         let value = e.target.value;

//                         // ✅ allow clearing
//                         if (value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             Royalty: "",
//                             TotalBillAmount: calculateTotal(
//                               data.BillAmount,
//                               data.GST,
//                               "",
//                               data.SQMCharges,
//                             ),
//                           }));
//                           return;
//                         }

//                         if (Number(value) <= 0) {
//                           value = 0;
//                         }

//                         const totalAmt = calculateTotal(
//                           data.BillAmount,
//                           data.GST,
//                           value,
//                           data.SQMCharges,
//                         );

//                         if (totalAmt > remaining) {
//                           alert(
//                             "Total Bill Amount cannot exceed Remaining Amount",
//                           );
//                           value = 0;
//                         }

//                         setData((prev) => ({
//                           ...prev,
//                           Royalty: value,
//                           TotalBillAmount: calculateTotal(
//                             data.BillAmount,
//                             data.GST,
//                             value,
//                             data.SQMCharges,
//                           ),
//                         }));
//                       }}
//                       onBlur={(e) => {
//                         // ✅ revert empty field to 0 on outside click
//                         if (e.target.value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             Royalty: 0,
//                             TotalBillAmount: calculateTotal(
//                               data.BillAmount,
//                               data.GST,
//                               0,
//                               data.SQMCharges,
//                             ),
//                           }));
//                         }
//                       }}
//                       onKeyDown={(e) => {
//                         // Prevent minus, plus, decimal and exponent
//                         if (["-", "+", "e", "E"].includes(e.key)) {
//                           e.preventDefault();
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── SQM Charges ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>{t("Testing/SQM Charges")}</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       min={0}
//                       type="number"
//                       placeholder={t("Enter SQM Charges")}
//                       name="SQMCharges"
//                       value={data.SQMCharges}
//                       onChange={(e) => {
//                         let value = e.target.value;
//                         if (!/^\d*\.?\d{0,2}$/.test(value)) {
//                           return;
//                         }
//                         if (value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             SQMCharges: "",
//                             TotalBillAmount: calculateTotal(
//                               data.BillAmount,
//                               data.GST,
//                               data.Royalty,
//                               "",
//                             ),
//                           }));
//                           return;
//                         }

//                         if (Number(value) <= 0) {
//                           value = 0;
//                         }

//                         const totalAmt = calculateTotal(
//                           data.BillAmount,
//                           data.GST,
//                           data.Royalty,
//                           value,
//                         );

//                         if (totalAmt > remaining) {
//                           alert(
//                             "Total Bill Amount cannot exceed Remaining Amount",
//                           );
//                           value = 0;
//                         }

//                         setData((prev) => ({
//                           ...prev,
//                           SQMCharges: value,
//                           TotalBillAmount: calculateTotal(
//                             data.BillAmount,
//                             data.GST,
//                             data.Royalty,
//                             value,
//                           ),
//                         }));
//                       }}
//                       onKeyDown={(e) => {
//                         if (["-", "+", "e", "E"].includes(e.key)) {
//                           e.preventDefault();
//                         }
//                       }}
//                       onBlur={(e) => {
//                         if (e.target.value === "") {
//                           setData((prev) => ({
//                             ...prev,
//                             SQMCharges: 0,
//                             TotalBillAmount: calculateTotal(
//                               data.BillAmount,
//                               data.GST,
//                               data.Royalty,
//                               0,
//                             ),
//                           }));
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Total Bill Amount (auto-calculated, read-only) ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Total Bill Amount")}{" "}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       placeholder={t("Total Bill Amount")}
//                       name="TotalBillAmount"
//                       value={data.TotalBillAmount}
//                       readOnly
//                       style={{
//                         backgroundColor: "#f0f4ff",
//                         color: "#3b409e",
//                         fontWeight: "600",
//                         cursor: "not-allowed",
//                         border: "1px solid #b0bfff",
//                         borderRadius: "6px",
//                         padding: "8px 12px",
//                         width: "100%",
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── RA Bill Number ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("RA Bill Number")}{" "}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>

//                   <div className="col-7">
//                     <select
//                       name="RABillAmount"
//                       value={data.RABillAmount}
//                       className="py-2"
//                       onChange={handleRABillChange}
//                     >
//                       <option value="" disabled>
//                         {t("Select RA Bill Number")}
//                       </option>

//                       <option
//                         value="1st"
//                         disabled={
//                           RAbillValue === "1st" ||
//                           RAbillValue === "2nd" ||
//                           RAbillValue === "3rd" ||
//                           RAbillValue === "Final"
//                         }
//                       >
//                         1st
//                       </option>

//                       <option
//                         value="2nd"
//                         disabled={
//                           RAbillValue === "2nd" ||
//                           RAbillValue === "3rd" ||
//                           RAbillValue === "Final"
//                         }
//                       >
//                         2nd
//                       </option>

//                       <option
//                         value="3rd"
//                         disabled={
//                           RAbillValue === "3rd" || RAbillValue === "Final"
//                         }
//                       >
//                         3rd
//                       </option>

//                       <option value="Final" disabled={RAbillValue === "Final"}>
//                         Final
//                       </option>

//                       {/* <option value="1st">1st</option>
//                       <option value="2nd">2nd</option>
//                       <option value="3rd">3rd</option>
//                       <option value="Final">Final</option> */}
//                     </select>
//                   </div>
//                   {workOrderData && workOrderData.length > 0 && (
//                     <div className="tableContainer m-auto border-none">
//                       <table>
//                         <thead>
//                           <tr>
//                             <th style={{ padding: "10px" }}>Sr No</th>
//                             <th style={{ padding: "10px" }}>RA Bill</th>
//                             <th style={{ padding: "10px" }}>Project Name</th>
//                             <th style={{ padding: "10px" }}>Bill Amount</th>
//                             <th style={{ padding: "10px" }}>Net Payable</th>
//                             <th style={{ padding: "10px" }}>Deduction</th>
//                             <th style={{ padding: "10px" }}>Progress</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {workOrderData.map((item, index) => (
//                             <tr key={index} style={{}}>
//                               <td style={{ padding: "10px" }}>{index + 1}</td>

//                               <td style={{ padding: "10px" }}>
//                                 {item.RABillNumber}
//                               </td>

//                               <td style={{ padding: "10px" }}>
//                                 {item.ProjectName}
//                               </td>

//                               <td style={{ padding: "10px" }}>
//                                 ₹ {item.BillAmount}
//                               </td>

//                               <td style={{ padding: "10px" }}>
//                                 ₹ {item.NetPayableAmount}
//                               </td>

//                               <td style={{ padding: "10px" }}>
//                                 ₹ {item.DeductionAmount}
//                               </td>

//                               <td style={{ padding: "10px" }}>
//                                 {item.physicalValueOfProgress}%
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* ── Remark ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>{t("Remark")}</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       placeholder={t("Enter Remark")}
//                       name="Remark"
//                       value={data.Remark}
//                       onChange={(e) => {
//                         let value = e.target.value
//                           .replace(
//                             /[^a-zA-Z0-9\u0900-\u097F\s!@#$%^&*()_+=\-{}[\]:;"'<>,.?/\\|]/g,
//                             "",
//                           )
//                           .replace(/^\s+/, "");
//                         HandleChangeData({
//                           target: { name: e.target.name, value },
//                         });
//                       }}
//                       onBlur={(e) => {
//                         const value = e.target.value.trim();
//                         const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(
//                           value,
//                         );
//                         if (value && !hasValidChar) {
//                           setError("Enter at least one valid character");
//                           alert("Enter at least one valid character");
//                           setTimeout(() => e.target.focus(), 0);
//                         } else {
//                           setError("");
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Upload Bill Copy ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Upload Bill Copy")}{" "}
//                       <span style={{ color: "red" }}>*</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="file"
//                       className="form-control py-2"
//                       id="BillCopy"
//                       onChange={handleBillfile}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Measurement Book ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Measurement Book")}
//                       <span style={{ color: "red" }}> *</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="file"
//                       className="form-control py-2"
//                       id="Measurement_Book"
//                       onChange={handleBillfile}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Inspection Report ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("SQM Inspection Report")}{" "}
//                       <span style={{ color: "red" }}> *</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="file"
//                       className="form-control py-2"
//                       id="Inspection_Report"
//                       onChange={handleBillfile}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── Work Completion ── */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Work Completion Certificate")}{" "}
//                       {data.RABillAmount === "Final" && (
//                         <span style={{ color: "red" }}> *</span>
//                       )}
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="file"
//                       className="form-control py-2"
//                       id="Work_completion"
//                       onChange={handleBillfile}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* ── GR File (Existing Work Order only) ── */}
//               {/* {workOrderType === "Existing Work Order" && ( */}
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-3">
//                     <label>
//                       {t("Administrative Approved GR (AAGR)")}{" "}
//                       <span style={{ color: "red" }}> *</span>
//                     </label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="file"
//                       className="form-control py-2"
//                       id="UploadGR"
//                       onChange={handleBillfile}
//                       accept=".pdf,.jpg,.jpeg,.png"
//                     />
//                   </div>
//                 </div>
//               </div>
//               {/* )} */}

//               {/* ── Amount Summary ── */}
//               {/* <div className="col-12 elements">
//                 <div className="col-12 my-5">
//                   <div className="row">
//                     <div className="col-4 part1 py-2">
//                       <div className="row">
//                         <div className="col-7 my-auto">
//                           <p className="my-auto">{t("Net Bill Amount")} : </p>
//                         </div>
//                         <div className="col-5 my-auto">
//                           <p className="my-auto">
//                             <b>{data.BillAmount || 0}</b>
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-4 part1 py-2">
//                       <div className="row">
//                         <div className="col-7 my-auto">
//                           <p className="my-auto">
//                             {t("Net Payable Amount")} :{" "}
//                           </p>
//                         </div>
//                         <div className="col-5 my-auto">
//                           <p className="my-auto">
//                             <b>{netPayableAmount || 0}</b>
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-4 part1 py-2">
//                       <div className="row">
//                         <div className="col-8 my-auto">
//                           <p className="my-auto">
//                             {t("Total Deduction Amount")} :{" "}
//                           </p>
//                         </div>
//                         <div className="col-4 my-auto">
//                           <p className="my-auto">
//                             <b>{totalDeductionAmount.toFixed(2)}</b>
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div> */}

//               {/* ── Deduction Input Row ── */}
//               {/* <div className="row border p-4 rounded my-3 bg-light justify-content-center">
//                 <div className="col-md-3">
//                   <label className="fw-bold">{t("Deduction Type")}</label>
//                   <select
//                     className="form-control my-2"
//                     value={selectedDeductionID}
//                     onChange={(e) => {
//                       setSelectedDeductionID(e.target.value);
//                       changeselectedName(e.target.value);
//                     }}
//                   >
//                     <option value="">{t("Choose Deduction")}</option>
//                     {fetchDeductionData.map((val, idx) => (
//                       <option key={idx} value={val.DeductionID}>
//                         {val.UseFor}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="col-md-3">
//                   <label className="fw-bold">{t("Percentage")}</label>
//                   <input
//                     type="text"
//                     value={deductionPercent}
//                     disabled
//                     className="form-control text-center my-2"
//                   />
//                 </div>

//                 <div className="col-md-3">
//                   <label className="fw-bold">{t("Amount")}</label>
//                   <input
//                     type="number"
//                     className="form-control text-center my-2"
//                     value={deductionAmount || ""}
//                     onChange={(e) => {
//                       const amt = parseFloat(e.target.value || 0);
//                       const currentNetAmount = netPayableAmount;
//                       if (amt > currentNetAmount) {
//                         alert(
//                           `Deduction amount cannot exceed the Bill Amount (₹${currentNetAmount.toFixed(2)}).`,
//                         );
//                         setDeductionAmount(currentNetAmount);
//                         setDeductionPercent(100);
//                         return;
//                       }
//                       setDeductionAmount(amt);
//                       if (data.BillAmount > 0) {
//                         setDeductionPercent(
//                           ((amt / data.BillAmount) * 100).toFixed(2),
//                         );
//                       }
//                     }}
//                   />
//                 </div>

//                 <div className="col-md-2 d-flex align-items-end justify-content-center">
//                   <button
//                     className="btn btn-success rounded-pill px-4 fw-bold"
//                     style={{
//                       cursor: "pointer",
//                       color: "white",
//                       border: "none",
//                       padding: "6px 12px",
//                       borderRadius: "8px",
//                       fontSize: "14px",
//                       display: "inline-flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       gap: "4px",
//                       whiteSpace: "nowrap",
//                       marginBottom: "8px",
//                     }}
//                     onClick={(e) => deductionOperation(e)}
//                   >
//                     <img
//                       src="/Add-32.png"
//                       alt="add"
//                       style={{
//                         width: "13px",
//                         height: "13px",
//                         marginRight: "2px",
//                       }}
//                     />
//                     {t("ADD")}
//                   </button>
//                 </div>
//               </div> */}

//               {/* ── Deduction List Table ── */}
//               {/* {deductionList.length > 0 && (
//                 <div className="col-12 my-3">
//                   <div className="row">
//                     <div className="col-12">
//                       <div className="tableContainer m-auto">
//                         <table>
//                           <thead>
//                             <tr style={{ textAlign: "center" }}>
//                               <th style={{ width: "5%", textAlign: "center" }}>
//                                 {t("Sr.No")}
//                               </th>
//                               <th style={{ width: "5%", textAlign: "center" }}>
//                                 {t("Deduction Name")}
//                               </th>
//                               <th style={{ width: "15%", textAlign: "center" }}>
//                                 {t("Deduction Percentage")}
//                               </th>
//                               <th style={{ width: "15%", textAlign: "center" }}>
//                                 {t("Deduction Amount")}
//                               </th>
//                               <th style={{ width: "10%", textAlign: "center" }}>
//                                 {t("Action")}
//                               </th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {deductionList.length > 0 ? (
//                               deductionList.map((val, index) => (
//                                 <tr key={index}>
//                                   <td>{index + 1}</td>
//                                   <td>{val.DeductionName}</td>
//                                   <td>
//                                     {editIndexOF === index ? (
//                                       <input
//                                         type="number"
//                                         value={editIndex?.DeductionPercent || 0}
//                                         disabled
//                                         className="form-control"
//                                       />
//                                     ) : (
//                                       <>
//                                         {parseFloat(
//                                           val.DeductionPercent,
//                                         ).toFixed(2)}{" "}
//                                         %
//                                       </>
//                                     )}
//                                   </td>
//                                   <td>
//                                     {editIndexOF === index ? (
//                                       <input
//                                         type="number"
//                                         value={editIndex?.DeductionAmount || ""}
//                                         onChange={(e) => {
//                                           setEditIndex({
//                                             ...editIndex,
//                                             DeductionAmount: e.target.value,
//                                           });
//                                           if (e.target.value < 0) {
//                                             alert(
//                                               "Deduction Amount Should be greater than 0!",
//                                             );
//                                             setEditIndex({
//                                               ...editIndex,
//                                               DeductionAmount: "",
//                                             });
//                                           }
//                                         }}
//                                         className="form-control"
//                                       />
//                                     ) : (
//                                       parseFloat(val.DeductionAmount).toFixed(2)
//                                     )}
//                                   </td>
//                                   <td>
//                                     {editIndexOF === index ? (
//                                       <div
//                                         style={{
//                                           display: "flex",
//                                           gap: "8px",
//                                           flexWrap: "nowrap",
//                                           justifyContent: "center",
//                                         }}
//                                       >
//                                         <button
//                                           disabled={fileProcessing || loading}
//                                           className="btn btn-sm"
//                                           style={buttonStylePrimary}
//                                           onClick={(e) => handelchangeTablre(e)}
//                                         >
//                                           <img
//                                             src="/Submit-32.png"
//                                             alt="save"
//                                             style={{
//                                               width: "16px",
//                                               height: "16px",
//                                             }}
//                                           />
//                                           {t("Save")}
//                                         </button>
//                                         <button
//                                           className="btn btn-sm"
//                                           type="button"
//                                           style={buttonStyleDanger}
//                                           onClick={(e) => {
//                                             e.preventDefault();
//                                             setEditIndex(null);
//                                             setEditIndexOF(null);
//                                           }}
//                                         >
//                                           <img
//                                             src="/Close-32.png"
//                                             alt="cancel"
//                                             style={{
//                                               width: "16px",
//                                               height: "16px",
//                                             }}
//                                           />
//                                           {t("Cancel")}
//                                         </button>
//                                       </div>
//                                     ) : (
//                                       <div
//                                         style={{
//                                           display: "flex",
//                                           gap: "8px",
//                                           flexWrap: "nowrap",
//                                           justifyContent: "center",
//                                         }}
//                                       >
//                                         <button
//                                           className="btn btn-sm"
//                                           style={buttonStylePrimary}
//                                           onClick={(e) => handleEdit(e, index)}
//                                         >
//                                           <img
//                                             src="/Edit-32.png"
//                                             alt="edit"
//                                             style={{
//                                               width: "16px",
//                                               height: "16px",
//                                             }}
//                                           />
//                                           {t("Edit")}
//                                         </button>
//                                         <button
//                                           className="btn btn-sm"
//                                           style={buttonStyleDanger}
//                                           onClick={(e) =>
//                                             handleDeleteDeduction(
//                                               e,
//                                               val.DeductionID,
//                                             )
//                                           }
//                                         >
//                                           <img
//                                             src="/Delete-32.png"
//                                             alt="delete"
//                                             style={{
//                                               width: "16px",
//                                               height: "16px",
//                                             }}
//                                           />
//                                           {t("Delete")}
//                                         </button>
//                                       </div>
//                                     )}
//                                   </td>
//                                 </tr>
//                               ))
//                             ) : (
//                               <tr>
//                                 <td colSpan="5" className="text-center">
//                                   {t("No data found")}
//                                 </td>
//                               </tr>
//                             )}

//                             {deductionList.length > 0 && (
//                               <tr>
//                                 <td colSpan="2" className="text-center">
//                                   <b>{t("Total")}</b>
//                                 </td>
//                                 <td>
//                                   <b>
//                                     {parseFloat(totalDeductionPercent).toFixed(
//                                       2,
//                                     )}{" "}
//                                     %
//                                   </b>
//                                 </td>
//                                 <td>
//                                   <b>
//                                     {parseFloat(totalDeductionAmount).toFixed(
//                                       2,
//                                     )}
//                                   </b>
//                                 </td>
//                                 <td></td>
//                               </tr>
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )} */}

//               {/* ── Amount Summary ── */}
//               <div className="col-12 elements">
//                 <div className="col-12 my-5">
//                   <div className="row">
//                     <div className="col-4 part1 py-2">
//                       <div className="row">
//                         <div className="col-7 my-auto">
//                           <p className="my-auto">{t("Total Bill Amount")} : </p>
//                         </div>
//                         <div className="col-5 my-auto">
//                           <p className="my-auto">
//                             <b>{Number(data.TotalBillAmount || 0)}</b>
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="col-4 part1 py-2">
//                       <div className="row">
//                         <div className="col-8 my-auto">
//                           <p className="my-auto">
//                             {t("Total Deduction Amount")} :{" "}
//                           </p>
//                         </div>
//                         <div className="col-4 my-auto">
//                           <p className="my-auto">
//                             <b>{totalDeductionAmount.toFixed(2)}</b>
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="col-4 part1 py-2">
//                       <div className="row">
//                         <div className="col-7 my-auto">
//                           <p className="my-auto">
//                             {t("Net Payable Amount")} :{" "}
//                           </p>
//                         </div>
//                         <div className="col-5 my-auto">
//                           <p className="my-auto">
//                             <b>
//                               {(
//                                 parseFloat(data.TotalBillAmount || 0) -
//                                 Number(totalDeductionAmount || 0)
//                               ).toFixed(2)}
//                             </b>
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* ── Deductions — driven directly by fetched deduction data, not a static list ── */}
//               <div className="tableContainer m-auto">
//                 <table>
//                   <thead>
//                     <tr style={{ textAlign: "center" }}>
//                       <th style={{ width: "5%" }}>{t("Sr.No")}</th>
//                       <th style={{ width: "20%" }}>{t("Deduction Name")}</th>
//                       <th style={{ width: "20%" }}>{t("Deduction Amount")}</th>
//                       <th style={{ width: "20%" }}>{t("Bank Name")}</th>
//                       <th style={{ width: "20%" }}>{t("Account Number")}</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {fetchDeductionData.length > 0 ? (
//                       fetchDeductionData.map((val, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{val.UseFor}</td>
//                           <td>
//                             <input
//                               type="number"
//                               value={val.DeductionAmount}
//                               placeholder="0"
//                               min={0}
//                               onChange={(e) =>
//                                 handleDeductionAmountChange(e, index)
//                               }
//                               onBlur={(e) =>
//                                 handleDeductionAmountBlur(e, index)
//                               }
//                               onKeyDown={(e) => {
//                                 // Prevent minus, plus, decimal and exponent
//                                 if (["-", "+", "e", "E"].includes(e.key)) {
//                                   e.preventDefault();
//                                 }
//                               }}
//                               onFocus={(e) => {
//                                 if (e.target.value === "0") {
//                                   e.target.select();
//                                 }
//                               }}
//                             />
//                           </td>
//                           <td>{val.Bank_Name}</td>
//                           <td>{val.Account_Number}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center">
//                           {t("No data found")}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {/* ── Save / Cancel Buttons ── */}
//               <div className="col-12 ms-auto my-5">
//                 <div className="row">
//                   <div className="col-7 m-auto">
//                     <div className="col-12 text-center">
//                       <button
//                         className="px-4 py-2 btn btn-primary fw-bold"
//                         onClick={handleSubmit}
//                         disabled={loading || submitLockRef.current}
//                         style={{
//                           cursor: loading ? "not-allowed" : "pointer",
//                           background: loading
//                             ? "#9ca3af"
//                             : "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "8px",
//                           fontSize: "14px",
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: "6px",
//                           opacity: loading ? 0.7 : 1,
//                         }}
//                       >
//                         {loading ? (
//                           <>
//                             <span
//                               style={{
//                                 width: "14px",
//                                 height: "14px",
//                                 border: "2px solid white",
//                                 borderTop: "2px solid transparent",
//                                 borderRadius: "50%",
//                                 animation: "spin 0.8s linear infinite",
//                               }}
//                             />
//                             {t("Saving...")}
//                           </>
//                         ) : (
//                           <>
//                             <img
//                               src="/Submit-32.png"
//                               alt="submit"
//                               style={{ width: "13px" }}
//                             />
//                             {t("Save")}
//                           </>
//                         )}
//                       </button>

//                       <button
//                         className="px-4 py-2 btn btn-danger fw-bold mx-4"
//                         style={{
//                           cursor: "pointer",
//                           color: "white",
//                           border: "none",
//                           padding: "6px 10px",
//                           borderRadius: "8px",
//                           fontSize: "14px",
//                           display: "inline-flex",
//                           justifyContent: "center",
//                           alignItems: "center",
//                           gap: "4px",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         <img
//                           src="/Close-32.png"
//                           alt="cancel"
//                           style={{ width: "13px", height: "13px" }}
//                         />
//                         {t("Cancel")}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DemandGeneration;
